// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../img/fon-1-main.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../img/fon-1-main-mob.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../img/fon-1-banks.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../img/fon-1-banks-mob.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../img/fon-1-news.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../img/fon-1-news-mob.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../img/fon-1-nov.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../img/icon-checked.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../img/Info.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("../img/Info-2.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("../img/fon-1-pravo.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("../img/fon-1-lending.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("../img/fon-2-lending-1280.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("../img/fon-1-lending-1280.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("../img/Info-2green.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
}

body {
    position: relative;
    margin: 0;
    padding: 0;
    font-family: 'Geologica', sans-serif;
    background: #f5f5f5;
}

button {
    font-family: 'Geologica', sans-serif;
}

li {
    list-style-type: none;
}

a {
    color: #000;
    text-decoration: none;
    cursor: pointer;
}

/******** header ************/
.header {
    z-index: 1;
    width: 1920px;
    padding: 0px 0px 0px 0px;
    margin: 0px auto 0px auto;
    position: relative;
}

.header-contant {
    width: 100%;
    padding: 20px 50px 0px 50px;
    margin: 0px 0px 0px 0px;
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.header-contant-logo {
    flex: 0 0 90%;
    display: flex;
    justify-content: flex-start;
}

.header-contant-user {
    flex: 0 0 5%;
    display: flex;
    justify-content: flex-end;
}

.header-contant-menu {
    flex: 0 0 3%;
    display: flex;
    justify-content: flex-end;
}

.burger-1 {
    cursor: pointer;
}

.burger-2 {
    display: block;
    cursor: pointer;
    z-index: 1000;
    position: absolute;
    width: 18px;
    height: 18px;
    top: 15px;
    right: 15px;
    transition-duration: 0.5s;
}

.burger-2:hover {
    opacity: 0.3;
}

.mobile-container {
    display: block;
    z-index: 999;
    position: absolute;
    width: 260px;
    /*height: 597px;*/
    height: auto;
    right: 0px;
    top: 70px;
    background: rgba(79, 79, 79, 0.9);
    mix-blend-mode: normal;
    -webkit-backdrop-filter: blur(2px);
            backdrop-filter: blur(2px);
    border-radius: 20px 0px 0px 20px;
}

.mobile-container-vnutr {
    position: relative;
    padding: 50px 40px 20px 40px;
    height: auto;
}

.main-menu li {
    margin: 0px 0px 10px 0px;
}

.main-menu a {
    font-family: 'Geologica';
    font-style: normal;
    font-weight: 300;
    font-size: 16px;
    line-height: 120%;
    color: #FFFFFF;
    transition-duration: 0.5s;
}

.main-menu a:hover {
    opacity: 0.7;
}

.main-menu li.main-menu-up {
    margin: 0px 0px 30px 0px;
}

@media (max-width: 1920px) {
    .header {
        width: 100%;
    }
}

@media (max-width: 1366px) {
    .mobile-container {
        /*height: 500px;*/
    }
}

@media (max-width: 1280px) {
    .mobile-container {
        width: 260px;
    }

    .main-menu a {
        font-size: 14px;
        line-height: 140%;
    }
}


@media (max-width: 1080px) {
    .header-contant-logo img {
        height: 40px;
    }

    .mobile-container {
        /*height: 430px;*/
    }
}

@media (max-width: 1024px) {
    .header-contant {
        padding: 20px 20px 0px 20px;
    }

    .mobile-container {
        /*height: 410px;*/
    }
}

@media (max-width: 900px) {
    .header-contant-logo img {
        height: 36px;
    }
}

@media (max-width: 899px) {
    .header-contant-logo img {
        height: 34px;
    }
}

@media (max-width: 768px) {
    .header-contant-logo {
        flex: 0 0 85%;
    }

    .header-contant-logo img {
        height: 32px;
    }
}

@media (max-width: 600px) {
    .header-contant-logo {
        flex: 0 0 80%;
    }

    .header-contant-logo img {
        height: 30px;
    }
}

@media (max-width: 500px) {
    .header-contant-logo {
        flex: 0 0 75%;
    }

    .header-contant-logo img {
        height: 28px;
    }

    .mobile-container {
        /*height: 597px;*/
    }

    .user {
        opacity: 0.6;
    }

    .burger-1 {
        opacity: 0.6;
    }
}

@media (max-width: 390px) {
    .header-contant-logo {
        flex: 0 0 70%;
    }
}

/******** one-ekran ************/
.one-ekran {
    position: relative;
    width: 1920px;
    height: 878px;
    margin: -70px auto 0px auto;
    padding: 0px 0px 0px 0px;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-repeat: no-repeat;
    background-position: bottom center;
    background-size: cover;
    border-radius: 0px 0px 50px 50px;
}

.conteiner {
    width: 1344px;
    padding: 0px 0px 0px 0px;
    margin: 0px auto 0px auto;
}

.one-ekran-contant {
    width: 100%;
    padding: 200px 0px 0px 0px;
}

.h1 {
    font-family: 'Geologica';
    font-style: normal;
    font-weight: 600;
    font-size: 60px;
    line-height: 110%;
    text-align: center;
    color: #000000;
}

.one-ekran-contant-text {
    margin: 20px 0px 0px 0px;
    font-family: 'Geologica';
    font-style: normal;
    font-weight: 400;
    font-size: 24px;
    line-height: 30px;
    text-align: center;
    color: #000000;
}

.form-1 {
    margin: 100px auto 0px auto;
    width: 100%;
    height: 70px;
    height: auto;
    display: flex;
}

.form-1-col {
    position: relative;
    padding: 5px 20px 20px 20px;
    margin: 0px 5px 0px 0px;
    height: 100%;
    flex: 0 0 25%;
    background: #fff;
    display: flex;
    flex-direction: column;
    justify-content: center;
}

.form-1-col-1 {
    border-radius: 10px 0px 0px 10px;
}

.form-1-col-3 {
    padding-top: 11px;
    border-radius: 0px 10px 10px 0px;
}

.form-1 label {
    margin: 0px 0px 5px 0px;
    font-family: 'Geologica';
    font-style: normal;
    font-weight: 400;
    font-size: 11px;
    line-height: 14px;
    /*color: #828282;*/
    color: #000;
}

/* *******************
Select c dropdown на JS
******************* */

.dropdown {
    /*position: relative;*/
    width: 100%;
}

.dropdown__button {
    position: relative;
    display: block;
    width: 100%;
    text-align: left;

    background: #FFFFFF;
    border: 0px solid #7E9BBD;
    border-radius: 0px;
    height: 25px;

    padding-top: 0px;
    padding-bottom: 15px;
    padding-left: 0px;
    padding-right: 35px;
    /*padding-right: 35px;*/

    font-weight: 500;
    font-size: 16px;
    line-height: 20px;

    cursor: pointer;
    font-family: 'Geologica';
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 20px;
    /*color: #000000;*/
    color: #828282;
}

.dropdown__button:focus,
.dropdown__button--active {
    outline: none;
    box-shadow: 0px 0px 0px 0px rgba(176, 198, 225, 0.6);
}

.dropdown__button::after {
    content: "";
    position: absolute;
    top: 50%;
    right: 0px;
    /*right: 15px;*/
    transform: translateY(-50%);

    /* Рисуем треугольник */
    width: 0;
    height: 0;
    border-width: 10.4px 6px 0 6px;
    border-color: #828282 transparent transparent transparent;
    border-style: solid;

    /* Снимаем клик с треугольника */
    pointer-events: none;
}

.dropdown__list_prc {
    display: block;
    position: absolute;
    left: 0px;
    top: 70px;
    margin: 0;
    padding: 0;
    list-style-type: none;

    background: #ffffff00;
    box-shadow: 0px 4px 8px rgba(176, 198, 225, 0.6);
    overflow-x: hidden;
    overflow-y: scroll;
    border: 1px solid #5e5d5d;
    /*border: 1px solid #fff;*/
    border-radius: 0 0 10px 10px;
    width: 100%;
    max-height: 205px;
    z-index: 2;
}

.dropdown__list {
    display: block;
    position: absolute;
    left: 0px;
    top: 70px;
    margin: 0;
    padding: 0;
    list-style-type: none;

    background: #ffffff00;
    box-shadow: 0px 4px 8px rgba(176, 198, 225, 0.6);
    overflow: hidden;
    border: 1px solid #5e5d5d;
    /*border: 1px solid #fff;*/
    border-radius: 0 0 10px 10px;
    width: 100%;
    max-height: 205px;
    z-index: 2;
}

.dropdown__list:hover {
    border: 1px solid #5e5d5d;
}

.dropdown__list--visible {
    display: block;
}

.dropdown__list-item {
    position: relative;
    width: 100%;
    margin: 0;
    padding: 0;
    background: #fff;
    border-left: 0px solid #ccc;
    border-top: 0px solid #ccc;
    border-bottom: 0px;
    padding: 10px 20px 10px 20px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.dropdown__list-item span {
    font-size: 11px;
    font-weight: 400;
    line-height: 14px;
    letter-spacing: 0em;
    text-align: right;
}

.dropdown__list-item-text {
    margin: 3px 0px 0px 0px;
    font-size: 11px;
    font-weight: 400;
    line-height: 14px;
    letter-spacing: 0em;
    text-align: right;
}

.dropdown__list-item-text-2 {
    position: absolute;
    z-index: 2;
    right: 10px;
    top: 10px;
}

.dropdown__list-item-2 {
    padding: 10px 20px 10px 40px;
}

.dropdown__list-item:first-child {
    border-radius: 0px 0px 0 0;
}

.dropdown__list-item:last-child {
    border-radius: 0 0 10px 10px;
    border-bottom: 0px solid #828282;
}

.dropdown__list-item:hover {
    background: #FFEB39;
}

.dropdown__input-hidden {
    display: none;
}

.pole {
    font-family: 'Geologica';
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 20px;
    color: #000000;
    border: none;
    outline: none;
    width: 100%;

}

.pole::placeholder {
    /*color: #000000;*/
    color: #828282;
    opacity: 1;
}

.pole:-ms-input-placeholder {
    color: #000000;
}

.pole::-ms-input-placeholder {
    color: #000000;
}

.button {
    width: 25%;
    height: 70px;
    background: #FFEB39;
    border-radius: 10px;
    border: none;
    font-style: normal;
    font-weight: 400;
    font-size: 17px;
    line-height: 21px;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    color: #000000;
    cursor: pointer;
}

.button:hover {
    background: linear-gradient(0deg, rgba(255, 255, 255, 0.5), rgba(255, 255, 255, 0.5)), #FFEB39;
}

.button:active {
    border: 2px solid #000000;
    background: none;
}

.button:visited {
    background: none;
    border: 2px solid #828282;
    /*color: #828282;*/
    color: #000;
}

.bank-image {
    width: 18px;
    position: absolute;
    top: 30%;
    left: 15px;
    margin: 0px 0px 0px 0px;
}

@media (max-width: 1920px) {
    .one-ekran {
        width: 100%;
        height: 878px;
    }
}

@media (max-width: 1600px) {
    .one-ekran {
        height: 760px;
    }

    .conteiner {
        /*width: 1360px;*/
        width: 1120px;
    }
}

@media (max-width: 1366px) {
    .one-ekran {
        height: 650px;
    }

    .conteiner {
        /*width: 1200px;*/
        width: 1000px;
    }

    .one-ekran-contant {
        padding: 150px 0px 0px 0px;
    }

    .form-1 {
        margin: 70px auto 0px auto;
    }
}

@media (max-width: 1280px) {
    .one-ekran {
        height: 584px;
        background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
    }

    .conteiner {
        width: 954px;
    }

    .one-ekran-contant {
        padding: 120px 0px 0px 0px;
    }

    .form-1 {
        margin: 50px auto 0px auto;
    }
}

@media (max-width: 1180px) {
    .h1 {
        font-size: 56px;
    }

    .one-ekran-contant-text {
        font-size: 22px;
        line-height: 26px;
    }

    .form-1 {
        /*height: 60px;*/
    }

    .dropdown__list {
        /* top: 60px;*/
    }

    .button {
        /*height: 60px;*/
    }
}

@media (max-width: 1100px) {
    .conteiner {
        width: 100%;
        padding: 0px 20px 0px 20px;
    }
}

@media (max-width: 1080px) {
    .one-ekran {
        height: 550px;
    }

    .h1 {
        font-size: 52px;
    }

    .one-ekran-contant-text {
        font-size: 20px;
        line-height: 22px;
    }

    .form-1 {
        /*height: 58px;*/
    }

    .dropdown__list {
        /*top: 58px;*/
    }

    .button {
        /*height: 58px;*/
    }
}

@media (max-width: 1024px) {
    .one-ekran {
        height: 510px;
    }

    .conteiner {
        width: 100%;
        padding: 0px 20px 0px 20px;
    }

    .h1 {
        font-size: 44px;
    }

    .one-ekran-contant-text {
        font-size: 18px;
        line-height: 20px;
    }
}

@media (max-width: 900px) {
    .one-ekran {
        height: 500px;
    }

    .h1 {
        font-size: 40px;
    }

    .one-ekran-contant-text {
        font-size: 16px;
        line-height: 18px;
    }
}

@media (max-width: 899px) {
    .one-ekran {
        height: 550px;
    }

    .one-ekran-contant {
        padding: 100px 0px 0px 0px;
    }

    .h1 {
        font-size: 38px;
    }

    .form-1 {
        flex-direction: column;
        width: 400px;
        height: 70px;
        margin: 20px auto 0px auto;
    }

    .dropdown__list {
        top: 57px;
    }

    .form-1-col {
        width: 100%;
        margin: 0px 0px 5px 0px;
    }

    .form-1-col-1 {
        border-radius: 10px 10px 0px 0px;
    }

    .form-1-col-2 {}

    .form-1-col-3 {
        border-radius: 0px 0px 10px 10px;
    }

    .button {
        height: 70px;
        width: 100%;
        padding: 25px 0px 24px 0px;
    }
}

@media (max-width: 768px) {
    .h1 {
        font-size: 36px;
    }
}

@media (max-width: 500px) {
    .one-ekran {
        height: 400px;
        margin: 20px auto 250px auto;
        border-radius: 50px 50px 0px 0px;
    }

    .one-ekran-contant {
        padding: 70px 0px 0px 0px;
    }

    .h1 {
        font-size: 32px;
    }

    .one-ekran-contant-text {
        margin: 10px 0px 0px 0px;
    }

    .form-1 {
        width: 100%;
        height: auto;
        margin: 150px auto 0px auto;
        padding: 20px 20px 20px 20px;
        background: #fff;
        border-radius: 30px 30px 30px 30px;
    }

    .dropdown__button {
        background: #f5f5f5;
    }

    .form-1-col {
        width: 100%;
        height: 58px;
        background: #f5f5f5;
        margin: 0px 0px 5px 0px;
        padding: 12px 20px 20px 20px;
    }

    .pole::placeholder {
        background: #f5f5f5;
        font-weight: 500;
    }

    .pole:-ms-input-placeholder {
        background: #f5f5f5;
        font-weight: 500;
    }

    .pole::-ms-input-placeholder {
        background: #f5f5f5;
        font-weight: 500;
    }

    .pole {
        background: #f5f5f5;
    }

    .button {
        height: auto;
        padding: 25px 0px 25px 0px;
    }

}

/******** section-two ************/
.section-two {
    width: 1920px;
    padding: 120px 0px 100px 0px;
    margin: 0px auto 0px auto;
}

.section-two-contant {
    width: 100%;
    display: flex;
    justify-content: space-between;
}

.section-two-item {
    flex: 0 0 33.333%;
    margin: 0px 5px 0px 5px;
}

.section-two-item img {
    width: 100%;
    border-radius: 30px 30px 0px 0px;
}

.section-two-bloktext {
    position: relative;
    width: 100%;
    height: 190px;
    background: #fff;
    border-radius: 30px 30px 30px 30px;
    padding: 30px 30px 30px 30px;
    margin: -130px 0px 0px 0px;
}

.section-two-text-1 {
    margin: 0px 0px 20px 0px;
    font-size: 18px;
    font-weight: 600;
    line-height: 20px;
    letter-spacing: 0em;
    text-align: left;
}

.section-two-text-2 {
    font-size: 14px;
    font-weight: 300;
    line-height: 17px;
    letter-spacing: 0em;
    text-align: left;
    color: #828282;
}

.section-two-icon {
    position: absolute;
    width: 103px !important;
    right: 10px;
    top: -35px;
}

@media (max-width: 1920px) {
    .section-two {
        width: 100%;
    }
}

@media (max-width: 1366px) {
    .section-two {
        padding: 80px 0px 70px 0px;
    }

    .section-two-item {
        flex: 0 0 32%;
        margin: 0px 0px 0px 0px;
    }

    .section-two-item img {
        max-width: 100%;
    }
}

@media (max-width: 1024px) {
    .section-two {
        padding: 60px 0px 50px 0px;
    }

    .section-two-icon {
        width: 90px !important;
    }
}

@media (max-width: 940px) {
    .section-two-bloktext {
        height: 205px;
    }
}

@media (max-width: 900px) {
    .section-two-bloktext {
        height: 220px;
    }
}

@media (max-width: 899px) {
    .section-two {
        padding: 60px 0px 20px 0px;
    }

    .section-two-contant {
        flex-wrap: wrap;
        justify-content: center;
    }

    .section-two-item {
        flex: 0 0 47%;
        margin: 0px 10px 30px 10px;
    }

    .section-two-bloktext {
        height: 180px;
    }
}

@media (max-width: 710px) {
    .section-two-item {
        flex: 0 0 46%;
    }
}

@media (max-width: 700px) {
    .section-two-item {
        flex: 0 0 46%;
    }

    .section-two-bloktext {
        height: 190px;
    }
}

@media (max-width: 667px) {
    .section-two-bloktext {
        height: 200px;
    }
}

@media (max-width: 620px) {
    .section-two-bloktext {
        height: 220px;
    }
}

@media (max-width: 600px) {
    .section-two-item {
        flex: 0 0 350px;
        margin: 0px 0px 30px 0px;
    }

    .section-two-bloktext {
        height: 160px;
    }
}

@media (max-width: 500px) {
    .section-two {
        padding: 50px 0px 20px 0px;
    }

    .section-two-image {
        display: none;
    }

    .section-two-bloktext {
        margin: 0px 0px 0px 0px;
    }

    .section-two-bloktext-mob {
        margin: -130px 0px 0px 0px;
    }

    .section-two-icon {
        width: 100px !important;
    }
}

@media (max-width: 428px) {
    .section-two-item {
        flex: 0 0 100%;
        margin: 0px 0px 10px 0px;
    }
}

@media (max-width: 390px) {
    .section-two-bloktext {
        height: 180px;
    }
}

@media (max-width: 330px) {
    .section-two-bloktext {
        height: 190px;
    }
}

@media (max-width: 330px) {
    .section-two-bloktext {
        height: auto;
    }
}

/********** section-three ************/
.section-three {
    width: 1920px;
    padding: 0px 50px 100px 50px;
    margin: 0px auto 0px auto;

}

.section-three-contant {
    width: 100%;
    background: #FFf;
    padding: 60px 0px 60px 0px;
    border-radius: 60px;
}

.h2 {
    font-size: 36px;
    font-weight: 400;
    line-height: 43px;
    letter-spacing: 0em;
    text-align: center;
}

.h2-s3-2 {
    display: none;
}

.section-three-items {
    width: 100%;
    margin: 50px 0px 40px 0px;
    display: flex;
    justify-content: space-between;
}

.section-three-item {
    flex: 0 0 33.333%;
    margin: 0px 5px 0px 5px;
}

.section-three-item img {
    width: 100%;
    border-radius: 10px 10px 0px 0px;
}

.s3-icon {
    width: 24px !important;
    margin: 0px 0px 10px 0px;
}

.section-three-bloktext {
    height: 230px;
    position: relative;
    margin: -100px 0px 0px 0px;
    padding: 30px 30px 30px 30px;
    background: #f5f5f5;
    border-radius: 10px;
}

.button-1 {
    margin: 0px auto 0px auto;
}

.section-three-img-4 {
    display: none;
}

.s3-icon-4 {
    width: 94px !important;
    position: absolute;
    top: -30px;
    right: 20px;
}

@media (max-width: 1920px) {
    .section-three {
        width: 100%;
    }
}

@media (max-width: 1366px) {
    .section-three {
        padding: 0px 50px 80px 50px;
    }

    .section-three-item {
        flex: 0 0 32%;
        margin: 0px 0px 0px 0px;
    }

    .section-three-bloktext {
        height: 260px;
    }
}

@media (max-width: 1180px) {
    .section-three-contant {
        padding: 60px 20px 60px 20px;
        box-sizing: border-box;
    }

    .h2 {
        font-size: 32px;
        line-height: 36px;
    }
}

@media (max-width: 1100px) {
    .section-three {
        padding: 0px 20px 70px 20px;
    }

    .section-three-items {
        margin: 30px 0px 40px 0px;
    }

    .section-three-item {
        flex: 0 0 31%;
    }

}

@media (max-width: 1080px) {
    .section-three-bloktext {
        height: 280px;
    }

    .h2 {
        font-size: 30px;
        line-height: 32px;
    }
}

@media (max-width: 1024px) {
    .section-three {
        padding: 0px 20px 50px 20px;
    }

    .section-three-item {
        flex: 0 0 32%;
    }

    .section-three-bloktext {
        height: 300px;
        margin: -65px 0px 0px 0px;
    }

    .h2 {
        font-size: 28px;
        line-height: 30px;
    }
}

@media (max-width: 960px) {
    .section-three-bloktext {
        height: 300px;
    }

    .h2 {
        font-size: 26px;
        line-height: 28px;
    }
}

@media (max-width: 899px) {
    .section-three-items {
        flex-wrap: wrap;
        justify-content: center;
        margin: 30px 0px 30px 0px;
    }

    .section-three-item {
        flex: 0 0 46%;
        margin: 0px 10px 20px 10px;
    }

    .section-three-bloktext {
        height: 240px;
    }

    .h2 {
        font-size: 24px;
        line-height: 26px;
    }

    .button-1 {
        width: 350px;
    }
}

@media (max-width: 812px) {
    .section-three-bloktext {
        height: 260px;
    }
}

@media (max-width: 700px) {
    .section-three {
        padding: 0px 0px 50px 0px;
    }

    .section-three-bloktext {
        height: 280px;
    }
}

@media (max-width: 630px) {
    .section-three-bloktext {
        height: 300px;
    }
}

@media (max-width: 600px) {
    .section-three-item {
        flex: 0 0 350px;
        margin: 0px 0px 20px 0px;
    }

    .section-three-bloktext {
        height: 260px;
    }

    .s3-icon-4 {
        width: 110px !important;
        top: -35px;
        right: 10px;
    }
}

@media (max-width: 500px) {
    .h2 {
        font-size: 24px;
        line-height: 26px;
    }

    .section-three-image {
        display: none;
    }

    .section-three-bloktext {
        height: auto;
        margin: 0px 0px 0px 0px;
    }

    .section-three-bloktext-3 {
        margin: -20px 0px 0px 0px;
    }

    .section-three-items {
        margin: 30px 0px 30px 0px;
    }

    .section-three-item {
        margin: 0px 0px 10px 0px;
    }

    .section-three-img-3 {
        display: none;
    }

    .section-three-img-4 {
        display: block;
    }

}

@media (max-width: 428px) {
    .section-three-contant {
        padding: 60px 0px 60px 0px;
    }

    .h2 {
        text-align: left;
    }

    .h2-s3 {
        padding: 0px 20px 0px 20px;
    }

    .h2-s3-1 {
        display: none;
    }

    .h2-s3-2 {
        display: block;
    }

    .section-three-item {
        flex: 0 0 100%;
        margin: 0px 0px 15px 0px;
    }

    .button-1 {
        width: 100%;
    }
}

@media (max-width: 389px) {
    .h2 {
        font-size: 22px;
        line-height: 24px;
    }

    .s3-icon-4 {
        width: 90px !important;
    }
}

@media (max-width: 360px) {
    .h2 {
        font-size: 20px;
        line-height: 22px;
    }
}

@media (max-width: 320px) {
    .h2 {
        font-size: 18px;
        line-height: 20px;
    }
}

/********************/
.section-foor {
    width: 1920px;
    padding: 0px 0px 100px 0px;
    margin: 0px auto 0px auto;
}

.conteiner {}

.section-foor-contant {
    position: relative;
}

.section-foor-image {
    max-width: 100%;
    border-radius: 30px;
}

.h2-s4 {
    position: absolute;
    right: 0;
    top: 0;
}

.section-foor-item {
    width: 60%;
    position: absolute;
    right: 0;
    top: 40%;
    display: flex;
}

.section-foor-bloktext {
    position: relative;
    flex: 0 0 50%;
    background: #FFf;
    border-radius: 20px;
    margin: 0px 0px 0px 20px;
    padding: 30px 30px 30px 30px;
}

.section-foor-icon {
    position: absolute;
    right: -10px;
    top: -60px;
}

@media (max-width: 1920px) {
    .section-foor {
        width: 100%;
    }
}

@media (max-width: 1366px) {
    .section-foor {
        padding: 0px 0px 70px 0px;
    }

    .section-foor-item {
        width: 70%;
    }
}

@media (max-width: 1100px) {
    .section-foor-item {
        width: 70%;
        right: 40px;
        top: 31%;
    }

    .section-foor-image {
        width: 500px;
    }
}

@media (max-width: 1024px) {
    .section-foor {
        padding: 0px 0px 50px 0px;
    }
}


@media (max-width: 960px) {
    .section-foor-item {
        width: 80%;
    }
}

@media (max-width: 900px) {
    .section-foor-item {
        width: 85%;
    }
}

@media (max-width: 800px) {
    .section-foor-item {
        width: 90%;
    }
}

@media (max-width: 768px) {
    .section-foor-item {
        width: 95%;
    }

    .section-foor-icon {
        width: 109px;
        right: 0px;
        top: -45px;
    }
}

@media (max-width: 700px) {
    .section-foor-item {
        width: 95%;
        right: 20px;
    }

    .section-foor-icon {
        display: none;
    }

    .section-foor-bloktext {
        margin: 0px 0px 0px 10px;
        padding: 20px 20px 20px 20px;
    }
}

@media (max-width: 667px) {
    .section-foor-item {
        flex-direction: column;
        width: 315px;
        right: 0px;
        top: 12%;
    }

    .section-foor-bloktext {
        margin: 0px 0px 10px 10px;
        padding: 20px 20px 20px 20px;
    }
}

@media (max-width: 630px) {
    .h2-s4 {
        display: none;
    }

    .section-foor-image {
        width: 400px;
    }

    .section-foor-item {
        top: 3.5%;
    }
}

@media (max-width: 600px) {
    .section-foor-image {
        width: 100%;
    }

    .section-foor-item {
        top: 16%;
        right: 10px;
    }
}

@media (max-width: 500px) {
    .section-foor {
        overflow: hidden;
    }

    .section-foor-item {
        margin: -180px 0px 0px 0px;
        position: relative;
        flex-direction: row;
        width: 100%;
        left: 10px;
        right: 0px;
        top: 48%;
    }

    .section-foor-bloktext {
        flex: 0 0 55%;
    }
}

@media (max-width: 428px) {
    .section-foor-bloktext {
        flex: 0 0 70%;
    }
}

@media (max-width: 414px) {
    .section-foor-bloktext {
        flex: 0 0 73%;
    }
}

@media (max-width: 390px) {
    .section-foor-bloktext {
        flex: 0 0 76%;
    }
}

@media (max-width: 389px) {
    .section-foor-bloktext {
        flex: 0 0 76%;
    }

    .section-foor-item {
        margin: 0px 0px 0px 0px;
        position: absolute;
        flex-direction: column;
        width: 92%;
        left: 10px;
        right: 10px;
        top: 9%;
    }

    .section-foor-image {
        height: 320px;
        object-fit: cover;
    }
}

@media (max-width: 340px) {
    .section-foor-item {
        top: 12%;
    }

    .section-foor-image {
        height: 350px;
    }
}

@media (max-width: 320px) {
    .section-foor-item {
        top: 9%;
    }

    .section-foor-image {
        height: 360px;
    }
}


/********  vopros  ***************************/
.prodat-section-4 {
    width: 1920px;
    padding: 0px 0px 0px 0px;
    margin: 0px auto 40px auto;
}

.prodat-section-4 {
    text-align: center;
    display: flex;
}

.vopros-col-1 {
    flex: 0 0 70%;
    padding: 0px 0px 0px 15%;
}

.vopros-col-2 {
    flex: 0 0 30%;
    text-align: right;
    display: flex;
    justify-content: flex-end;
    align-items: flex-end;
    padding: 90px 0px 70px 0px;
}

.vopros-col-2 img {
    max-width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 20px 0px 0px 20px;
}

.prodat-section-4-contant {
    width: 100%;
    padding: 0px 0px 30px 0px;
}

.vopros {
    width: 100%;
    margin: 0px 0px 0px 0px;
    padding: 0px 0px 0px 0px;
}

.h2-vopros {
    text-align: left;
}

.vopros-contant {
    width: 100%;
    margin: 0px 0px 0px 0px;
    padding: 100px 0px 0px 0px;
    text-align: center;
}

.vopros-spoiler {
    width: 100%;
    margin: 0px auto 0px auto;
    padding: 20px 20px 20px 0px;
}

.vopros-spoiler-vopros-wrapper {
    text-align: left;
}

.vopros-spoiler-vopros {
    position: relative;
    font-size: 20px;
    font-weight: 600;
    margin: 30px 0px 0px 0px;
    padding: 20px 40px 20px 0px;
    cursor: pointer;
    border-top: 1px solid #bbb;
}

.vopros-spoiler-vopros:hover {
    color: #000;
}

.vopros-spoiler-otvet {
    font-size: 16px;
    font-weight: 400;
    line-height: 1.3;
    margin: 0px 0px 30px 0px;
    padding: 0px 30px 20px 0px;
    color: #828282;
}

.vopros-spoiler-vopros-1 {
    color: #000;
}

.vopros-spoiler-otvet-1 {
    display: none;
}

.vopros-spoiler-otvet-2 {
    display: none;
}

.vopros-spoiler-otvet-3 {
    display: none;
}

.vopros-spoiler-otvet-4 {
    display: none;
}

.vopros-spoiler-otvet-5 {
    display: none;
}

.vopros-spoiler-otvet-6 {
    display: none;
}

.block {
    display: block;
}

.none {
    display: none;
}

.button-vopros {
    margin: 0px 0px 0px 0px;
}

.icon-down-arrow {
    position: absolute;
    right: 0;
    top: 25px;
}

.rotate-1 .vopros-spoiler-otvet-1 {
    display: block;
}

.rotate-1 .icon-down-arrow-1 {
    transform: rotate(-180deg);
    transition: .3s;
}

.rotate-2 .icon-down-arrow-2 {
    transform: rotate(-180deg);
    transition: .3s;
}

.rotate-3 .icon-down-arrow-3 {
    transform: rotate(-180deg);
    transition: .3s;
}

.rotate-4 .icon-down-arrow-4 {
    transform: rotate(-180deg);
    transition: .3s;
}

.rotate-5 .icon-down-arrow-5 {
    transform: rotate(-180deg);
    transition: .3s;
}

.rotate-6 .icon-down-arrow-6 {
    transform: rotate(-180deg);
    transition: .3s;
}

#controls span {
    display: inline-block;
}

.video-blok {
    display: none;
    justify-content: center;
}

@media (max-width: 1920px) {
    .prodat-section-4 {
        width: 100%;
    }
}

@media (max-width: 1600px) {
    .vopros-col-2 {
        padding: 90px 0px 60px 0px;
    }
}

@media (max-width: 1536px) {
    .vopros-col-1 {
        padding: 0px 0px 0px 14%;
    }

    .vopros-col-2 img {
        max-width: 100%;
    }
}

@media (max-width: 1440px) {
    .vopros-col-1 {
        padding: 0px 0px 0px 12%;
    }
}

@media (max-width: 1366px) {
    .prodat-section-4 {
        padding: 0px 0px 0px 0px;
    }

    .vopros-col-1 {
        padding: 0px 0px 0px 14%;
    }

    .vopros-col-2 {
        padding: 70px 0px 40px 10px;
    }

    .vopros-spoiler {
        margin: 20px auto 0px auto;
        padding: 0px 0px 0px 0px;
    }

    .vopros-spoiler-vopros {
        font-size: 19px;
    }

    .vopros-spoiler-otvet {
        font-size: 15px;
        line-height: 1.4;
    }
}

@media (max-width: 1280px) {
    .vopros-col-1 {
        flex: 0 0 60%;
        width: 60%;
        padding: 0px 0px 0px 13%;
    }

    .vopros-col-2 {
        flex: 0 0 40%;
        width: 40%;
        padding: 70px 0px 40px 20px;
    }
}

@media (max-width: 1180px) {
    .vopros-col-1 {
        padding: 0px 0px 0px 10%;
    }

}

@media (max-width: 1100px) {
    .vopros-col-1 {
        flex: 0 0 55%;
        width: 55%;
        padding: 0px 0px 0px 20px;
    }

    .vopros-col-2 {
        flex: 0 0 45%;
        width: 45%;
        padding: 60px 0px 40px 20px;
    }

}

@media (max-width: 1024px) {
    .vopros-spoiler {
        margin: 30px auto 0px auto;
    }

    .vopros-spoiler-vopros {
        font-size: 18px;
        margin: 0px 0px 20px 0px
    }

    .vopros-spoiler-otvet {
        font-size: 14px;
        line-height: 1.4;
    }
}

@media (max-width: 900px) {
    .vopros-spoiler-vopros {
        font-size: 16px;
        margin: 0px 0px 0px 0px;
    }

    .vopros-spoiler-otvet {
        font-size: 14px;
        line-height: 1.4;
        padding: 0px 30px 0px 0px;
    }
}

@media (max-width: 899px) {
    .vopros-col-1 {
        flex: 0 0 100%;
        padding: 0px 20px 0px 20px;
    }

    .vopros-col-2 {
        display: none;
    }

    .vopros-col-2 img {
        display: none;
    }

    .video-blok {
        margin: 0px 0px 60px 0px;
        display: flex;
        justify-content: center;
    }

    .video-player {
        width: 500px;
        border-radius: 20px;

    }

    .video-button {
        padding: 6% 0px 0px 0px;
        margin-top: 0px;
        position: absolute;
        width: 100%;
        height: 246px;
        opacity: 1;
        background: #ffeb3900;
        border: none;
    }
}

@media (max-width: 568px) {
    .video-blok {
        padding: 0px 20px 0px 20px;
    }

    .video-player {
        width: 100%;
    }
}

@media (max-width: 500px) {
    .prodat-section-4 {
        padding: 20px 0px 0px 0px;
    }

    .vopros-spoiler-vopros {
        margin: 0px 0px 30px 0px;
        padding: 20px 35px 0px 0px;
    }

    .vopros-spoiler-otvet {
        padding: 0px 30px 0px 0px;
    }

    .dropdown__button-popup {
        background: #fff;
    }
}

@media (max-width: 460px) {
    .h2-vopros {
        text-align: center;
    }
}

@media (max-width: 460px) {
    .prodat-section-4-contant {
        padding: 0px 0px 0px 0px;
    }
}

@media (max-width: 428px) {
    .video-button {
        padding: 0% 0px 0px 0px;
    }
}

@media (max-width: 414px) {
    .video-button img {
        margin: -25px 0px 0px 0px;
    }
}

@media (max-width: 390px) {
    .video-button img {
        margin: -35px 0px 0px 0px;
    }
}

@media (max-width: 375px) {
    .prodat-section-4 {
        padding: 0px 0px 0px 0px;
    }

    .vopros-spoiler-vopros {
        padding: 0px 20px 0px 0px;
    }

    .video-button img {
        margin: -50px 0px 0px 0px;
    }
}

@media (max-width: 360px) {
    .video-button img {
        margin: -60px 0px 0px 0px;
    }
}

@media (max-width: 320px) {
    .video-button {
        padding: 0% 0px 40px 0px;
    }

    .video-button img {
        margin: -80px 0px 0px 0px;
        width: 60px;
        height: 60px;
    }
}

/************ section-six **************/
.section-six {
    overflow: hidden;
    width: 1920px;
    padding: 0px 0px 120px 0px;
    margin: 0px auto 0px auto;
}

.section-six-contant {
    width: 100%;
}

.h2-news {
    margin: 0px 0px 40px 0px;
}

.section-six-link:hover {
    text-decoration: underline;
}

.section-six-text-2 {
    margin: 20px 0px 0px 0px;
}

.swiper {
    width: 100%;
}

.section-six-bloktext {
    margin: -40px 0px 0px 0px;
}

@media (max-width: 1920px) {
    .section-six {
        width: 100%;
    }

    .section-six-contant {
        width: 135%;
    }
}

@media (max-width: 1100px) {
    .section-six-contant {
        width: 110%;
    }

}

@media (max-width: 1024px) {
    .section-six {
        padding: 0px 0px 80px 0px;
    }

    .h2-news {
        margin: 0px 0px 20px 0px;
    }
}

@media (max-width: 899px) {
    .section-six-item {
        margin: 0px 0px 0px 0px;
    }

    .section-six-bloktext {
        height: 220px;
    }
}

@media (max-width: 700px) {
    .section-six-bloktext {
        height: 200px;
    }
}

@media (max-width: 667px) {
    .section-six-bloktext {
        height: 200px;
    }
}

@media (max-width: 390px) {
    .section-six {
        padding: 0px 0px 60px 0px;
    }
}


@media (max-width: 320px) {
    .section-six-bloktext {
        height: 230px;
    }
}

/********** footer **************/
.footer {
    width: 1920px;
    padding: 80px 0px 80px 0px;
    margin: 0px auto 0px auto;
    border-radius: 60px 60px 0px 0px;
    background: #4f4f4f;
}

.footer a:hover {
    opacity: 0.7;
}

.footer-contant {
    width: 100%;
}

.footer-contant-up {
    padding: 0px 0px 30px 0px;
    width: 100%;
    display: flex;
    border-bottom: 1px solid #ccc;
}

.footer-contant-up-col-1 {
    flex: 0 0 60%;
}

.h2-footer {
    text-align: left;
    color: #FFf;
}

.footer-contacts-row {
    margin: 20px 0px 20px 0px;
    width: 30%;
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.footer-phone-link {
    font-size: 16px;
    font-weight: 300;
    line-height: 20px;
    letter-spacing: 0em;
    text-align: left;
    color: #fff;
}

.footer-phone-text {
    font-size: 16px;
    font-weight: 300;
    line-height: 20px;
    letter-spacing: 0em;
    text-align: left;
    color: #828282;
    margin: 0 !important;
}

.footer-contant-up-col-2 {
    flex: 0 0 40%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
}

.footer-button-text {
    font-size: 16px;
    font-weight: 300;
    line-height: 20px;
    letter-spacing: 0em;
    text-align: left;
    color: #fff;
}

.button-footer {
    margin: 30px 0px 0px 0px;
    width: 393px;
    height: 57px;
}

.footer-contant-down {
    width: 100%;
    padding: 40px 0px 0px 0px;
    display: flex;
}

.footer-contant-down-col-1 {
    flex: 0 0 60%;
}

.footer-logo-text {
    margin: 10px 0px 0px 0px;
    font-size: 14px;
    font-weight: 300;
    line-height: 17px;
    letter-spacing: 0em;
    text-align: left;
    color: #ccc;
}

.footer-blok-link {
    margin: 50px 0px 0px 0px;
    display: flex;
}

.footer-blok-link-left {
    flex: 0 0 25%;
    display: flex;
    flex-direction: column;
}

.footer-link-text {
    margin: 0px 0px 20px 0px;
}

.footer-link {
    margin: 0px 0px 10px 0px;
}

.footer-blok-link-right {
    flex: 0 0 25%;
    display: flex;
    flex-direction: column;
}

.footer-contant-down-col-2 {
    flex: 0 0 40%;
    display: flex;
    flex-direction: column;
}

.footer-link-right {
    text-decoration: underline;
}

.footer-description {
    margin: 30px 0px 60px 0px;
    font-size: 9px;
    font-weight: 300;
    line-height: 11px;
    letter-spacing: 0.01em;
    text-align: left;
    color: #ccc;
}

@media (max-width: 1920px) {
    .footer {
        width: 100%;
    }
}

@media (max-width: 1600px) {
    .footer-contacts-row {
        width: 40%;
    }

    .footer-blok-link-left,
    .footer-blok-link-right {
        flex: 0 0 30%;
    }
}

@media (max-width: 1280px) {

    .footer-blok-link-left,
    .footer-blok-link-right {
        flex: 0 0 40%;
    }
}

@media (max-width: 1100px) {
    .footer {
        padding: 50px 20px 50px 20px;
    }

    .button-footer {
        width: 100%;
    }

    .footer-contant-down-col-2 img {
        max-width: 100%;
    }
}

@media (max-width: 960px) {
    .footer-contacts-row {
        width: 50%;
    }

}

@media (max-width: 768px) {
    .footer-contant-up-col-1 {
        flex: 0 0 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    .footer-contant-up-col-2 {
        display: none;
    }

    .h2-footer {
        margin: 0px 0px 0px 0px;
    }

    .footer-contacts-row {
        width: 100%;
        margin: 10px 0px 0px 0px;
    }

    .button-footer {
        width: 350px;
    }

    .footer-contant-down {
        flex-direction: column;
    }

    .footer-contant-down-col-2 {
        padding: 30px 0px 0px 0px;
    }

    .footer-blok-link-left,
    .footer-blok-link-right {
        flex: 0 0 50%;
    }

    .footer-phone-link-1 {
        display: none;
    }

    .footer-phone-text {
        display: none;
    }

    .footer-button-text-1 {
        display: none;
    }

}

@media (max-width: 500px) {
    .footer {
        padding: 50px 0px 50px 0px;
    }

    .button-footer {
        width: 100%;
    }
}

@media (max-width: 389px) {
    .footer-blok-link {
        flex-direction: column;
    }

    .footer-blok-link-right {
        padding: 40px 0px 0px 0px;
    }
}

/******************************************
*************** POPUPS *********************
*********************************************/

/***** popup-1 *******/
.b-popup {
    position: relative;
    display: block;
    width: 100%;
    min-height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    overflow: hidden;
    position: fixed;
    top: 0px;
    z-index: 1006;
    height: 95vh !important;
    overflow-y: scroll !important;
}

.b-popup-vnutr {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
}

.b-popup .b-popup-content {
    position: relative;
    margin: 20px auto 20px auto;
    width: 390px;
    height: auto;
    padding: 20px;
    background: #4F4F4FE5;
    border: 0px solid #92B96A;
    border-radius: 30px;
    box-shadow: 0px 0px 10px #000;
    z-index: 1007;


    /*text-align: center;*/
}

.popup-title {
    margin-bottom: 20px;
    color: #FFf;
    font-size: 18px;
    font-weight: 300;
    line-height: 20px;
    letter-spacing: 0em;
    text-align: left;
}

.popup-text {
    font-size: 15px;
    font-weight: 400;
    margin-bottom: 20px;
}

.form-popup {
    width: 100%;
    display: flex;
    flex-direction: column;
}

.form-popup label {
    margin: 0px 0px 5px 0px;
    font-family: 'Geologica';
    font-style: normal;
    font-weight: 400;
    font-size: 11px;
    line-height: 14px;
    color: #828282;
}

.one-ryad-popup {
    position: relative;
    width: 100%;
    display: flex;
    flex-direction: column;
    background: #fff;
    padding: 20px 0px 0px 20px;
}

.one-ryad-popup-1 {
    border-radius: 10px 10px 0 0;
    margin: 0px 0px 2px 0px;
}

.one-ryad-popup-2 {
    margin: 0px 0px 2px 0px;
}

.one-ryad-popup-3 {
    border-radius: 0px 0px 10px 10px;
    margin: 0px 0px 20px 0px;
    padding: 20px 20px 20px 20px;
}

.one-ryad-popup-4 {
    border-radius: 10px 10px 0 0;
    margin: 0px 0px 2px 0px;
}

.one-ryad-popup-5 {
    margin: 0px 0px 2px 0px;
}

.one-ryad-popup-6 {
    border-radius: 0px 0px 10px 10px;
    margin: 0px 0px 20px 0px;
}

.pole-popup {
    width: 100%;
    padding: 0px 10px 0px 0px;
    margin: 0px 0px 20px 0px;
    text-align: left;
    border: 0px solid #92B96A;
    border-radius: 0px;
    font-family: 'Geologica';
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 20px;
    color: #000000;
    outline: none;
}

.button-popup-1 {
    width: 100%;
    cursor: pointer;
    margin: 0px 0px 0px 0px;
}

.popup-close {
    position: absolute;
    top: 20px;
    right: 20px;
    width: 20px;
}

.popup-close img {
    max-width: 100%;
}

.popup-close:hover {
    opacity: 0.7;
}

@media (max-width: 1023px) {
    .b-popup .b-popup-content {
        margin: 10px auto 0px auto;
    }
}

@media (max-width: 500px) {
    .b-popup {
        padding: 0px 20px 0px 20px;
    }

    .b-popup .b-popup-content {
        width: 100%;
    }

    .popup-title {
        font-size: 18px;
    }

}

@media (max-width: 428px) {
    .one-ryad-popup {
        padding: 5px 0px 0px 20px;
    }

    .one-ryad-popup-3 {
        padding: 5px 10px 14px 20px;
    }

    .dropdown__button-popup {
        background: #fff;
    }

    .form-popup label {
        margin: 5px 0px 5px 0px;
    }
}

@media (max-width: 320px) {
    .one-ryad-popup {
        padding-left: 10px;
    }

    .popup-title {
        font-size: 16px;
    }
}

/***** popup-2 *******/
.b-popup {
    position: relative;
    display: block;
    width: 100%;
    min-height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    overflow: hidden;
    position: fixed;
    top: 0px;
    z-index: 1006;
    height: 95vh !important;
    overflow-y: scroll !important;
}

.b-popup-vnutr {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
}

.b-popup .b-popup-content-2 {
    position: relative;
    margin: 20px auto 20px auto;
    width: 390px;
    height: auto;
    padding: 20px;
    background: #fff;
    border: 0px solid #92B96A;
    border-radius: 30px;
    box-shadow: 0px 0px 10px #000;
    z-index: 1007;


    /*text-align: center;*/
}

.popup-title-2 {
    margin-bottom: 20px;
    color: #000;
    font-size: 18px;
    font-weight: 300;
    line-height: 20px;
    letter-spacing: 0em;
    text-align: left;
}

.popup-text {
    font-size: 15px;
    font-weight: 400;
    margin-bottom: 20px;
}

.form-popup {
    width: 100%;
    display: flex;
    flex-direction: column;
}

.form-popup label {
    margin: 0px 0px 5px 0px;
    font-family: 'Geologica';
    font-style: normal;
    font-weight: 400;
    font-size: 11px;
    line-height: 14px;
    color: #828282;
}

.one-ryad-popup-user {
    position: relative;
    width: 100%;
    display: flex;
    flex-direction: column;
    background: #f5f5f5;
    padding: 20px 0px 0px 20px;
}

.one-ryad-popup-user-1 {
    border-radius: 10px 10px 0 0;
    margin: 0px 0px 3px 0px;
}

.one-ryad-popup-user-2 {
    margin: 0px 0px 13px 0px;
    border-radius: 0px 0px 10px 10px;
}

.popup2-link {
    display: inline-block;
    width: auto;
    margin: 10px 0px 0px 0px;
    font-size: 11px;
    font-weight: 400;
    line-height: 14px;
    letter-spacing: 0em;
    text-align: left;
    color: #828282;
    text-align: center;
    text-decoration: underline;
}

.popup2-link:hover {
    color: #000;
}

.pole-popup-user {
    width: 100%;
    padding: 0px 10px 0px 0px;
    margin: 0px 0px 20px 0px;
    text-align: left;
    border: 0px solid #92B96A;
    border-radius: 0px;
    font-family: 'Geologica';
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 20px;
    color: #000000;
    background: #f5f5f5;
    outline: none;
}

@media (max-width: 1023px) {
    .b-popup .b-popup-content {
        margin: 10px auto 0px auto;
    }
}

@media (max-width: 500px) {
    .b-popup {
        padding: 0px 20px 0px 20px;
    }

    .b-popup .b-popup-content {
        width: 100%;
    }

    .popup-title {
        font-size: 18px;
    }

}

@media (max-width: 428px) {
    .one-ryad-popup {
        padding: 5px 0px 0px 20px;
    }

    .one-ryad-popup-3 {
        padding: 5px 10px 14px 20px;
    }

    .dropdown__button-popup {
        background: #fff;
    }

    .form-popup label {
        margin: 5px 0px 5px 0px;
    }
}

@media (max-width: 320px) {
    .one-ryad-popup {
        padding-left: 10px;
    }

    .popup-title {
        font-size: 16px;
    }
}

/***** popup-3 *******/
.popup-text {
    font-size: 11px;
    font-weight: 400;
    line-height: 14px;
    letter-spacing: 0em;
    text-align: left;
    color: #828282;
    margin-bottom: 20px;
}

.form-popup {
    width: 100%;
    display: flex;
    flex-direction: column;
}

.form-popup label {
    margin: 0px 0px 5px 0px;
    font-family: 'Geologica';
    font-style: normal;
    font-weight: 400;
    font-size: 11px;
    line-height: 14px;
    color: #828282;
}

.dropdown__button-popup-user {
    background: #f5f5f5;
}

.one-ryad-popup-user {
    position: relative;
    width: 100%;
    display: flex;
    flex-direction: column;
    background: #f5f5f5;
    padding: 20px 20px 0px 20px;
}

.one-ryad-popup-user-1 {
    border-radius: 10px 10px 0 0;
    margin: 0px 0px 3px 0px;
}

.one-ryad-popup-user-2 {
    margin: 0px 0px 13px 0px;
    border-radius: 0px 0px 10px 10px;
}

.one-ryad-popup-user-3 {
    margin: 0px 0px 3px 0px;
    border-radius: 10px 10px 0px 0px;
}

.one-ryad-popup-user-4 {
    margin: 0px 0px 3px 0px;
    border-radius: 0px 0px 0px 0px;
}

.one-ryad-popup-user-5 {
    height: 79px;
    margin: 0px 0px 20px 0px;
    border-radius: 0px 0px 10px 10px;
}

.one-ryad-popup-user-6 {
    margin: 0px 0px 3px 0px;
    border-radius: 10px 10px 0px 0px;
}

.one-ryad-popup-user-7 {
    margin: 0px 0px 3px 0px;
    border-radius: 0px 0px 0px 0px;
}

.one-ryad-popup-user-8 {
    margin: 0px 0px 20px 0px;
    border-radius: 0px 0px 10px 10px;
}

@media (max-width: 1023px) {
    .b-popup .b-popup-content {
        margin: 10px auto 0px auto;
    }
}

@media (max-width: 500px) {
    .b-popup {
        padding: 0px 20px 0px 20px;
    }

    .b-popup .b-popup-content {
        width: 100%;
    }

    .popup-title {
        font-size: 18px;
    }

}

@media (max-width: 428px) {
    .one-ryad-popup {
        padding: 5px 0px 0px 20px;
    }

    .one-ryad-popup-3 {
        padding: 5px 10px 14px 20px;
    }

    .dropdown__button-popup-user {
        background: #f5f5f5;
    }

    .form-popup label {
        margin: 5px 0px 5px 0px;
    }
}

@media (max-width: 320px) {
    .one-ryad-popup {
        padding-left: 10px;
    }

    .popup-title {
        font-size: 16px;
    }
}

/**********************
******** PAGE BANKS **********
**********************/

/******** one-ekran ************/
.one-ekran-banks {
    height: 705px;
    padding: 0px 0px 0px 0px;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}

.one-ekran-banks-text {
    margin: 20px auto 0px auto;
    width: 760px;
    text-align: center;
}

@media (max-width: 1600px) {
    .one-ekran-banks {
        height: 650px;
    }
}

@media (max-width: 1440px) {
    .one-ekran-banks {
        height: 620px;
    }

    .one-ekran-contant-banks {
        padding: 160px 0px 0px 0px;
    }
}

@media (max-width: 1366px) {
    .one-ekran-banks {
        height: 570px;
    }

    .one-ekran-contant-banks {
        padding: 160px 0px 0px 0px;
    }
}

@media (max-width: 1280px) {
    .one-ekran-banks {
        height: 470px;
        background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
    }

    .one-ekran-contant-banks {
        padding: 120px 0px 0px 0px;
    }
}

@media (max-width: 1080px) {
    .one-ekran-banks {
        height: 400px;
    }

    .one-ekran-contant-banks {
        padding: 100px 0px 0px 0px;
    }
}

@media (max-width: 900px) {
    .one-ekran-banks {
        height: 385px;
    }

    .one-ekran-contant-banks {
        padding: 130px 0px 0px 0px;
    }

    .one-ekran-banks-text {
        width: 700px;
    }
}

@media (max-width: 800px) {
    .one-ekran-contant-banks {
        padding: 120px 0px 0px 0px;
    }

    .one-ekran-banks-text {
        width: 600px;
    }
}

@media (max-width: 700px) {
    .one-ekran-banks-text {
        width: 100%;
    }
}

@media (max-width: 600px) {
    .one-ekran-contant-banks {
        padding: 150px 0px 0px 0px;
    }

    .one-ekran-banks-text {
        font-weight: 600;
    }
}

@media (max-width: 500px) {
    .one-ekran-banks {
        border-radius: 50px 50px 50px 50px;
        margin: 20px auto 0px auto;
    }

    .one-ekran-contant-banks {
        padding: 50px 0px 0px 0px;
    }
}

/*********** section-two-banks ***************/
.section-two-banks {
    padding: 100px 0px 70px 0px;
}

.h2-banks {
    margin: 0px 0px 40px 0px;
}

.section-two-contant-banks {
    width: 100%;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
}

.section-two-item-banks {
    flex: 0 0 32%;
    padding: 70px 40px 60px 40px;
    margin: 0px 0px 30px 0px;
    border-radius: 30px;
    background: #fff;
    text-align: center;

}

.section-two-banks-text-1 {
    margin: 20px 0px 30px 0px;
    font-size: 24px;
    font-weight: 400;
    line-height: 29px;
    letter-spacing: 0em;
    text-align: center;
}

.section-two-banks-bloktext {
    text-align: left;
    margin: 0px 0px 20px 0px;
    padding: 20px 20px 20px 20px;
    background: #f5f5f5;
}

.section-two-banks-text-2 {
    margin: 0px 0px 5px 0px;
    font-family: 'Geologica';
    font-style: normal;
    font-weight: 400;
    font-size: 11px;
    line-height: 14px;
    /*color: #828282;*/
    color: #000;
}

.section-two-banks-text-3 {
    font-size: 16px;
    font-weight: 400;
    line-height: 20px;
    letter-spacing: 0em;
    text-align: left;
}

.section-two-banks-link {
    display: block;
    width: 100%;
    position: relative;
    margin: 20px 0px 0px 0px;
    padding: 0px 0px 5px 0px;
    font-size: 13px;
    font-weight: 400;
    line-height: 14px;
    letter-spacing: 0em;
    text-align: left;
    color: #000;
    border-bottom: 1px solid #000;
}

.section-two-banks-link:hover {
    opacity: 0.7;
}

.arrow-2 {
    position: absolute;
    right: 0;
}

.button-2 {
    margin: 0px 0px 20px 0px;
}

@media (max-width: 1600px) {
    .section-two-banks {
        padding: 80px 0px 50px 0px;
    }
}

@media (max-width: 1366px) {
    .section-two-banks-link {
        font-size: 12px;
    }
}

@media (max-width: 1280px) {
    .section-two-item-banks {
        padding: 40px 30px 40px 30px;
    }

    .section-two-banks-bloktext {
        margin: 0px 0px 15px 0px;
        padding: 15px 15px 15px 15px;
    }

    .section-two-banks-link {
        font-size: 11px;
    }
}

@media (max-width: 1024px) {
    .section-two-banks {
        padding: 50px 0px 20px 0px;
    }
}

@media (max-width: 930px) {
    .section-two-contant-banks {
        justify-content: center;
    }

    .section-two-item-banks {
        flex: 0 0 44%;
        margin: 0px 15px 30px 15px;
    }
}

@media (max-width: 768px) {
    .section-two-item-banks {
        flex: 0 0 45%;
    }
}

@media (max-width: 667px) {
    .section-two-item-banks {
        flex: 0 0 320px;
        margin: 0px 0px 30px 0px;
    }
}

@media (max-width: 428px) {
    .section-two-item-banks {
        flex: 0 0 100%;
    }

    .h2-banks {
        margin: 0px 0px 25px 0px;
    }
}

@media (max-width: 320px) {
    .section-two-item-banks {
        padding: 30px 15px 30px 15px;
    }
}

/******************************
********* PAGE BANKS-1 ***********
****************************/
.section-three-banks-1 {
    margin: 100px auto 0px auto;
    padding: 0px 50px 0px 50px;
}

@media (max-width: 1100px) {
    .section-three-banks-1 {
        margin: 80px auto 0px auto;
        padding: 0px 20px 0px 20px;
    }
}

@media (max-width: 900px) {
    .one-ekran-banks {
        height: 500px;
    }
}

@media (max-width: 900px) {
    .one-ekran-banks-1 {
        height: 550px;
    }

    .section-three-banks-1 {
        margin: 60px auto 0px auto;
    }
}

@media (max-width: 670px) {
    .one-ekran-banks {
        height: 560px;
    }
}

@media (max-width: 700px) {
    .section-three-banks-1 {
        padding: 0px 0px 0px 0px;
    }
}

@media (max-width: 600px) {
    .one-ekran-banks-1 {
        height: 600px;
    }

    .one-ekran-contant-banks-1 {
        padding: 110px 0px 0px 0px;
    }
}

@media (max-width: 500px) {
    .one-ekran-banks {
        height: 400px;
    }

    .form-1-banks-1 {
        margin: 70px auto 0px auto;
    }

}

@media (max-width: 375px) {
    .one-ekran-banks {
        border-radius: 50px 50px 0px 0px;
    }
}

@media (max-width: 374px) {
    .one-ekran-banks {
        height: 360px;
    }

    .form-1-banks {
        margin: 100px auto 0px auto;
    }
}

/*************************/
.section-three-banks {
    margin: 100px auto 0px auto;
}

@media (max-width: 900px) {
    .section-three-banks {
        margin: 60px auto 0px auto;
    }
}

@media (max-width: 500px) {
    .section-three-banks {
        margin: 270px auto 0px auto;
    }
}

@media (max-width: 375px) {
    .section-three-banks {
        margin: 300px auto 0px auto;
    }
}

@media (max-width: 320px) {
    .section-three-banks {
        margin: 320px auto 0px auto;
    }
}

/******** section-three-banks ************/
.section-three-banks {
    position: relative;
    width: 1920px;
    margin: 100px auto 0px auto;
    padding: 0px 50px 0px 50px;
}

.section-three-banks-contant {
    display: flex;
}

.section-three-banks-contant-col1 {
    flex: 0 0 50%;
    background: #fff;
    padding: 40px 30px 40px 30px;
    border-radius: 30px;
}

.h2-s3-banks {
    text-align: left;
}

.section-three-banks-text-1 {
    margin: 20px 0px 20px 0px;
    font-size: 14px;
    font-weight: 300;
    line-height: 17px;
    letter-spacing: 0em;
    text-align: left;
}

.section-three-banks-text-2 {
    font-size: 16px;
    font-weight: 500;
    line-height: 20px;
    letter-spacing: 0em;
    text-align: left;
}

.section-three-banks-image {
    position: absolute;
    right: 0;
    top: 0;
    border-radius: 30px 0px 0px 30px;
}

.section-three-banks-contant-col2 {}

@media (max-width: 1920px) {
    .section-three-banks {
        width: 100%;
    }
}

@media (max-width: 1366px) {
    .section-three-banks-contant-col1 {
        flex: 0 0 60%;
    }

    .section-three-banks-image {
        height: 70%;
    }
}

@media (max-width: 1280px) {
    .section-three-banks-contant-col1 {
        flex: 0 0 55%;
    }
}

@media (max-width: 1230px) {
    .section-three-banks-image {
        height: 65%;
    }
}

@media (max-width: 1130px) {
    .section-three-banks-image {
        height: 60%;
    }
}

@media (max-width: 1100px) {
    .section-three-banks-2 {
        position: relative;
        margin: 80px auto 0px auto;
        padding: 0px 20px 80px 20px;
    }

    .section-three-banks-contant-col2 {
        /*position: relative;*/
    }

    .section-three-banks-image-1 {
        height: 50%;
        position: absolute;
        top: 0;
    }
}


@media (max-width: 1050px) {
    .section-three-banks-image-1 {
        height: 47%;
    }
}

@media (max-width: 1024px) {
    .section-three-banks {
        margin: 80px auto 0px auto;
        padding: 0px 20px 0px 20px;
    }
}

@media (max-width: 960px) {
    .section-three-banks-image-1 {
        height: 40%;
    }
}

@media (max-width: 910px) {
    .section-three-banks-image-1 {
        height: 40%;
    }
}

@media (max-width: 900px) {
    .section-three-banks-image {
        height: 45%;
    }
}

@media (max-width: 899px) {
    .section-three-banks {
        margin: 60px auto 0px auto;
    }

    .section-three-banks-contant {
        flex-direction: column-reverse;
    }

    .section-three-banks-image {
        position: relative;
        width: 100%;
        border-radius: 30px 30px 0px 0px;
    }

    .section-three-banks-contant-col2 {
        width: 100%;
    }

    .section-three-banks-contant-col1 {
        position: relative;
        margin-top: -100px;
        z-index: 1;
        width: 100%;
    }
}

@media (max-width: 600px) {
    .section-three-banks {
        margin: 60px auto 0px auto;
        padding: 0px 0px 0px 0px;
    }

    .section-three-banks-2 {
        margin: 60px auto 0px auto;
        padding: 0px 0px 0px 0px;
    }

    .section-three-banks-2-contant {
        padding: 0px 0px 0px 0px;
    }
}

@media (max-width: 500px) {
    .section-three-banks-1 {
        margin: 320px auto 0px auto;
    }
}

@media (max-width: 428px) {
    .section-three-banks-contant-col1 {
        margin-top: -50px;
    }
}

@media (max-width: 390px) {
    .section-three-banks-contant-col1 {
        margin-top: -40px;
        padding: 30px 20px 30px 20px;
    }
}

@media (max-width: 375px) {
    .section-three-banks-1 {
        margin: 290px auto 0px auto;
    }
}

@media (max-width: 374px) {
    .section-three-banks-1 {
        margin: 360px auto 0px auto;
    }
}

/********************
********* PAGE NEWS *********
*********************/

/******* one-ekran-news ********/
.one-ekran-news {
    height: 420px;
    padding: 0px 0px 0px 0px;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
}

@media (max-width: 1366px) {
    .one-ekran-news {
        height: 360px;
    }
}

@media (max-width: 768px) {
    .one-ekran-news {
        height: 460px;
        background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
        background-position: top center;
    }
}

@media (max-width: 500px) {
    .one-ekran-news {
        margin: 20px auto 0px auto;
        border-radius: 50px 50px 50px 50px;
    }
}

/******* section-two-news *********/
.section-two-news {
    margin: 0px auto 0px auto;
    padding: 100px 0px 80px 0px;
}

.section-two-news-contant {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
}

.section-two-news-item {
    flex: 0 0 32%;
    margin: 0px 5px 20px 5px;
}

@media (max-width: 1279px) {
    .section-two-news {
        padding: 80px 0px 60px 0px;
    }
}

@media (max-width: 1024px) {
    .section-two-news {
        padding: 60px 0px 40px 0px;
    }
}

@media (max-width: 930px) {
    .section-two-news-contant {
        justify-content: center;
    }

    .section-two-news-item {
        flex: 0 0 42%;
        margin: 0px 10px 20px 10px;
    }

}

@media (max-width: 700px) {
    .section-two-news-item {
        flex: 0 0 400px;
        margin: 0px 0px 20px 0px;
    }

}

@media (max-width: 500px) {
    .section-two-news-item {
        flex: 0 0 320px;
    }

}

@media (max-width: 414px) {
    .section-two-news-item {
        flex: 0 0 100%;
    }

}

/********************
******** PAGE STATIA ********
***********************/

/******** one-ekran-statia **********/
.one-ekran-statia {
    height: 600px;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
}

.one-ekran-statia-contant {
    padding: 200px 0px 0px 0px;
}

@media (max-width: 1440px) {
    .one-ekran-statia {
        height: 500px;
    }

    .one-ekran-statia-contant {
        padding: 160px 0px 0px 0px;
    }
}

@media (max-width: 1280px) {
    .one-ekran-statia {
        height: 400px;
    }

    .one-ekran-statia-contant {
        padding: 120px 0px 0px 0px;
    }
}

@media (max-width: 900px) {
    .one-ekran-statia {
        height: 360px;
        border-radius: 0;
    }

    .one-ekran-statia-contant {
        padding: 110px 0px 0px 0px;
    }
}

@media (max-width: 768px) {
    .one-ekran-statia-contant {
        padding: 120px 0px 0px 0px;
    }
}

@media (max-width: 700px) {
    .one-ekran-statia {
        height: 360px;
        background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
        background-position: top center;
        border-radius: 0px 0px 50px 50px;

    }

    .one-ekran-statia-contant {
        padding: 130px 0px 0px 0px;
    }
}

@media (max-width: 600px) {
    .one-ekran-statia {
        height: 430px;
    }

    .one-ekran-statia-contant {
        padding: 150px 0px 0px 0px;
    }
}

@media (max-width: 500px) {
    .one-ekran-statia {
        height: 430px;
    }

    .one-ekran-statia-contant {
        padding: 90px 0px 0px 0px;
    }
}

@media (max-width: 428px) {
    .one-ekran-statia-contant {
        padding: 80px 0px 0px 0px;
    }
}

/************* section-two-statia *************/
.section-two-statia-contant-col1 {
    flex: 0 0 65%;
}

.section-two-statia-image-2 {
    position: absolute;
    right: 0;
    top: 0;
    border-radius: 30px 0px 0px 30px;
}

.section-two-statia-image-1 {
    width: 100%;
    margin: 0px 0px 20px 0px;
}

.section-two-statia-bloktext {
    margin: 20px 0px 0px 0px;
    padding: 10px 0px 0px 0px;
    border-top: 1px solid #828282;
    width: 100%;
    display: flex;
}

.section-two-statia-bloktext-col1 {
    flex: 0 0 25%;
    font-size: 14px;
    font-weight: 300;
    line-height: 17px;
    letter-spacing: 0em;
    text-align: left;
}

.section-two-statia-bloktext-col2 {
    flex: 0 0 75%;
    font-size: 14px;
    font-weight: 300;
    line-height: 17px;
    letter-spacing: 0em;
    text-align: left;
    color: #828282;
}

@media (max-width: 1760px) {
    .section-two-statia-contant-col1 {
        flex: 0 0 60%;
    }
}

@media (max-width: 1640px) {
    .section-two-statia-contant-col1 {
        flex: 0 0 57%;
    }
}

@media (max-width: 1536px) {
    .section-two-statia-contant-col1 {
        flex: 0 0 50%;
    }
}

@media (max-width: 1366px) {
    .section-two-statia-image-2 {
        height: 650px;
    }

    .section-two-statia-bloktext-col1 {
        flex: 0 0 30%;
    }

    .section-two-statia-bloktext-col2 {
        flex: 0 0 70%;
    }
}

@media (max-width: 1280px) {
    .section-two-statia-image-2 {
        height: 570px;
    }

    .section-two-statia-contant-col1 {
        flex: 0 0 55%;
    }
}

@media (max-width: 1180px) {
    .section-two-statia-image-2 {
        height: 500px;
    }
}

@media (max-width: 1080px) {
    .section-two-statia-image-2 {
        height: 450px;
    }
}

@media (max-width: 992px) {
    .section-two-statia-image-2 {
        height: 450px;
    }
}

@media (max-width: 960px) {
    .section-two-statia-image-2 {
        height: 420px;
    }
}

@media (max-width: 900px) {
    .section-two-statia {
        margin: -70px auto 0px auto;
        padding: 0px 0px 0px 0px;
    }

    .section-two-statia-contant {
        flex-direction: column-reverse;
    }

    .section-two-statia-image-2 {
        display: none;
    }

    .section-two-statia-contant-col1 {
        position: relative;
        z-index: 0;
        width: 100%;
        margin: 0px 0px 0px 0px;
    }

    .section-two-statia-image-1 {
        width: 100%;
    }
}

@media (max-width: 768px) {
    .section-two-statia {
        /*margin: 0px auto 60px auto;*/
    }
}

@media (max-width: 700px) {
    .section-two-statia-bloktext-col2 {
        padding: 0px 0px 0px 10px;
    }
}

@media (max-width: 500px) {

    .section-two-statia-bloktext-col1 {
        flex: 0 0 35%;
    }

    .section-two-statia-bloktext-col2 {
        flex: 0 0 65%;
    }
}

@media (max-width: 428px) {
    .section-two-statia-bloktext {
        flex-direction: column;
    }

    .section-two-statia-bloktext-col1 {
        margin: 0px 0px 10px 0px;
    }

    .section-two-statia-bloktext-col2 {
        padding: 0px 0px 0px 0px;
    }
}

/********** section-three-statia *************/
.section-three-statia {
    padding: 100px 0px 100px 0px;
}

@media (max-width: 1280px) {
    .section-three-statia {
        padding: 80px 0px 80px 0px;
    }
}

@media (max-width: 1100px) {
    .section-three-statia {
        padding: 60px 0px 60px 0px;
    }
}

/***********************
****** PAGE NOVOSTROIKI ********
***************************/
.one-ekran-nov {
    padding: 0px 0px 0px 0px;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
}

.form-1-col-2-nov {
    border-radius: 0px 10px 10px 0px;
}

.section-two-bloktext-nov {
    margin: 0px 0px 0px 0px;
}

.two-ekran-novostroiki-image {
    display: none;
}

@media (max-width: 899px) {
    .one-ekran-nov {
        height: 600px;
    }
}

@media (max-width: 600px) {
    .one-ekran-contant-nov {
        padding: 100px 0px 0px 0px;
    }

    .h2-novostroiki-1 {
        padding-right: 50px;
    }
}

@media (max-width: 500px) {
    .one-ekran-nov {
        margin: 20px auto 160px auto;
    }

    .two-ekran-novostroiki {
        padding: 50px 0px 20px 0px;
    }

    .two-ekran-novostroiki-image {
        display: block;
    }

    .section-two-bloktext-nov-2 {
        margin: -50px 0px 0px 0px;
    }
}

@media (max-width: 428px) {
    .one-ekran-nov {
        margin: 20px auto 160px auto;
        background-size: 220% 160%;
    }
}

@media (max-width: 390px) {
    .one-ekran-contant-nov {
        padding: 60px 0px 0px 0px;
    }
}

@media (max-width: 374px) {
    .one-ekran-nov {
        margin: 20px auto 120px auto;
    }

}

/**********************/
.arrow-2 {
    width: auto !important;
    border-radius: 0px 0px 0px 0px;
}

.three-ekran-novostroiki-bloktext {
    height: auto;
}


/****************************
******* PAGE NOVOSTROIKI-1 ******
*****************************/

/******* one-ekran-novostroiki-1 **********/
.one-ekran-nov-text-1 {
    font-size: 36px;
    line-height: 1;
}

@media (max-width: 1024px) {
    .one-ekran-nov-text-1 {
        font-size: 24px;
    }
}

@media (max-width: 460px) {
    .one-ekran-nov-text-1 {
        padding: 0px 40px 0px 40px;
    }
}

@media (max-width: 500px) {
    .one-ekran-nov-1 {
        margin: 20px auto 50px auto;
    }
}

@media (max-width: 470px) {
    .one-ekran-nov-1 {
        margin: 20px auto 70px auto;
    }
}

@media (max-width: 460px) {
    .one-ekran-nov-1 {
        margin: 20px auto 100px auto;
    }
}

@media (max-width: 389px) {
    .one-ekran-nov-text-1 {
        font-size: 22px;
    }
}

@media (max-width: 360px) {
    .one-ekran-nov-1 {
        margin: 20px auto 80px auto;
    }

    .one-ekran-nov-text-1 {
        padding: 0px 20px 0px 20px;
    }
}

/******** three-ekran-novostroiki-1 ***************/
.three-ekran-novostroiki-1 {
    padding: 0px 0px 0px 0px;
    margin: 20px auto 100px auto;
}

.three-ekran-novostroiki-blokinfo {
    display: flex;
    margin: 30px 0px 30px 0px;
}

.three-ekran-novostroiki-blokinfo-col {
    flex: 0 0 50%;
}

.three-ekran-novostroiki-blokinfo-col1 {
    padding: 0px 10px 0px 0px;
}

.three-ekran-novostroiki-blokinfo-col2 {
    padding: 0px 0px 0px 10px;
}

.three-ekran-novostroiki-blokinfo-item-1 {
    border-radius: 10px 10px 0px 0px;
}

.three-ekran-novostroiki-blokinfo-item-4 {
    border-radius: 0px 0px 10px 10px;
}

.three-ekran-novostroiki-blokinfo-item-5 {
    border-radius: 10px 10px 0px 0px;
}

.three-ekran-novostroiki-blokinfo-item-8 {
    border-radius: 0px 0px 10px 10px;
}

@media (max-width: 1024px) {
    .three-ekran-novostroiki-1 {
        margin: 10px auto 60px auto;
    }
}

@media (max-width: 900px) {
    .three-ekran-novostroiki-1-contant {
        flex-direction: column-reverse;
    }

    .three-ekran-novostroiki-1-image {
        display: block;
        position: relative;
        width: 100%;
        height: auto;
        border-radius: 30px 30px 0px 0px;
    }

    .three-ekran-novostroiki-1-col1 {
        margin: -200px 0px 0px 0px;
    }
}

@media (max-width: 500px) {
    .three-ekran-novostroiki-blokinfo-col1 {
        padding: 0px 5px 0px 0px;
    }

    .three-ekran-novostroiki-blokinfo-col2 {
        padding: 0px 0px 0px 5px;
    }

    .h2-s3-novostroiki-1 {
        width: 88%;
    }
}

@media (max-width: 428px) {
    .three-ekran-novostroiki-1 {
        margin: 30px auto 60px auto;
    }

    .three-ekran-novostroiki-1-col1 {
        margin: -100px 0px 0px 0px;
        padding: 30px 20px 30px 20px;
    }

    .three-ekran-novostroiki-blokinfo {
        flex-direction: column;
    }

    .three-ekran-novostroiki-blokinfo-col1 {
        padding: 0px 0px 0px 0px;
    }

    .three-ekran-novostroiki-blokinfo-col2 {
        padding: 0px 0px 0px 0px;
    }

    .three-ekran-novostroiki-blokinfo-item-1 {
        border-radius: 10px 10px 0px 0px;
    }

    .three-ekran-novostroiki-blokinfo-item-4 {
        border-radius: 0px 0px 0px 0px;
    }

    .three-ekran-novostroiki-blokinfo-item-5 {
        border-radius: 0px 0px 0px 0px;
    }

    .three-ekran-novostroiki-blokinfo-item-8 {
        border-radius: 0px 0px 10px 10px;
    }

    .h2-s3-novostroiki-1 {
        width: 85%;
    }
}

@media (max-width: 390px) {
    .h2-s3-novostroiki-1 {
        width: 100%;
    }
}

/******* foor-ekran-novostroiki-1 ***********/
.foor-ekran-novostroiki-1 {
    width: 1920px;
    margin: 0px auto 100px auto;
    padding: 0px 0px 0px 0px;
}

.foor-ekran-novostroiki-1-contant {
    padding: 60px 60px 60px 60px;
    background: #fff;
    border-radius: 30px;
}

.foor-ekran-novostroiki-1-contant-items {
    margin: 0px 0px 0px 0px;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
}

.foor-ekran-novostroiki-1-contant-item {
    position: relative;
    flex: 0 0 50%;
    margin: 0px 0px 60px 0px;
    padding: 0px 10px 0px 50px;
}

.foor-ekran-novostroiki-1-text-1 {
    position: absolute;
    left: 0;
    top: 0px;
    font-size: 60px;
    font-weight: 500;
    line-height: 1;
    letter-spacing: 0em;
    text-align: left;
    color: #FFEB39;
}

.foor-ekran-novostroiki-1-text-2 {
    margin: 0px 0px 5px 0px;
    font-size: 20px;
    font-weight: 300;
    line-height: 26px;
    letter-spacing: 0em;
    text-align: left;
    color: #000;
}

.foor-ekran-novostroiki-1-text-3 {
    font-size: 18px;
    font-weight: 300;
    line-height: 20px;
    letter-spacing: 0em;
    text-align: left;
    color: #828282;
}

.button-novostroiki-1 {
    width: 450px;
}

@media (max-width: 1920px) {
    .foor-ekran-novostroiki-1 {
        width: 100%;
    }
}

@media (max-width: 1600px) {
    .foor-ekran-novostroiki-1-text-2 {
        font-size: 18px;
        line-height: 1;
    }

    .foor-ekran-novostroiki-1-text-3 {
        font-size: 16px;
        line-height: 1.3;
    }
}


@media (max-width: 1280px) {
    .foor-ekran-novostroiki-1-text-2 {
        font-size: 16px;
    }

    .foor-ekran-novostroiki-1-text-3 {
        font-size: 14px;
    }
}

@media (max-width: 900px) {
    .foor-ekran-novostroiki-1 {
        margin: 0px auto 60px auto;
    }

    .foor-ekran-novostroiki-1-contant-item {
        padding: 0px 20px 0px 50px;
    }
}

@media (max-width: 768px) {
    .foor-ekran-novostroiki-1-contant {
        padding: 40px 30px 40px 30px;
    }
}

@media (max-width: 700px) {
    .foor-ekran-novostroiki-1-contant-item {
        margin: 0px 0px 40px 0px;
        padding: 0px 20px 0px 40px;
    }
}

@media (max-width: 600px) {
    .foor-ekran-novostroiki-1-contant-item {
        flex: 0 0 100%;
        margin: 0px 0px 40px 0px;
        padding: 0px 20px 0px 50px;
    }
}

@media (max-width: 500px) {
    .button-novostroiki-1 {
        width: 100%;
    }

    .foor-ekran-novostroiki-1-text-2 {
        margin: 0px 0px 10px 0px;
    }
}

@media (max-width: 428px) {
    .foor-ekran-novostroiki-1-contant {
        padding: 40px 20px 40px 20px;
    }

    .foor-ekran-novostroiki-1-contant-item {
        padding: 0px 0px 0px 50px;
    }
}

@media (max-width: 360px) {
    .foor-ekran-novostroiki-1-contant-item {
        padding: 0px 0px 0px 40px;
    }

    .foor-ekran-novostroiki-1-text-1 {
        font-size: 50px;
    }
}

/***********************
****** PAGE CALCULATOR ********
***************************/

/*************************/
.section-calculator {
    width: 1920px;
    padding: 0px 0px 0px 0px;
    margin: 100px auto 100px auto;
}

.section-calculator-contant {
    width: 100%;
}

.section-calculator-link {
    position: relative;
    margin: 0px 0px 0px 30px;
    padding: 0px 0px 0px 20px;
    font-size: 18px;
    font-weight: 400;
    line-height: 20px;
    letter-spacing: 0em;
    text-align: left;
    color: #ccc;
    transition-duration: 0.5s;
}

.section-calculator-link:hover {
    color: #000;
}

.section-calculator-link::before {
    content: '<';
    position: absolute;
    left: 0;
    top: 0px;
}

.section-calculator-tab {
    width: 100%;
    margin: 40px 0px 0px 0px;
}

.section-calculator-tab-title {
    width: 100%;
    margin: 0px 0px 40px 0px;
    padding: 0px 30px 0px 30px;
    display: flex;
    justify-content: space-between;
}

.section-calculator-tab-title-item {
    padding: 0px 0px 2px 0px;
    width: auto;
    border-bottom: 1px solid #ccc;
    font-size: 18px;
    font-weight: 400;
    line-height: 20px;
    letter-spacing: 0em;
    text-align: left;
    color: #ccc;
    transition-duration: 0.5s;
    cursor: pointer;
}

.section-calculator-tab-title-item:hover {
    color: #000 !important;
    border-bottom: 1px solid #000 !important;
}

.section-calculator-tab-title-item-1 {
    color: #000;
    border-bottom: 1px solid #000;
}

.section-calculator-tab-title-item-2 {}

.section-calculator-tab-title-item-3 {}

.section-calculator-tab-title-item-4 {}

.section-calculator-tab-body {
    width: 100%;
    display: flex;
    flex-direction: column;
}

.calculator-tab-body-1 {
    display: flex;
}

.calculator-tab-body-2 {
    display: block;
}

.calculator-tab-body-3 {
    display: block;
}

.calculator-tab-body-4 {
    display: block;
}

.calculator-tab-body-blok {
    width: 100%;
    margin: 0px 0px 40px 0px;
    padding: 30px 30px 30px 30px;
    background: #fff;
    border-radius: 30px;
}

.calculator-tab-body-blok-title {
    /* margin: 0px 0px 20px 0px;*/
    font-size: 18px;
    font-weight: 400;
    line-height: 20px;
    letter-spacing: 0em;
    text-align: left;
    color: #000;
    cursor: pointer;
}

.block-1 {
    display: none;
}

.block-2 {
    display: block;
}

.calculator-tab-body-blok-title-11 {
    display: none;
}

.calculator-tab-body-blok-title-21 {
    display: none;
}

.calculator-tab-body-blok-title span {
    margin: 0px 0px 0px 10px;
    font-size: 11px;
    font-weight: 400;
    line-height: 14px;
    letter-spacing: 0em;
    text-align: left;
    color: #ccc;
}

.tab-body-blok-info {
    margin: 20px 0px 0px 0px;
    width: 100%;
}

.tab-body-blok-info-301 {
    margin: 20px 0px 0px 0px;
    width: 100%;
}

.tab-body-blok-info-1 {
    display: block;
}

.tab-body-blok-info-2 {
    display: block;
}

.tab-body-blok-info-3 {
    display: block;
}

.tab-body-blok-info-4 {
    display: none;
}

.tab-body-blok-info-303 {
    display: block;
}

.tab-body-blok-info-row {
    width: 100%;
    display: flex;
    box-sizing: border-box;
}

.tab-body-blok-info-row-2 {
    flex-wrap: wrap;
}

.tab-body-blok-info-row-1 .tab-body-blok-info-element {
    flex: 0 0 33.333%;
}

.tab-body-blok-info-row-2 .tab-body-blok-info-element {
    flex: 0 0 25%;
}

.tab-body-blok-info-row-3 .tab-body-blok-info-element {
    flex: 0 0 50%;
}

.tab-body-blok-info-row-4 {
    margin: 20px 0px 0px 0px;
}

.tab-body-blok-info-row-4 .tab-body-blok-info-element {
    flex: 0 0 25%;
    width: 25%;
}

.tab-body-blok-info-row-4-1 {
    margin: 0px 0px 0px 0px;
    flex-wrap: wrap;
}

#tab-body-blok-info-row-4-1 {
    margin: 20px 0px 0px 0px;
}

.tab-body-blok-info-row-4-1 .tab-body-blok-info-element {
    flex: 0 0 50%;
}

.tab-body-blok-info-row-5 .tab-body-blok-info-element {
    flex: 0 0 33.333%;
    width: 33.333%;
}

.tab-body-blok-info-row-6 .tab-body-blok-info-element {
    flex: 0 0 33.333%;
}

.tab-body-blok-info-row-66 .tab-body-blok-info-element {
    flex: 0 0 50%;
}

.tab-body-blok-info-row-7 .tab-body-blok-info-element {
    flex: 0 0 50%;
}

.tab-body-blok-info-row-201 .tab-body-blok-info-element {
    flex: 0 0 33.333%;
}

.tab-body-blok-info-row-202 .tab-body-blok-info-element {
    flex: 0 0 50%;
}

.tab-body-blok-info-row-203 {
    display: flex;
}

.tab-body-blok-info-row-203 .tab-body-blok-info-element {
    flex: 0 0 50%;
}

.tab-body-blok-info-row-307 {
    justify-content: center;
    width: 100%;
}

.tab-body-blok-info-row-303 .tab-body-blok-info-element {
    flex: 0 0 25%;
}

.tab-body-blok-info-row-304 .tab-body-blok-info-element {
    flex: 0 0 25%;
}

.tab-body-blok-info-row-304 .tab-body-blok-info-element-305 {
    flex: 0 0 25%;
}

.tab-body-blok-info-row-304 .tab-body-blok-info-element-306 {
    flex: 0 0 25%;
}

.tab-body-blok-info-row-304 .tab-body-blok-info-element-307 {
    flex: 0 0 50%;
}

.tab-body-blok-info-row-305 {
    flex-wrap: wrap;
    margin-bottom: 20px;
}

.tab-body-blok-info-row-305 .checkbox-box-zalog {
    flex: 0 0 50%;
}

.checkbox-box-zalog-1 {
    padding: 0px 10px 0px 0px !important;
}

.checkbox-box-zalog-2 {
    padding: 0px 0px 0px 8px !important;
}

.checkbox-box-zalog-3 {
    padding: 0px 10px 0px 0px !important;
}

.checkbox-box-zalog-4 {
    padding: 0px 0px 0px 8px !important;
}

.tab-body-blok-info-element {
    padding: 0px 4px 0px 0px;
    margin: 0px 0px 15px 0px;
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
}

.tab-body-blok-info-element-vnutr {
    width: 100%;
    height: 65px;
    /* srg old 100% */
    padding: 10px 10px 10px 20px;
    margin: 0px 0px 0px 0px;
    background: #f5f5f5;
    /*background: #e20e0e;*/
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
}

.tab-body-blok-info-element-1 .tab-body-blok-info-element-vnutr {
    border-radius: 10px 0px 0px 10px;
}

.tab-body-blok-info-element-2 .tab-body-blok-info-element-vnutr {
    border-radius: 0px 0px 0px 0px;
}

.tab-body-blok-info-element-3 .tab-body-blok-info-element-vnutr {
    border-radius: 0px 10px 10px 0px;
}

.tab-body-blok-info-element-4 .tab-body-blok-info-element-vnutr {
    border-radius: 10px 0px 0px 10px;
}

.tab-body-blok-info-element-5 .tab-body-blok-info-element-vnutr {
    border-radius: 0px 0px 0px 0px;
}

.tab-body-blok-info-element-6.tab-body-blok-info-element-vnutr {
    border-radius: 0px 0px 0px 0px;
}

.tab-body-blok-info-element-7 .tab-body-blok-info-element-vnutr {
    border-radius: 0px 10px 10px 0px;
}

.tab-body-blok-info-element-8 .tab-body-blok-info-element-vnutr {
    border-radius: 10px 0px 0px 10px;
}

.tab-body-blok-info-element-9 .tab-body-blok-info-element-vnutr {
    border-radius: 0px 0px 0px 0px;
}

.tab-body-blok-info-element-10.tab-body-blok-info-element-vnutr {
    border-radius: 0px 0px 0px 0px;
}

.tab-body-blok-info-element-11 .tab-body-blok-info-element-vnutr {
    border-radius: 0px 10px 10px 0px;
}

.tab-body-blok-info-element-12 .tab-body-blok-info-element-vnutr {
    border-radius: 10px 0px 0px 10px;
}

.tab-body-blok-info-element-13 .tab-body-blok-info-element-vnutr {
    border-radius: 0px 10px 10px 0px;
}

.tab-body-blok-info-element-14 .tab-body-blok-info-element-vnutr {
    border-radius: 10px 0px 0px 10px;
}

.tab-body-blok-info-element-15 .tab-body-blok-info-element-vnutr {
    border-radius: 0px 0px 0px 0px;
}

.tab-body-blok-info-element-16.tab-body-blok-info-element-vnutr {
    border-radius: 0px 0px 0px 0px;
}

.tab-body-blok-info-element-17 .tab-body-blok-info-element-vnutr {
    border-radius: 0px 10px 10px 0px;
}

.tab-body-blok-info-element-16-1.tab-body-blok-info-element-vnutr {
    border-radius: 10px 0px 0px 10px;
}

.tab-body-blok-info-element-17-1 .tab-body-blok-info-element-vnutr {
    border-radius: 0px 10px 10px 0px;
}

.tab-body-blok-info-element-18 .tab-body-blok-info-element-vnutr {
    border-radius: 10px 0px 0px 10px;
}

.tab-body-blok-info-element-19 .tab-body-blok-info-element-vnutr {
    border-radius: 0px 0px 0px 0px;
}

.tab-body-blok-info-element-20 .tab-body-blok-info-element-vnutr {
    border-radius: 0px 10px 10px 0px;
}

.tab-body-blok-info-element-21 .tab-body-blok-info-element-vnutr {
    border-radius: 10px 0px 0px 10px;
}

.tab-body-blok-info-element-22 .tab-body-blok-info-element-vnutr {
    border-radius: 0px 10px 10px 0px;
}

.tab-body-blok-info-element-23 .tab-body-blok-info-element-vnutr {
    border-radius: 10px 10px 10px 10px;
}

.tab-body-blok-info-element-201 .tab-body-blok-info-element-vnutr {
    border-radius: 10px 0px 0px 10px;
}

.tab-body-blok-info-element-202 .tab-body-blok-info-element-vnutr {
    border-radius: 0px 0px 0px 0px;
}

.tab-body-blok-info-element-203 .tab-body-blok-info-element-vnutr {
    border-radius: 0px 10px 10px 0px;
}

.tab-body-blok-info-element-204 .tab-body-blok-info-element-vnutr {
    border-radius: 10px 0px 0px 10px;
}

.tab-body-blok-info-element-205 .tab-body-blok-info-element-vnutr {
    border-radius: 0px 10px 10px 0px;
}

.tab-body-blok-info-element-206 .tab-body-blok-info-element-vnutr {
    border-radius: 10px 0px 0px 10px;
}

.tab-body-blok-info-element-207 .tab-body-blok-info-element-vnutr {
    border-radius: 0px 10px 10px 0px;
}

.tab-body-blok-info-element-208 .tab-body-blok-info-element-vnutr {
    border-radius: 0px 10px 10px 0px;
}

.tab-body-blok-info-element-210 .tab-body-blok-info-element-vnutr {
    border-radius: 0px 10px 10px 0px;
}

.tab-body-blok-info-element-301 .tab-body-blok-info-element-vnutr {
    border-radius: 10px 0px 0px 10px;
}

.tab-body-blok-info-element-302 .tab-body-blok-info-element-vnutr {
    border-radius: 0px 10px 10px 0px;
}

.tab-body-blok-info-element-302 {
    padding-right: 8px;
}

.tab-body-blok-info-element-303 .tab-body-blok-info-element-vnutr {
    border-radius: 10px 0px 0px 10px;
}

.tab-body-blok-info-element-303 {
    padding-left: 8px;
}

.tab-body-blok-info-element-304 .tab-body-blok-info-element-vnutr {
    border-radius: 0px 10px 10px 0px;
}

.tab-body-blok-info-element-305 .tab-body-blok-info-element-vnutr {
    border-radius: 10px 0px 0px 10px;
}

.tab-body-blok-info-element-306 .tab-body-blok-info-element-vnutr {
    border-radius: 0px 10px 10px 0px;
}

.tab-body-blok-info-element-306 {
    padding-right: 8px;
}

.tab-body-blok-info-element-307 .tab-body-blok-info-element-vnutr {
    border-radius: 10px 10px 10px 10px;
}

.tab-body-blok-info-element-307 {
    padding-left: 8px;
}

.tab-body-blok-info-element-220 {
    display: block;
    flex: 0 0 50%;
    width: 50%;
}

.tab-body-blok-info-element-vnutr-chek {
    position: relative;
}

.pole-step-2 {
    position: relative;
    background: #f5f5f5;
    color: #828282;
}

.pole-2-chek {
    display: none;
    position: absolute;
    width: 24px;
    right: 10px;
    top: 20px;
    z-index: 1;
}

.tab-body-blok-info-element .form-1-col {
    padding: 0px 0px 0px 0px;
    margin: 0px 0px 0px 0px;
}

.button-step-21 {
    margin-top: 30px;
}

.button-step-22 {
    display: none;
    margin-top: 30px;
}

.button-step-23 {
    display: flex;
    margin-top: 30px;
}

.button-step-24 {
    display: none;
    margin-top: 30px;
}

.button-step-202 {
    display: none;
    margin-top: 30px;
}

.button-step-203 {
    display: none;
    margin-top: 30px;
}

.button-step-303 {
    display: none;
    margin-top: 30px;
    opacity: 0/7;
}

.calculator-blok-vopros {
    width: 100%;
    display: flex;
    align-items: center;
}

.calculator-blok-vopros-1 {
    display: none;
}

.calculator-blok-vopros-image {
    cursor: pointer;
}

.calculator-blok-vopros-image-2 {
    display: none;
}

.calculator-blok-vopros-text {
    display: none;
    padding: 0px 0px 0px 10px;
    font-style: normal;
    font-weight: 400;
    font-size: 9px;
    line-height: 11px;
    letter-spacing: 0.01em;
    color: #000000;
    transition-duration: 0.5s;
    cursor: pointer;
}

.calculator-blok-vopros-text-1 {
    display: none;
    padding: 0px 0px 0px 10px;
    font-style: normal;
    font-weight: 400;
    font-size: 9px;
    line-height: 11px;
    letter-spacing: 0.01em;
    color: #000000;
    transition-duration: 0.5s;
    cursor: pointer;
}

.button-step-2 {
    position: relative;
    height: 59px;
    border: 2px solid #000;
    background: #ffeb3900;
}

.button-step-2:hover {
    background: linear-gradient(0deg, rgba(255, 255, 255, 0.5), rgba(255, 255, 255, 0.5)), #FFEB39 !important;
    border: 2px solid #FFEB39 !important;
}

.button-step-2:active {
    border: 2px solid #000000 !important;
    background: none !important;
}

.button-step-2:visited {
    background: none !important;
    border: 2px solid #828282 !important;
    /*color: #828282;*/
    color: #000 !important;
}

.button-step-210 {
    width: 50%;
    position: relative;
    height: 59px;
    border: 2px solid #000;
    background: #ffeb3900;
}

.button-step-210:hover {
    background: linear-gradient(0deg, rgba(255, 255, 255, 0.5), rgba(255, 255, 255, 0.5)), #FFEB39 !important;
    border: 2px solid #FFEB39 !important;
}

.button-step-210:active {
    border: 2px solid #000000 !important;
    background: none !important;
}

.button-step-210:visited {
    background: none !important;
    border: 2px solid #828282 !important;
    /*color: #828282;*/
    color: #000 !important;
}

.button-step-301 {
    opacity: 0.7;
}

.checkbox-box {
    padding: 0px 0px 0px 5px;
    height: 59px;
    width: 50%;
    display: flex;
    align-items: center;
}

.checkbox-box label {
    margin: 0px 0px 0px 0px;
    padding: 0px 0px 0px 40px;
    font-style: normal;
    font-weight: 300;
    font-size: 9px;
    line-height: 11px;
    letter-spacing: 0.01em;
    color: #828282;
}

.checkbox-box-301 {
    width: 33.333%;
    padding: 0px 0px 0px 0px;
    height: auto;
    margin: 10px 0px 30px 0px;
}

.checkbox-1 {
    position: absolute;
    z-index: 1;
    opacity: 1;
    display: inline-flex;
    align-items: center;
    -webkit-user-select: none;
            user-select: none;
}

.checkbox-1::before {
    content: '';
    display: inline-block;
    width: 28px;
    height: 28px;
    flex-shrink: 0;
    flex-grow: 0;
    border: 1.5px solid #000;
    border-radius: 6px;
    margin-right: 10px;
    background: #fff;
    background-repeat: no-repeat;
    background-position: center center;
    background-size: 50% 50%;
    opacity: 1;
}

/* стили при наведении курсора на checkbox */
.checkbox-1:not(:disabled):not(:checked):hover::before {
    border-color: #000;
}

/* стили для активного состояния чекбокса (при нажатии на него) */
.checkbox-1:not(:disabled):active::before {
    border-color: #ccc;
}

/* стили для чекбокса, находящегося в фокусе */
.checkbox-1:focus::before {
    box-shadow: 0 0 0 0.0rem rgba(0, 123, 255, 0.25);
}

/* стили для чекбокса, находящегося в фокусе и не находящегося в состоянии checked */
.checkbox-1:focus:not(:checked)::before {
    border-color: #ccc;
}

/* стили для чекбокса, находящегося в состоянии disabled */
.checkbox-1:disabled::before {
    background-color: #e9ecef;
}

.checkbox-1:checked::before {
    border-color: #ccc;
    background-color: rgb(255, 255, 255);
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
    background-repeat: no-repeat;
    background-position: center center;
    background-size: 90% 90%;
}

.dropdown__list-calc {
    overflow: scroll;
    height: 120px;
}

.tab-body-blok-info-animation {
    width: 100%;
    padding: 10px 0px 20px 0px;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.tab-body-blok-info-animation-2 {
    display: flex;
    flex-direction: row;

}

.tab-body-blok-info-animation-col {
    padding: 0px 10px 0px 0px;
    flex: 0 0 50%;
    text-align: left;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
}

.tab-body-blok-info-animation-text {
    font-size: 14px;
    font-weight: 500;
    line-height: 17px;
    letter-spacing: 0em;
    text-align: center;
    color: #000;
}

.tab-body-blok-info-animation-text-2 {
    margin: 0px 0px 0px 0px;
    padding: 0px 0px 15px 30px;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
    background-repeat: no-repeat;
    background-position: left top;
    background-size: 20px auto;
    text-align: left;
}

.tab-body-blok-info-animation-text-22 {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
}

.tab-body-blok-info-animation-text-3 {
    padding: 15px 0px 15px 0px;
    text-align: left;
}

.blok-info-animation {
    padding: 30px 0px 30px 0px;
}

.tab-body-blok-info-animation-link {
    font-size: 11px;
    font-weight: 400;
    line-height: 14px;
    letter-spacing: 0em;
    color: #828282;
    text-decoration: underline;
    cursor: pointer;
    text-align: center;
}

.tab-body-blok-info-animation-link:hover {
    color: #000;
}

.tab-body-blok-info-animation-link-3 {
    margin: 5px 0px 0px 0px;
}

#tab-body-blok-info-animation-link-1 {
    display: none;
}

.circle-box {
    display: flex;
}

.circle {
    background: #000;
    border-radius: 0%;
    width: 6px;
    height: 6px;
    margin: 0px 7px 0px 7px;
}

.circle-1 {
    animation-delay: 0s;
}

.circle-2 {
    animation-delay: 0.4s;
}

.circle-3 {
    animation-delay: 0.8s;
}

.tab-body-blok-info-animation-2 {
    display: flex;
    flex-direction: row;

}

/*************************/
.tab-body-blok-contant-401-up {
    width: 100%;
    display: block;
}

.tab-body-blok-info-400 {
    width: 100%;
    padding: 0px 0px 0px 0px;
    margin: 0px 0px 30px 0px;
}

.tab-body-blok-info-element-400 {
    border-radius: 10px !important;
    border: 1px solid #000;
    padding: 0px 0px 0px 0px;
}

.tab-body-blok-info-element-400 .tab-body-blok-info-element-vnutr {
    border-radius: 10px !important;
}

.tab-body-blok-info-element-400-text {
    font-size: 9px;
    font-weight: 400;
    line-height: 11px;
    letter-spacing: 0.01em;
    text-align: left;
    background-size: 18px auto;
}

.button-step-400 {
    width: 100%;
}

.tab-body-blok-contant-401 {
    width: 500px;
    margin: 40px auto 0px auto;
    padding: 0px 0px 0px 0px;
}

.tab-body-blok-info-401 {
    width: 100%;
    padding: 10px 20px 30px 20px;
    border: 2px solid #000;
    border-radius: 10px;
}

#tab-body-blok-info-401-4 {
    display: none;
}

#tab-body-blok-info-401-5 {
    display: none;
}

#tab-body-blok-info-401-6 {
    display: block;
}

.tab-body-blok-info-401-element {
    width: 100%;
    padding: 20px 0px 15px 0px;
    border-bottom: 1px solid #ccc;
    display: flex;
    align-items: center;
}

.tab-body-blok-info-401-element img {
    width: 24px;
    margin: 0px 10px 0px 0px;
}

.blok-info-401-element-text {
    font-size: 16px;
    font-weight: 400;
    line-height: 20px;
    letter-spacing: 0em;
    text-align: left;
    color: #000;
}

.tab-body-4-blok-price {
    width: 120px;
    margin: 0px 0px 0px auto;
    padding: 20px 0px 0px 0px;
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-end;
    align-items: flex-end;
}

.tab-body-4-price-1 {
    margin: 0px 5px 0px 0px;
    font-size: 11px;
    font-weight: 400;
    line-height: 14px;
    letter-spacing: 0em;
    text-align: right;
    text-decoration: line-through;
    color: #828282;
}

.tab-body-4-price-2 {
    font-size: 11px;
    font-weight: 400;
    line-height: 14px;
    letter-spacing: 0em;
    padding: 2px 6px 2px 6px;
    border-radius: 2px;
    color: #fff;
    background: #000;
    text-align: center;
}

.tab-body-4-price-3 {
    font-size: 24px;
    font-weight: 400;
    line-height: 26px;
    letter-spacing: 0em;
    text-align: right;
    color: #000;
}

.button-step-401 {
    width: 100%;
    margin: 30px 0px 0px 0px;
}

.tab-body-4-dopinfo-blok-link {
    position: relative;
    width: 110px;
}

.tab-body-4-dopinfo-link {
    position: relative;
    margin: 0px 0px 10px 0px;
    font-size: 11px;
    font-weight: 400;
    line-height: 14px;
    letter-spacing: 0em;
    text-align: left;
    color: #828282;
    cursor: pointer;
    text-decoration: underline;
    transition-duration: 0.5s;
}

.tab-body-4-dopinfo-link:hover {
    text-decoration: none;
}

.icon-down-arrow-401 {
    position: absolute;
    width: 15px;
    top: 0px;
    cursor: pointer;
}

.tab-body-4-blok-dopinfo {
    display: flex;
    width: 100%;
    height: auto;
    flex-wrap: wrap;

}

.tab-body-4-blok-dopinfo-1 {
    padding: 0px 0px 30px 0px;

}

.rotate-401 .icon-down-arrow-401 {
    transform: rotate(-180deg);
    transition: .3s;
}

.block {
    display: flex;

}

.block-2 {
    display: block;

}

.rotate-401 #tab-body-4-blok-dopinfo-1 {
    display: block;
}

.rotate-401 #tab-body-4-blok-dopinfo-2 {
    display: block;
}

.rotate-401 #tab-body-4-blok-dopinfo-3 {
    display: block;
}

.rotate-401 #tab-body-4-blok-dopinfo-4 {
    display: block;
}

.rotate-401 #tab-body-4-blok-dopinfo-5 {
    display: block;
}

.rotate-401 #tab-body-4-blok-dopinfo-6 {
    display: block;
}

.none {
    display: none;
}

.tab-body-4-blok-dopinfo-col {
    flex: 0 0 50%;
}

.icon-home-gray {
    margin: 0px 0px 10px 0px;
}

.tab-body-4-blok-dopinfo-text {
    font-size: 9px;
    font-weight: 300;
    line-height: 11px;
    letter-spacing: 0.01em;
    text-align: left;
    color: #828282;
}

.button-step-201 {
    margin: 30px auto 0px auto;
}

.button-step-402 {
    display: none;
    width: 100%;
    margin: 30px 0px 0px 0px;
}

.tab-body-4-blok-dopinfo-text-3 {
    line-height: 13px;
}

.tab-body-4-blok-dopinfo-2 {
    padding: 0px 0px 0px 0px;
}

.button-step-4000 {
    width: 100%;
    margin: 30px 0px 0px 0px;
    border-radius: 0px;
}

.button-step-4001 {
    width: 100%;
    margin: 30px 0px 0px 0px;
    border-radius: 0px;
}

.button-step-4002 {
    width: 100%;
    margin: 30px 0px 0px 0px;
    border-radius: 0px;
}

.button-step-4000-active {
    background: #fff;
    border: 2px solid #000;

}

.button-step-4001-active {
    background: #fff;
    border: 2px solid #000;

}

.button-step-4002-active {
    background: #fff;
    border: 2px solid #000;

}

.button-step-finish {
    display: none;
    width: 100%;
    margin: 30px 0px 0px 0px;
}

.validacia {
    display: block;
    width: 100%;
    margin: 20px 0px 0px 0px;
    text-align: center;
    display: flex;
    justify-content: center;
}

.validacia-2 {
    display: block;
    width: 100%;
    margin: 20px 0px 0px 0px;
    text-align: center;
    display: flex;
    justify-content: center;
}

.validacia-3 {
    display: block;
    width: 100%;
    margin: 20px 0px 0px 0px;
    text-align: center;
    display: flex;
    justify-content: center;
}

.validacia-4 {
    display: none;
    width: 100%;
    margin: 20px 0px 0px 0px;
    text-align: center;
    justify-content: center;
}

#validacia-text {
    width: auto;
    font-size: 11px;
    line-height: 17px;
    color: red;
    font-weight: 500;
}

#validacia-text-2 {
    font-size: 9px;
    margin: 5px 0px 0px 0px;
    padding: 0px 0px 5px 18px;
    background-size: 14px auto;
}

#tab-body-blok-info-303-vnutr {
    margin: 0px 0px 30px 0px;
}

.tab-body-blok-info-element-301 {
    height: 64px;
}



@media (max-width: 1920px) {
    .section-calculator {
        width: 100%;
    }
}

@media (max-width: 1280px) {
    .tab-body-blok-info-row-2 .tab-body-blok-info-element {
        flex: 0 0 33.333%;
    }

    .tab-body-blok-info-row-4 .tab-body-blok-info-element {
        flex: 0 0 24%;
    }

    .tab-body-blok-info-element-6 .tab-body-blok-info-element-vnutr {
        border-radius: 0px 10px 10px 0px;
    }

    .tab-body-blok-info-element-7 .tab-body-blok-info-element-vnutr {
        border-radius: 10px 0px 0px 10px;
    }

    .tab-body-blok-info-element-8 .tab-body-blok-info-element-vnutr {
        border-radius: 0px 0px 0px 0px;
    }

    .tab-body-blok-info-element-9 .tab-body-blok-info-element-vnutr {
        border-radius: 0px 10px 10px 0px;
    }

    .tab-body-blok-info-element-10 .tab-body-blok-info-element-vnutr {
        border-radius: 10px 0px 0px 10px;
    }

    .tab-body-blok-info-element-11 .tab-body-blok-info-element-vnutr {
        border-radius: 0px 10px 10px 0px;
    }

    .tab-body-blok-info-element-220 .tab-body-blok-info-element-vnutr {
        border-radius: 10px 10px 10px 10px;
    }

    .tab-body-blok-info-row-303 .tab-body-blok-info-element {
        flex: 0 0 24%;
    }

    .tab-body-blok-info-row-304 .tab-body-blok-info-element {
        flex: 0 0 24%;
    }

    .tab-body-blok-info-row-304 .tab-body-blok-info-element-305 {
        flex: 0 0 26%;
    }

    .tab-body-blok-info-row-304 .tab-body-blok-info-element-306 {
        flex: 0 0 26.5%;
    }

    .tab-body-blok-info-row-304 .tab-body-blok-info-element-307 {
        flex: 0 0 48%;
    }

    .tab-body-blok-info-row .tab-body-blok-info-element {
        box-sizing: border-box;
    }

    .tab-body-blok-info-element-vnutr {
        box-sizing: border-box;
    }

    .tab-body-blok-info-row-305 .checkbox-box-zalog {
        flex: 0 0 50%;
    }
}

@media (max-width: 1100px) {
    .tab-body-blok-info-row-2 .tab-body-blok-info-element {
        flex: 0 0 33.333%;
    }

    .tab-body-blok-info-row-4 .tab-body-blok-info-element {
        flex: 0 0 25%;
    }

    .tab-body-blok-info-row-303 .tab-body-blok-info-element {
        flex: 0 0 25%;
    }

    .tab-body-blok-info-row-304 .tab-body-blok-info-element {
        flex: 0 0 25%;
    }

    .tab-body-blok-info-row-304 .tab-body-blok-info-element-305 {
        flex: 0 0 25%;
    }

    .tab-body-blok-info-row-304 .tab-body-blok-info-element-306 {
        flex: 0 0 25%;
    }

    .tab-body-blok-info-row-304 .tab-body-blok-info-element-307 {
        flex: 0 0 50%;
    }
}

@media (max-width: 1030px) {
    .tab-body-blok-info-row-2 .tab-body-blok-info-element {
        flex: 0 0 33.333%;
    }

    .tab-body-blok-info-row-4 {
        flex-wrap: wrap;
    }

    .tab-body-blok-info-row-4 .tab-body-blok-info-element {
        flex: 0 0 33.333%;
        width: 33.333%;
    }

    .tab-body-blok-info-element-16 .tab-body-blok-info-element-vnutr {
        border-radius: 0px 10px 10px 0px;
    }

    .tab-body-blok-info-element-17 .tab-body-blok-info-element-vnutr {
        border-radius: 10px 10px 10px 10px;
    }

    .tab-body-blok-info-element-302 {
        padding-right: 5px;
    }

    .tab-body-blok-info-element-306 {
        padding-right: 5px;
    }

    .tab-body-blok-info-row-303 .tab-body-blok-info-element {
        flex: 0 0 25%;
    }

    .tab-body-blok-info-row-304 .tab-body-blok-info-element {
        flex: 0 0 25%;
    }

    .tab-body-blok-info-row-304 .tab-body-blok-info-element-305 {
        flex: 0 0 25%;
    }

    .tab-body-blok-info-row-304 .tab-body-blok-info-element-306 {
        flex: 0 0 25%;
    }

    .tab-body-blok-info-row-304 .tab-body-blok-info-element-307 {
        flex: 0 0 50%;
    }
}

@media (max-width: 1024px) {
    .tab-body-blok-info-303 {
        margin: 0px 0px 0px 0px;
    }

    .tab-body-blok-info-row-2 .tab-body-blok-info-element {
        flex: 0 0 33.333%;
    }

    .tab-body-blok-info-row-4 .tab-body-blok-info-element {
        flex: 0 0 50%;
        width: 50%;
    }

    .tab-body-blok-info-element-15 .tab-body-blok-info-element-vnutr {
        border-radius: 0px 10px 10px 0px;
    }

    .tab-body-blok-info-element-16 .tab-body-blok-info-element-vnutr {
        border-radius: 10px 0px 0px 10px;
    }

    .tab-body-blok-info-element-17 .tab-body-blok-info-element-vnutr {
        border-radius: 0px 10px 10px 0px;
    }

    .tab-body-blok-info-row-303 {
        flex-wrap: wrap;
    }

    .tab-body-blok-info-row-303 .tab-body-blok-info-element {
        flex: 0 0 50%;
    }

    .tab-body-blok-info-row-303 .tab-body-blok-info-element-302 {
        padding-right: 0;
    }

    .tab-body-blok-info-row-303 .tab-body-blok-info-element-303 {
        padding-left: 0;
    }

    .tab-body-blok-info-row-303 .tab-body-blok-info-element-304 {
        padding-right: 0;
    }

    .tab-body-blok-info-row-303 .tab-body-blok-info-element-306 {
        padding-right: 0;
    }

    .tab-body-blok-info-row-304 {
        flex-wrap: wrap;
    }

    .tab-body-blok-info-row-304 .tab-body-blok-info-element {
        flex: 0 0 50%;
    }

    .tab-body-blok-info-row-304 .tab-body-blok-info-element-305 {
        flex: 0 0 50%;
        order: 1;
    }

    .tab-body-blok-info-row-304 .tab-body-blok-info-element-306 {
        flex: 0 0 50%;
        order: 2;
    }

    .tab-body-blok-info-row-304 .tab-body-blok-info-element-307 {
        flex: 0 0 100%;
        padding-left: 0;
        padding-right: 0;
        margin-bottom: 30px;
        order: 0;
    }

    .tab-body-blok-info-element-302 {
        padding-right: 5px;
    }

    .tab-body-blok-info-element-303 {
        padding-left: 5px;
    }

    .tab-body-blok-info-element-306 {
        padding-right: 3px;
    }
}

@media (max-width: 800px) {
    .tab-body-blok-info-row-1 {
        flex-wrap: wrap;
    }

    .tab-body-blok-info-row-1 .tab-body-blok-info-element {
        flex: 0 0 50%;
    }

    .tab-body-blok-info-row-2 .tab-body-blok-info-element {
        flex: 0 0 50%;
    }

    .tab-body-blok-info-row-4 .tab-body-blok-info-element {
        flex: 0 0 50%;
    }

    .tab-body-blok-info-row-5 {
        flex-wrap: wrap;
    }

    .tab-body-blok-info-row-5 .tab-body-blok-info-element {
        flex: 0 0 50%;
        width: 50%;
    }

    .tab-body-blok-info-row-6 {
        flex-wrap: wrap;
    }

    .tab-body-blok-info-row-6 .tab-body-blok-info-element {
        flex: 0 0 50%;
    }

    .tab-body-blok-info-row-7 {
        flex-wrap: wrap;
        margin: 0px 0px 0px 0px;
    }

    .tab-body-blok-info-row-201 {
        flex-wrap: wrap;
    }

    .tab-body-blok-info-row-201 .tab-body-blok-info-element {
        flex: 0 0 50%;
    }

    .tab-body-blok-info-row-203 {
        flex-wrap: wrap;
    }

    .tab-body-blok-info-row-203 .tab-body-blok-info-element {
        flex: 0 0 50%;
    }

    .tab-body-blok-info-element-1 .tab-body-blok-info-element-vnutr {
        border-radius: 10px 0px 0px 10px;
    }

    .tab-body-blok-info-element-2 .tab-body-blok-info-element-vnutr {
        border-radius: 0px 10px 10px 0px;
    }

    .tab-body-blok-info-element-3 .tab-body-blok-info-element-vnutr {
        border-radius: 10px 10px 10px 10px;
    }

    .tab-body-blok-info-element-4 .tab-body-blok-info-element-vnutr {
        border-radius: 10px 0px 0px 10px;
    }

    .tab-body-blok-info-element-5 .tab-body-blok-info-element-vnutr {
        border-radius: 0px 10px 10px 0px;
    }

    .tab-body-blok-info-element-6 .tab-body-blok-info-element-vnutr {
        border-radius: 10px 0px 0px 10px;
    }

    .tab-body-blok-info-element-7 .tab-body-blok-info-element-vnutr {
        border-radius: 0px 10px 10px 0px;
    }

    .tab-body-blok-info-element-8 .tab-body-blok-info-element-vnutr {
        border-radius: 10px 0px 0px 10px;
    }

    .tab-body-blok-info-element-9 .tab-body-blok-info-element-vnutr {
        border-radius: 0px 10px 10px 0px;
    }

    .tab-body-blok-info-element-10 .tab-body-blok-info-element-vnutr {
        border-radius: 10px 0px 0px 10px;
    }

    .tab-body-blok-info-element-11 .tab-body-blok-info-element-vnutr {
        border-radius: 0px 10px 10px 0px;
    }

    .tab-body-blok-info-element-19 .tab-body-blok-info-element-vnutr {
        border-radius: 0px 10px 10px 0px;
    }

    .tab-body-blok-info-element-20 .tab-body-blok-info-element-vnutr {
        border-radius: 10px 10px 10px 10px;
    }

    .tab-body-blok-info-element-201 .tab-body-blok-info-element-vnutr {
        border-radius: 10px 0px 0px 10px;
    }

    .tab-body-blok-info-element-202 .tab-body-blok-info-element-vnutr {
        border-radius: 0px 10px 10px 0px;
    }

    .tab-body-blok-info-element-203 .tab-body-blok-info-element-vnutr {
        border-radius: 10px 10px 10px 10px;
    }

    .tab-body-blok-info-element-206 .tab-body-blok-info-element-vnutr {
        border-radius: 10px 0px 0px 10px;
    }

    .tab-body-blok-info-element-207 .tab-body-blok-info-element-vnutr {
        border-radius: 0px 10px 10px 0px;
    }

    .tab-body-blok-info-element-208 .tab-body-blok-info-element-vnutr {
        border-radius: 10px 10px 10px 10px;
    }

    .checkbox-box-301 {
        width: 45%;
    }

}

@media (max-width: 767px) {
    .section-calculator-link {
        font-size: 16px;
    }

    .section-calculator-tab-title-item {
        font-size: 16px;
    }
}

@media (max-width: 700px) {
    .section-calculator-link {
        font-size: 15px;
    }

    .tab-body-blok-info-animation-text {
        font-size: 12px;
        line-height: 14px;
    }

    .section-calculator-tab-title-item {
        font-size: 15px;
    }

    .tab-body-blok-info-row-7 .tab-body-blok-info-element {
        flex: 0 0 100%;
    }

    .checkbox-box {
        width: 100%;
    }

    .checkbox-box-301 {
        width: 50%;
    }

    .tab-body-blok-info-row-305 .checkbox-box-zalog {
        flex: 0 0 100%;
        padding: 0px 0px 0px 0px !important;
    }

    .checkbox-box-zalog-1 {
        order: 0;
    }

    .checkbox-box-zalog-2 {
        order: 3;
    }

    .checkbox-box-zalog-3 {
        order: 2;
    }

    .checkbox-box-zalog-4 {
        order: 4;
    }

}

@media (max-width: 640px) {
    .checkbox-box-301 {
        width: 65%;
    }

}

@media (max-width: 600px) {
    .button-step-2 {
        width: 100%;
        margin-top: 10px;
    }

    .checkbox-box-301 {
        width: 100% !important;
        margin: 0px 0px 20px 0px;
    }

    .button-step-301,
    .button-step-21,
    .button-step-22,
    .button-step-23,
    .button-step-201,
    .button-step-202 {
        width: 100% !important;
    }

    .tab-body-blok-info-row-6 .tab-body-blok-info-element {
        flex: 0 0 100% !important;
        margin: 0px 0px 5px 0px;
    }

    .tab-body-blok-info-row-6 .tab-body-blok-info-element-22 {
        margin: 0px 0px 20px 0px;
    }

    .tab-body-blok-info-row-7 .tab-body-blok-info-element {
        margin: 0px 0px 5px 0px;
    }

    .tab-body-blok-info-row-1 .tab-body-blok-info-element {
        flex: 0 0 100%;
        margin: 0px 0px 5px 0px;
    }

    .tab-body-blok-info-row-2 .tab-body-blok-info-element {
        flex: 0 0 100%;
        margin: 0px 0px 5px 0px;
    }

    .tab-body-blok-info-row-3 {
        flex-wrap: wrap;
    }

    .tab-body-blok-info-row-3 .tab-body-blok-info-element {
        flex: 0 0 100%;
        margin: 0px 0px 5px 0px;
    }

    .tab-body-blok-info-row-4 .tab-body-blok-info-element {
        flex: 0 0 100%;
        width: 100%;
        margin: 0px 0px 5px 0px;
    }

    .tab-body-blok-info-row-5 .tab-body-blok-info-element {
        flex: 0 0 100%;
        width: 100%;
        margin: 0px 0px 5px 0px;
    }

    .tab-body-blok-info-row-201 .tab-body-blok-info-element {
        flex: 0 0 100%;
    }

    .tab-body-blok-info-row-202 {
        flex-wrap: wrap;
    }

    .tab-body-blok-info-row-202 .tab-body-blok-info-element {
        flex: 0 0 100%;
    }

    .tab-body-blok-info-row-203 .tab-body-blok-info-element {
        flex: 0 0 100%;
    }

    .tab-body-blok-info-row .tab-body-blok-info-element {
        flex: 0 0 100%;
        margin: 0px 0px 5px 0px;
    }

    .tab-body-blok-info-element .tab-body-blok-info-element-vnutr {
        border-radius: 10px 10px 10px 10px;
    }

    .tab-body-blok-info-row .tab-body-blok-info-element {
        flex: 0 0 100%;
        padding-left: 0;
        padding-right: 0;
    }

    .tab-body-blok-info-row-304 .tab-body-blok-info-element-307 {
        margin-bottom: 30px;
    }

    .tab-body-blok-contant-401 {
        width: 100%;
        margin: 20px auto 0px auto;
    }

    .tab-body-4-blok-dopinfo-col {
        flex: 0 0 100%;
    }

    .icon-home-gray {
        margin: 0px 0px 0px 0px;
    }

    .tab-body-4-blok-dopinfo-text-1 {
        margin: 0px 0px 20px 0px;
    }

    .checkbox-box-301 {
        margin-top: 10px;
    }

}

@media (max-width: 599px) {
    .tab-body-blok-info-animation-2 {
        flex-direction: column;
    }

    .tab-body-blok-info-animation-col {
        padding: 0px 0px 0px 0px;
        width: 100%;
    }

    #tab-body-blok-info-animation-link {
        margin-top: 0px !important;
    }

    .tab-body-blok-info-animation-text-3 {
        padding: 20px 0px 10px 30px;
    }

    .tab-body-blok-info-5 {
        margin: 20px 0px 0px 0px;
    }

    .tab-body-blok-info-animation-link-2 {
        padding-left: 30px;
    }
}

@media (max-width: 500px) {
    .section-calculator {
        margin: 50px auto 30px auto;
    }

    .section-calculator-tab {
        margin: 30px 0px 0px 0px;
    }

    .section-calculator-link {
        margin: 0px 0px 0px 20px;
    }

    .section-calculator-tab-title {
        padding: 0px 20px 0px 20px;
    }

    .tab-body-blok-info {
        margin: 15px 0px 0px 0px;
    }

    .calculator-tab-body-blok {
        padding: 20px 20px 30px 20px;
    }

    .section-calculator-link {
        font-size: 12px;
    }

    .section-calculator-tab-title-item {
        font-size: 12px;
    }

    .tab-body-blok-info-row-303 {
        padding: 0px 0px 0px 0px !important;
    }

    .tab-body-blok-info-row .tab-body-blok-info-element {
        margin: 0px 0px 5px 0px !important;
        padding: 0px 0px 0px 0px !important;
        height: 64px;
    }

    #tab-body-blok-info-303 .tab-body-blok-info-element {
        height: auto;
    }
}

@media (max-width: 475px) {}

@media (max-width: 428px) {
    .section-calculator-tab {
        margin: 30px 0px 0px 0px;
    }

    .section-calculator-tab-title {
        margin: 0px 0px 30px 0px;
    }

    .section-calculator-link {
        margin: 0px 0px 0px 20px;
    }
}

@media (max-width: 390px) {
    .section-calculator-link {
        padding: 0px 0px 0px 15px;
        font-size: 11px;
    }

    .section-calculator-tab-title-item {
        font-size: 11px;
        line-height: 16px;
        padding: 0px 0px 0px 0px;
    }

}

@media (max-width: 389px) {
    .calculator-tab-body-blok-title {
        font-size: 15px;
        line-height: 16px;
    }
}

@media (max-width: 359px) {
    .calculator-tab-body-blok-title {
        font-size: 13px;
    }
}

@media (max-width: 340px) {
    .calculator-tab-body-blok-title {
        font-size: 12px;
    }
}

@media (max-width: 320px) {
    .calculator-tab-body-blok-title {
        font-size: 11px;
    }
}


/***********************
****** PAGE CALCULATOR-FINISH ********
***************************/
/**********************/
.one-ekran-calculator-finish {
    margin-bottom: 0px;
    height: 600px;
    background-position: top center;
}

/******************/
.section-calculator-finish {
    width: 1920px;
    margin: -240px auto 120px auto;
    padding: 0px 0px 0px 0px;
}

.section-calculator-finish-contant {
    position: relative;
    z-index: 1;
    width: 600px;
    margin: 0px auto 0px auto;
    padding: 30px 30px 30px 30px;
    border-radius: 30px;
    background: #fff;
}

.section-calculator-finish-text {
    font-size: 16px;
    font-weight: 400;
    line-height: 20px;
    letter-spacing: 0em;
    text-align: left;
}

.section-calculator-finish-blok-info {
    width: 100%;
    margin: 30px 0px 30px 0px;
    padding: 20px 20px 20px 20px;
    border: 2px solid #000;
    border-radius: 10px;
}

/*
.section-calculator-finish-blok-info-2,.section-calculator-finish-blok-info-3{
    display: none;
}
*/
.tab-body-blok-info-403 {
    display: none;
}

.finish-blok-info-image {
    display: flex;
    align-items: center;
    margin: 0px 0px 10px 0px;
}

.finish-blok-info-image img {
    margin: 0px 10px 0px 0px;
}

.finish-blok-info-polis {}

.tab-body-blok-info-401-element {
    display: flex;
    align-items: flex-end;
}

.section-calculator-finish-blok-info-text {
    font-size: 11px;
    font-weight: 400;
    line-height: 14px;
    letter-spacing: 0em;
    text-align: left;
    color: #828282;
}

.section-calculator-finish-blok-info-text-3 {
    margin: 0px 0px 0px 10px;
    font-size: 14px;
    font-weight: 700;
    line-height: 14px;
    letter-spacing: 0em;
    text-align: left;
}

.section-calculator-finish-blok-info-text-4 {
    margin: 0px 0px 0px 10px;
    font-size: 14px;
    font-weight: 700;
    line-height: 14px;
    letter-spacing: 0em;
    text-align: left;
}

.button-step-500 {
    width: 100%;
    opacity: 0.7;
}

@media (max-width: 1920px) {
    .section-calculator-finish {
        width: 100%;
    }
}

@media (max-width: 1366px) {
    .one-ekran-calculator-finish {
        height: 584px;
    }

    .section-calculator-finish {
        margin: -290px auto 120px auto;
    }
}

@media (max-width: 1280px) {
    .one-ekran-calculator-finish {
        height: 584px;
        background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
    }

    .section-calculator-finish {
        margin: -300px auto 100px auto;
    }

    .section-calculator-finish-contant {
        width: 502px;
    }
}

@media (max-width: 1080px) {
    .one-ekran-calculator-finish {
        height: 550px;
    }
}

@media (max-width: 1024px) {
    .one-ekran-calculator-finish {
        height: 510px;
    }

    .section-calculator-finish {
        margin: -260px auto 100px auto;
    }
}

@media (max-width: 900px) {
    .one-ekran-calculator-finish {
        height: 500px;
    }

    .section-calculator-finish {
        margin: -270px auto 100px auto;
    }
}

@media (max-width: 899px) {
    .one-ekran-calculator-finish {
        height: 480px;
    }

}

@media (max-width: 899px) {
    .section-calculator-finish-contant {
        width: 100%;
    }

    .section-calculator-finish {
        margin: -250px auto 100px auto;
    }
}

/***********************
****** PAGE PRAVOINFO ********
***************************/

/***** one-ekran-pravo ******/
.one-ekran-pravo {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
}

/********** two-ekran-pravo **********/
.two-ekran-pravo {
    position: relative;
    width: 1920px;
    margin: -200px auto 100px auto;
    padding: 0px 0px 0px 0px;
}

.two-ekran-pravo-contant {
    width: 100%;
}

.pravo-tab {
    width: 100%;
}

.pravo-tab-title {
    width: 100%;
    padding: 0px 20px 0px 20px;
    margin: 0px 0px 40px 0px;
    display: flex;
    justify-content: space-between;
}

.pravo-tab-title-item {
    flex: 0 0 33.333%;
}

.pravo-tab-title-item-2 {
    text-align: center;
}

.pravo-tab-title-item-3 {
    text-align: right;
}

.pravo-tab-title-link {
    display: inline-block;
    width: auto;
    font-size: 18px;
    font-weight: 400;
    line-height: 20px;
    letter-spacing: 0em;
    color: #828282;
    padding: 0px 0px 2px 0px;
    border-bottom: 2px solid #828282;
    transition-duration: 0.5s;
    cursor: pointer;
}

.pravo-tab-title-link:hover {
    color: #000;
    border-color: #000;
}

.pravo-tab-title-link-1 {
    color: #000;
    border-color: #000;
}

.pravo-tab-body {
    width: 100%;
    margin: 0px 0px 0px 0px;
    padding: 40px 30px 40px 30px;
    background: #fff;
    border-radius: 30px;
}

.pravo-tab-body-item {
    width: 100%;
    display: block;
}

.pravo-tab-body-item-2 {
    display: none;
}

.pravo-tab-body-item-3 {
    display: none;
}

.h2-ravo {
    text-align: left;
}

.pravo-tab-blok-text {
    width: 100%;
    margin: 30px 0px 0px 0px;
}

.pravo-tab-blok-text-1 {
    margin: 0px 0px 10px 0px;
    font-size: 16px;
    font-weight: 400;
    line-height: 20px;
    letter-spacing: 0em;
    text-align: left;
    color: #000;
}

.pravo-tab-blok-text-2 {
    margin: 0px 0px 20px 0px;
    font-size: 14px;
    font-weight: 300;
    line-height: 17px;
    letter-spacing: 0em;
    text-align: left;
    color: #828282;
}

.pravo-tab-blok-link {
    width: 100%;
    display: flex;
    flex-direction: column;
}

.pravo-tab-link {
    margin: 0px 0px 15px 0px;
    text-decoration: underline;
    transition-duration: 0.5s;
}

.pravo-tab-link:hover {
    color: #828282;
}

@media (max-width: 1920px) {
    .two-ekran-pravo {
        width: 100%;
    }
}

@media (max-width: 1366px) {
    .two-ekran-pravo {
        margin: -270px auto 100px auto;
    }
}

@media (max-width: 1280px) {
    .one-ekran-pravo {
        height: 550px;
    }

    .two-ekran-pravo {
        margin: -270px auto 100px auto;
    }
}

@media (max-width: 1100px) {
    .one-ekran-pravo {
        height: 500px;
    }

    .two-ekran-pravo {
        margin: -250px auto 70px auto;
    }
}

@media (max-width: 1024px) {
    .one-ekran-pravo {
        height: 450px;
    }

    .two-ekran-pravo {
        margin: -230px auto 60px auto;
    }
}

@media (max-width: 900px) {
    .one-ekran-pravo {
        height: 400px;
    }

    .two-ekran-pravo {
        margin: -200px auto 60px auto;
    }

    .pravo-tab-title {
        padding: 0px 0px 0px 0px;
        margin: 0px 0px 20px 0px;
    }
}

@media (max-width: 768px) {
    .one-ekran-pravo {
        height: 380px;
    }
}

@media (max-width: 700px) {
    .pravo-tab-title-link {
        font-size: 16px;
    }
}

@media (max-width: 600px) {
    .pravo-tab-title-item {
        flex: 0 0 auto;
    }

    .pravo-tab-title-link {
        font-size: 15px;
    }
}

@media (max-width: 500px) {
    .two-ekran-pravo {
        margin: -160px auto 60px auto;
    }

    .one-ekran-pravo-contant {
        padding: 150px 0px 0px 0px;
    }

    .pravo-tab-title {
        padding: 0px 20px 0px 20px;
        margin: 0px 0px 20px 0px;
    }
}

@media (max-width: 428px) {
    .pravo-tab-title {
        flex-direction: column;
        align-items: flex-start;
    }

    .pravo-tab-title-item {
        margin: 0px 0px 10px 0px;
    }

    .pravo-tab-body {
        padding: 30px 20px 30px 20px;
    }
}

@media (max-width: 424px) {
    .one-ekran-pravo {
        height: 430px;
    }

    .two-ekran-pravo {
        margin: -170px auto 60px auto;
    }
}

/**********************
******** PAGE LENDING **********
**********************/
/****** one-ekran-lending ********/
.one-ekran-lending {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_11___});
}

.one-ekran-contant-lending {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
}

.h1-lending-2 {
    display: none;
}

.button-lending {
    width: 460px;
    margin: 40px 0px 0px 0px;
}

.button-lending-1,
.button-lending-2,
.button-lending-3 {
    width: 100%;
    margin: 0px 0px 0px 0px;
}

.one-ekran-contant-lending-step {
    margin: -440px auto 0px auto;
    padding: 30px 30px 30px 30px;
    width: 600px;
    height: auto;
    z-index: 1;
    position: relative;
    display: none;
    border-radius: 30px;
    background: #fff;
}

.one-ekran-contant-text-02 {
    display: none;
}

.one-ekran-contant-lending-step-2 {
    display: none;
}

.one-ekran-contant-lending-step-3 {
    display: none;
}

.lending-step-text {
    margin: 0px 0px 20px 0px;
    font-size: 16px;
    font-weight: 400;
    line-height: 20px;
    letter-spacing: 0em;
    text-align: left;
    color: #000;
}

.lending-step-text-2 {
    margin: 0px 0px 5px 0px;
    font-size: 11px;
    font-weight: 400;
    line-height: 14px;
    letter-spacing: 0em;
    text-align: left;
    color: #000;
}

.one-ryad-popup-user-9 {
    height: 79px;
    margin: 0px 0px 3px 0px;
    border-radius: 10px 10px 0px 0px;
}

.one-ryad-popup-user-10 {
    height: 79px;
    margin: 0px 0px 3px 0px;
    border-radius: 0px 0px 0px 0px;
}

.one-ryad-popup-user-11 {
    margin: 0px 0px 3px 0px;
    border-radius: 0px 0px 0px 0px;
}

.one-ryad-popup-user-12 {
    margin: 0px 0px 20px 0px;
    border-radius: 0px 0px 10px 10px;
}

.one-ryad-popup-user-15 {
    margin: 0px 0px 3px 0px;
    border-radius: 10px 10px 0px 0px;
}

.one-ryad-popup-user-16 {
    margin: 0px 0px 3px 0px;
    border-radius: 0px 0px 0px 0px;
}

.one-ryad-popup-user-17 {
    height: 89px;
    margin: 0px 0px 20px 0px;
    border-radius: 0px 0px 10px 10px;
}

.pole-popup-00::placeholder {
    color: #000000;
    opacity: 1;
}

.lending-step-text-row {
    margin: 0px 0px 20px 0px;
    width: 100%;
    display: flex;
    justify-content: space-between;
}

.lending-step-text-item {
    height: 79px;
    flex: 0 0 50%;
    cursor: pointer;
}

.lending-step-text-item-1 {
    padding: 0px 5px 0px 0px;
}

.lending-step-text-item-2 {
    padding: 0px 0px 0px 5px;
}

.lending-step-text-item-vnutr {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 10px;
    background: #f5f5f5;
    border: 2px solid #f5f5f5;
    cursor: pointer;
}

.lending-step-text-item img {
    margin: 0px 10px 0px 0px;
}

.lending-step-text-3 {
    font-weight: 400 !important;
    font-size: 16px !important;
    line-height: 20px !important;
    color: #000000 !important;
    display: flex;
    align-items: center;
}

.checked-1 {
    border: 2px solid rgb(0, 0, 0);
}

.checkbox-1-1 {
    opacity: 0;
}

.checkbox-1-2 {
    opacity: 0;
}

.checkbox-1-3-box {
    position: relative;
    display: flex;
    padding: 0px 0px 0px 0px;
    margin: 0px 0px 30px 0px;
}

.checkbox-1-3-box label {
    cursor: pointer;
    margin: 0px 0px 0px 40px;
}

.checkbox-1-3 {
    cursor: pointer;
    margin: 0px 20px 0px 0px;
}

.one-ryad-popup-user-13 {
    margin: 0px 0px 3px 0px;
    border-radius: 10px 10px 0px 0px;
}

.one-ryad-popup-user-14 {
    margin: 0px 0px 20px 0px;
    border-radius: 0px 0px 10px 10px;
}

@media (max-width: 1600px) {
    .one-ekran-contant-lending-step {
        margin: -320px auto 0px auto;
    }
}

@media (max-width: 1366px) {
    .one-ekran-contant-lending-step {
        margin: -280px auto 0px auto;
    }
}

@media (max-width: 1280px) {

    .one-ekran-lending-2 {
        background-image: url(${___CSS_LOADER_URL_REPLACEMENT_12___});
    }

    .one-ekran-lending {
        background-image: url(${___CSS_LOADER_URL_REPLACEMENT_13___});
    }

    .one-ekran-contant-lending-step {
        margin: -240px auto 0px auto;
    }
}

@media (max-width: 1024px) {
    .one-ekran-contant-lending {
        padding: 160px 0px 0px 0px
    }

    .one-ekran-contant-lending-step {
        margin: -170px auto 0px auto;
    }
}

@media (max-width: 899px) {
    .one-ekran-contant-lending {
        padding: 180px 0px 0px 0px
    }

    .one-ekran-lending {
        height: 500px;
    }

    .one-ekran-contant-lending-step {
        margin: -170px auto 0px auto;
    }
}

@media (max-width: 700px) {
    .one-ekran-contant-lending-step {
        width: 100%;
    }
}

@media (max-width: 600px) {
    .one-ekran-contant-lending-step {
        margin: -50px auto 0px auto;
    }
}

@media (max-width: 500px) {
    .one-ekran-lending {
        height: 450px;
        margin: 20px auto 0px auto;
        border-radius: 50px 50px 50px 50px;
    }

    .button-lending {
        width: 100%;
    }

    .lending-step-text-row {
        flex-direction: column;
    }

    .lending-step-text-item {
        padding: 0px 0px 0px 0px;
    }

    .lending-step-text-item-vnutr {
        height: 79px;
    }
}

@media (max-width: 428px) {
    .one-ekran-contant-lending-step {
        padding: 30px 20px 30px 20px;
    }

    .one-ryad-popup-user-9,
    .one-ryad-popup-user-10 {
        height: 69px;
    }

    .lending-step-text-item-vnutr {
        height: 69px;
    }
}

@media (max-width: 414px) {
    .one-ekran-contant-lending {
        padding: 140px 0px 0px 0px;
    }
}

@media (max-width: 375px) {
    .one-ekran-contant-lending {
        padding: 110px 0px 0px 0px;
    }
}

/**********************/
.two-ekran-lending {
    width: 1920px;
    padding: 120px 0px 90px 0px;
    margin: 0px auto 0px auto;
}

.two-ekran-lending-contant {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
}

.two-ekran-lending-contant-item {
    flex: 0 0 20%;
    margin: 0px 0px 30px 0px;
}

.two-ekran-lending-contant-item-1 {
    flex: 0 0 20%;
}

.two-ekran-lending-contant-item-2 {
    flex: 0 0 20%;
    text-align: center;
}

.two-ekran-lending-contant-item-3 {
    flex: 0 0 20%;
    text-align: center;
}

.two-ekran-lending-contant-item-4 {
    flex: 0 0 20%;
    text-align: center;
}

.two-ekran-lending-contant-item-5 {
    flex: 0 0 20%;
    text-align: right;
}

.two-ekran-lending-contant-item-6 {
    flex: 0 0 16.666%;
}

.two-ekran-lending-contant-item-7 {
    flex: 0 0 16.666%;
    text-align: center;
}

.two-ekran-lending-contant-item-8 {
    flex: 0 0 16.666%;
    text-align: center;
}

.two-ekran-lending-contant-item-9 {
    flex: 0 0 16.666%;
    text-align: center;
}

.two-ekran-lending-contant-item-10 {
    flex: 0 0 16.666%;
    text-align: center;
}

.two-ekran-lending-contant-item-11 {
    flex: 0 0 16.666%;
    text-align: right;
}


@media (max-width: 1920px) {
    .two-ekran-lending {
        width: 100%;
    }
}

@media (max-width: 1280px) {
    .two-ekran-lending {
        padding: 100px 0px 70px 0px;
    }
}

@media (max-width: 1100px) {
    .two-ekran-lending {
        padding: 80px 0px 50px 0px;
    }
}

@media (max-width: 900px) {
    .two-ekran-lending-contant {
        justify-content: center;
    }

    .two-ekran-lending-contant-item-6 {
        flex: 0 0 25%;
    }

    .two-ekran-lending-contant-item-7 {
        flex: 0 0 25%;
        text-align: center;
    }

    .two-ekran-lending-contant-item-8 {
        flex: 0 0 25%;
        text-align: center;
    }

    .two-ekran-lending-contant-item-10 {
        flex: 0 0 25%;
        text-align: center;
    }

    .two-ekran-lending-contant-item-11 {
        flex: 0 0 25%;
        text-align: right;
    }
}

@media (max-width: 768px) {
    .two-ekran-lending-contant-item {
        flex: 0 0 25%;
    }

    .two-ekran-lending-contant-item-1 {}

    .two-ekran-lending-contant-item-2 {
        text-align: center;
    }

    .two-ekran-lending-contant-item-3 {
        text-align: center;
    }

    .two-ekran-lending-contant-item-4 {
        text-align: right;
    }

    .two-ekran-lending-contant-item-5 {
        text-align: left;
    }

    .two-ekran-lending-contant-item-6 {
        text-align: center;
    }

    .two-ekran-lending-contant-item-7 {
        text-align: center;
    }

    .two-ekran-lending-contant-item-8 {
        text-align: right;
    }

    .two-ekran-lending-contant-item-9 {
        text-align: left;
    }

    .two-ekran-lending-contant-item-10 {
        text-align: center;
    }

    .two-ekran-lending-contant-item-11 {
        text-align: right;
    }
}

@media (max-width: 600px) {
    .two-ekran-lending-contant-item {
        flex: 0 0 33.333%;
    }

    .two-ekran-lending-contant-item-1 {
        text-align: left;
    }

    .two-ekran-lending-contant-item-2 {
        text-align: center;
    }

    .two-ekran-lending-contant-item-3 {
        text-align: center;
    }

    .two-ekran-lending-contant-item-4 {
        text-align: left;
    }

    .two-ekran-lending-contant-item-5 {
        text-align: center;
    }

    .two-ekran-lending-contant-item-6 {
        text-align: center;
    }

    .two-ekran-lending-contant-item-7 {
        text-align: left;
    }

    .two-ekran-lending-contant-item-8 {
        text-align: center;
    }

    .two-ekran-lending-contant-item-9 {
        text-align: center;
    }

    .two-ekran-lending-contant-item-10 {
        text-align: left;
    }

    .two-ekran-lending-contant-item-11 {
        text-align: right;
    }
}

@media (max-width: 500px) {
    .two-ekran-lending-contant-item {
        flex: 0 0 50%;
        text-align: center;
    }
}

@media (max-width: 359px) {
    .two-ekran-lending-contant-item {
        flex: 0 0 100%;
    }
}

/************************
******** PAGE  INDEX-2 ***********
************************/
.section-calculator-finish-2 {
    margin: -370px auto 120px auto;
}

.section-calculator-finish-2-contant {
    width: 100%;
    display: flex;
    flex-direction: row;
    padding: 0px 0px 0px 0px;
    border-radius: 30px;
    background: none;
    box-sizing: border-box;
}

.section-calculator-finish-2-contant-col {
    flex: 0 0 50%;
}

.section-calculator-finish-2-contant-col-1 {
    padding: 0px 10px 0px 0px;
}

.section-calculator-finish-2-contant-col-2 {
    padding: 0px 0px 0px 10px;
}

.section-calculator-finish-2-contant-col-vnutr {
    text-align: left;
    padding: 20px 20px 20px 20px;
    border-radius: 30px;
    background: #fff;
}

.section-calculator-finish-2-contant-col-vnutr-111 {
    height: 100%;
}

.form-111 {
    flex-direction: column;
    margin: 0px 0px 0px 0px;
}

.form-111 .form-1-col {
    background: #f5f5f5;
    margin: 0px 0px 5px 0px;
}

.form-111 .dropdown__button {
    background: #f5f5f5;
}

.form-111 .pole {
    background: #f5f5f5;
}

.form-111 .form-1-col-1 {
    border-radius: 10px 10px 0px 0px;
}

.form-111 .form-1-col-2 {
    border-radius: 0px 0px 0px 0px;
}

.form-111 .form-1-col-3 {
    border-radius: 0px 0px 10px 10px;
    margin: 0px 0px 20px 0px;
}

.checkbox-1-111{
    opacity: 1;
    background: linear-gradient(0deg, rgba(255, 255, 255, 0.5), rgba(255, 255, 255, 0.5)), #FFEB39!important;
    /* background-color: #FFEB39 */
}
.checkbox-1-112{
    opacity: 0.1;
    background: linear-gradient(0deg, rgba(255, 255, 255, 0.5), rgba(255, 255, 255, 0.5)), #FFEB39!important;
}
.checked-111 {
    opacity: 0.1;
}


.checked-112 {
    opacity: 1;
}

.button-111 {
    background: #fff;
    border: 2px solid #828282;
    color: #828282;
}

.button-111:visited {
    background: none;
    border: 2px solid #828282;
    color: #000;
}

.tab-body-blok-info-row-2-111 {
    display: flex;
}

.tab-body-blok-info-row-2-111 .tab-body-blok-info-element {
    flex: 0 0 50% !important;
}

.tab-body-blok-info-row-2-111 .tab-body-blok-info-element-4 {
    padding: 0px 3px 0px 0px;
}

.tab-body-blok-info-row-2-111 .tab-body-blok-info-element-5 {
    padding: 0px 0px 0px 3px;
}

.tab-body-blok-info-row-2-111 .tab-body-blok-info-element-5 .tab-body-blok-info-element-vnutr {
    border-radius: 0px 10px 10px 0px;
    height: 100%;
}

.form-1-col-111 {
    width: 100%;
    flex: 0 0 50% !important;
}

.checked-1111 {
    display: flex;
}

.checked-1112 {
    opacity: 1;

}

#tab-body-blok-info-401-111 {
    margin: 20px 0px 0px 0px;
}

.block-111 {
    display: flex;
}

.banner-text {
    position: absolute;
    right: 20px;
    top: -10px;
    background: #FFEB39;
    text-align: center;
    width: 120px;
    font-size: 11px;
    padding: 3px 0px 3px 0px;
}

.banner-text-2 {
    background: #8a8a8a;
    color: #fff;
}

.tab-body-blok-info-401 {
    position: relative;
}

#tab-body-blok-info-401-112,
#tab-body-blok-info-401-113,
#tab-body-blok-info-401-114 {
    border: 2px solid #828282;
}

#tab-body-4-dopinfo-link-111 {
    display: flex;
    margin: 30px 0px 0px 0px;
    width: 140px;
}

#tab-body-4-dopinfo-link-112 {
    display: block;
    margin: 30px 0px 0px 0px;
    width: 140px;
}

.tab-body-4-dopinfo-link-112 img {
    transform: rotate(180deg);
}

.blok-1111 {
    display: block;
    flex-direction: column;
}

.block-11111 {
    display: flex;
    flex-direction: column;
    align-items: center;
}

.block-11112 {
    display: flex;
}

.tab-body-4-dopinfo-blok-link-111 {
    width: 100%;
    display: block;
    justify-content: center;
}

.icon-down-arrow-401-111 {
    transform: rotate(0deg);
    transition: .3s;
}

#tab-body-blok-info-401-112 {
    margin: 10px 0px 20px 0px;
}

#tab-body-blok-info-401-113 {
    margin: 0px 0px 20px 0px;
}

.tab-body-blok-info-401-element-2-000 {
    display: block;
    padding: 20px 20px 30px 20px;

}

.tab-body-blok-info-401-element-2-111 {
    display: block;
    cursor: pointer;
    position: relative;
    /*opacity: 0.6;*/
}

#tab-body-blok-info-401-element-2-112 {
    position: relative;
    display: none;
    cursor: pointer;
}

.checked-111111 {
    display: block;
}

.plus-2 {
    position: absolute;
    right: 0;
}

.plus-3 {
    position: absolute;
    right: 0;
}

.form-1-col-1111 {
    flex: 0 0 100%;
    padding: 5px 20px 5px 0px;
    margin: 0px 0px 0px 0px;
}

.form-1-col-1111 .dropdown__button {
    color: #000;
}

/*.tab-body-blok-info-401-element-1111{
    align-items: flex-start;
    box-sizing: border-box;
}*/

.dropdown-111 {
    display: flex;
    align-items: flex-start;
}

.bank-image-2 {
    width: 18px !important;
}

.tab-body-blok-info-401-element-1111 img {
    width: 22px;
    margin: 0px 10px 0px 0px;
}

.dropdown__list-111 {
    top: 50px;
}

.img-1 {}

.img-2 {
    display: none;
}

.img-3 {
    display: none;
}

.img-4 {
    display: none;
}

.dropdown__list-item-111 {
    text-align: left;
    justify-content: flex-start;
    align-items: center;
}

.dropdown__list-item-111 span {
    margin: 4px 0px 0px 10px;
    color: #828282;
}

.dropdown__button-111 span {
    color: #828282;
    font-size: 11px;
}

.tab-body-blok-info-animation-text-111 {
    margin: 100px 0px 0px 0px;
    padding: 20px 20px 20px 35px;
    border: 2px solid #ccc;
    background-position: 5px center;
    border-radius: 20px;
}

.tab-body-blok-info-animation-text-2-1111 {
    margin: 10px 0px 0px 0px;
}

.tab-body-4-blok-price-111 {
    width: auto;
    font-size: 13px;
    margin: 0px 0px -15px auto;
}

.tab-body-blok-info-animation-111 {
    justify-content: space-between;
    height: 100%;
    padding: 120px 0px 0px 0px;
}

@media (max-width: 1366px) {
    .section-calculator-finish-2 {
        margin: -300px auto 120px auto;
    }

    .tab-body-blok-info-row-2-111 .tab-body-blok-info-element {
        flex: 0 0 100% !important;
    }

    .tab-body-blok-info-row-2-111 .tab-body-blok-info-element-4 {
        padding: 0px 0px 0px 0px;
        margin: 0px 0px 5px 0px;
    }

    .tab-body-blok-info-element-4-111 .tab-body-blok-info-element-vnutr {
        border-radius: 10px 10px 0px 0px;
    }

    .tab-body-blok-info-element-5-111 .form-1-col-111 .tab-body-blok-info-element-vnutr {
        border-radius: 0px 0px 10px 10px;
    }

    .tab-body-blok-info-row-2-111 .tab-body-blok-info-element-5 {
        padding: 0px 0px 0px 0px;
    }
}

@media (max-width: 1280px) {
    .section-calculator-finish-2 {
        margin: -250px auto 80px auto;
    }
}

@media (max-width: 1024px) {
    .lending-step-text-row-111 {
        flex-wrap: wrap;
    }

    .lending-step-text-row-111 .lending-step-text-item {
        flex: 0 0 100%;
        margin: 0px 0px 5px 0px;
        padding: 0px 0px 0px 0px;
    }
}

@media (max-width: 899px) {
    .section-calculator-finish-2-111 {
        margin: -300px auto 100px auto;
    }

    .lending-step-text-row-111 {
        flex-wrap: wrap;
        flex-direction: column;
        margin-top: 170px;
        box-sizing: border-box;
    }

    .lending-step-text-row-111 .lending-step-text-item {
        height: 79px;
        margin: 0px 0px 0px 0px;
    }

    .lending-step-text-row-111 .lending-step-text-item-1 {
        height: 79px;
        margin: 0px 0px 5px 0px;
    }

    .section-calculator-finish-2-contant-col-1 {
        padding: 0px 2px 0px 0px;
    }

    .section-calculator-finish-2-contant-col-2 {
        padding: 0px 0px 0px 2px;
    }

    .section-calculator-finish-2-contant-col {
        flex: 0 0 50%;
    }

    .form-111 {
        width: 100%;
    }
}

@media (max-width: 830px) {
    .section-calculator-finish-2-contant-111 {
        flex-direction: column;
    }

    .section-calculator-finish-2-contant-col-1 {
        padding: 0px 0px 0px 0px;
    }

    .section-calculator-finish-2-contant-col-2 {
        padding: 0px 0px 0px 0px;
        margin: 30px 0px 0px 0px;
    }
}

@media (max-width: 500px) {
    .section-calculator-finish-2-contant-col-1 .section-calculator-finish-2-contant-col-vnutr {
        padding: 20px 20px 20px 20px;
    }

    .lending-step-text-row-111 {
        margin-top: 0px;
    }

    .form-111 {
        padding: 0px 0px 0px 0px;
    }
}


/* srg */
.addr_sugg {
    width: 100%;
}

.btn_calc_active {
    opacity: 0 !important;
}

.button-novostroiki-2 {
    background: #fff59c;
    width: 450px;
}

.policy_card:nth-child(n + 2) {
    margin-top: 20px;
}

.cntr_iframe {
    position: absolute;
    z-index: 10;
    top: 0;
    left: 0;
    background-color: #fff;
}

.container-pay {
    padding-left: 20vw;
    padding-top: 10vh;
    width: 60vw;
}

.iframe_pay {
    width: 100vw;
    height: 100vh;
}

.redBorder {
    border: 1px solid rgba(255, 0, 0, 0.4);
    box-sizing: border-box;
}

.txt_a_l {
    text-align: left;
}

.w_100 {
    width: 100%;
}

.popup_question {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);

    margin: 20px auto 20px auto;
    width: 390px;
    height: auto;
    padding: 20px;
    background: #fff;
    border: 0px solid #92B96A;
    border-radius: 30px;
    box-shadow: 0px 0px 10px #000;
    z-index: 1007;
}

.p-r {
    position: relative;
}

.cur-p {
    cursor: pointer;
}

.over_scroll_x {
    overflow-y: scroll;
}

.mt-10 {
    margin-top: 10px;
}

.txt_nowrap {
    white-space: nowrap;
}

.z-i {
    z-index: 1000;
}

@media (max-width: 768px) {
    .cntr_btn_repeat_sms_desk {
        display: none;
    }

    .txt_send_sms {
        font-family: 'Geologica';
        font-style: normal;
        font-weight: 400;
        font-size: 11px;
        /*color: #828282;*/
        color: #000;
        position: relative;
    }

    .cntr_btn_repeat_sms_mobil {
        margin-bottom: 10px;
    }
}

@media (min-width: 768px) {
    .txt_send_sms {
        font-family: 'Geologica';
        font-style: normal;
        font-weight: 400;
        font-size: 11px;
        /*color: #828282;*/
        color: #000;
        position: absolute;
        bottom: -20px;
        left: 50%;
        transform: translateX(-50%);
    }

    .cntr_btn_repeat_sms_mobil {
        display: none;
    }
}

.t_a_l {
    text-align: left;
}

.p-10 {
    padding: 10px !important;
}


.tab-body-blok-info-animation-text-25 {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_14___});
}

@-moz-document url-prefix() {
    @media (max-width: 1680px) {
        .tab-body-blok-info-row-2 .tab-body-blok-info-element {
            flex: 0 0 33.333%;
        }
    }
}

.cntr_discount {
    display: flex;

}

.btn_table_delete {
    border: none;
    border-radius: 4px;
    padding: 3px;
    background: #4f4f4f;
    color: #fff;
    font-size: 14px;
}

.btn_table_delete:hover {
    box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.2);
}`, "",{"version":3,"sources":["webpack://./src/static/css/main.css"],"names":[],"mappings":"AAAA;IACI,SAAS;IACT,UAAU;IACV,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,oCAAoC;IACpC,mBAAmB;AACvB;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,qBAAqB;IACrB,eAAe;AACnB;;AAEA,6BAA6B;AAC7B;IACI,UAAU;IACV,aAAa;IACb,wBAAwB;IACxB,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,2BAA2B;IAC3B,uBAAuB;IACvB,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,aAAa;IACb,2BAA2B;AAC/B;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,yBAAyB;AAC7B;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,yBAAyB;AAC7B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,aAAa;IACb,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,SAAS;IACT,WAAW;IACX,yBAAyB;AAC7B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,iBAAiB;IACjB,YAAY;IACZ,UAAU;IACV,SAAS;IACT,iCAAiC;IACjC,sBAAsB;IACtB,kCAA0B;YAA1B,0BAA0B;IAC1B,gCAAgC;AACpC;;AAEA;IACI,kBAAkB;IAClB,4BAA4B;IAC5B,YAAY;AAChB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,wBAAwB;IACxB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI;QACI,WAAW;IACf;AACJ;;AAEA;IACI;QACI,iBAAiB;IACrB;AACJ;;AAEA;IACI;QACI,YAAY;IAChB;;IAEA;QACI,eAAe;QACf,iBAAiB;IACrB;AACJ;;;AAGA;IACI;QACI,YAAY;IAChB;;IAEA;QACI,iBAAiB;IACrB;AACJ;;AAEA;IACI;QACI,2BAA2B;IAC/B;;IAEA;QACI,iBAAiB;IACrB;AACJ;;AAEA;IACI;QACI,YAAY;IAChB;AACJ;;AAEA;IACI;QACI,YAAY;IAChB;AACJ;;AAEA;IACI;QACI,aAAa;IACjB;;IAEA;QACI,YAAY;IAChB;AACJ;;AAEA;IACI;QACI,aAAa;IACjB;;IAEA;QACI,YAAY;IAChB;AACJ;;AAEA;IACI;QACI,aAAa;IACjB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,YAAY;IAChB;AACJ;;AAEA;IACI;QACI,aAAa;IACjB;AACJ;;AAEA,gCAAgC;AAChC;IACI,kBAAkB;IAClB,aAAa;IACb,aAAa;IACb,2BAA2B;IAC3B,wBAAwB;IACxB,yDAA4C;IAC5C,4BAA4B;IAC5B,kCAAkC;IAClC,sBAAsB;IACtB,gCAAgC;AACpC;;AAEA;IACI,aAAa;IACb,wBAAwB;IACxB,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,0BAA0B;AAC9B;;AAEA;IACI,wBAAwB;IACxB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,wBAAwB;IACxB,wBAAwB;IACxB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,2BAA2B;IAC3B,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,2BAA2B;IAC3B,uBAAuB;IACvB,YAAY;IACZ,aAAa;IACb,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,uBAAuB;AAC3B;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,iBAAiB;IACjB,gCAAgC;AACpC;;AAEA;IACI,uBAAuB;IACvB,wBAAwB;IACxB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,WAAW;AACf;;AAEA;;qBAEqB;;AAErB;IACI,sBAAsB;IACtB,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,WAAW;IACX,gBAAgB;;IAEhB,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;;IAEZ,gBAAgB;IAChB,oBAAoB;IACpB,iBAAiB;IACjB,mBAAmB;IACnB,uBAAuB;;IAEvB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;;IAEjB,eAAe;IACf,wBAAwB;IACxB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,cAAc;AAClB;;AAEA;;IAEI,aAAa;IACb,oDAAoD;AACxD;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,eAAe;IACf,2BAA2B;;IAE3B,uBAAuB;IACvB,QAAQ;IACR,SAAS;IACT,8BAA8B;IAC9B,yDAAyD;IACzD,mBAAmB;;IAEnB,gCAAgC;IAChC,oBAAoB;AACxB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,SAAS;IACT,SAAS;IACT,SAAS;IACT,UAAU;IACV,qBAAqB;;IAErB,qBAAqB;IACrB,gDAAgD;IAChD,kBAAkB;IAClB,kBAAkB;IAClB,yBAAyB;IACzB,0BAA0B;IAC1B,4BAA4B;IAC5B,WAAW;IACX,iBAAiB;IACjB,UAAU;AACd;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,SAAS;IACT,SAAS;IACT,SAAS;IACT,UAAU;IACV,qBAAqB;;IAErB,qBAAqB;IACrB,gDAAgD;IAChD,gBAAgB;IAChB,yBAAyB;IACzB,0BAA0B;IAC1B,4BAA4B;IAC5B,WAAW;IACX,iBAAiB;IACjB,UAAU;AACd;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,UAAU;IACV,gBAAgB;IAChB,2BAA2B;IAC3B,0BAA0B;IAC1B,kBAAkB;IAClB,4BAA4B;IAC5B,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,uBAAuB;IACvB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,SAAS;AACb;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,4BAA4B;IAC5B,gCAAgC;AACpC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,wBAAwB;IACxB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,YAAY;IACZ,aAAa;IACb,WAAW;;AAEf;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,UAAU;AACd;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,mBAAmB;IACnB,mBAAmB;IACnB,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,8FAA8F;AAClG;;AAEA;IACI,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,uBAAuB;AAC3B;;AAEA;IACI;QACI,WAAW;QACX,aAAa;IACjB;AACJ;;AAEA;IACI;QACI,aAAa;IACjB;;IAEA;QACI,iBAAiB;QACjB,aAAa;IACjB;AACJ;;AAEA;IACI;QACI,aAAa;IACjB;;IAEA;QACI,iBAAiB;QACjB,aAAa;IACjB;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,0BAA0B;IAC9B;AACJ;;AAEA;IACI;QACI,aAAa;QACb,yDAAgD;IACpD;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,0BAA0B;IAC9B;AACJ;;AAEA;IACI;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI;QACI,WAAW;QACX,0BAA0B;IAC9B;AACJ;;AAEA;IACI;QACI,aAAa;IACjB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI;QACI,aAAa;IACjB;;IAEA;QACI,WAAW;QACX,0BAA0B;IAC9B;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,iBAAiB;IACrB;AACJ;;AAEA;IACI;QACI,aAAa;IACjB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,iBAAiB;IACrB;AACJ;;AAEA;IACI;QACI,aAAa;IACjB;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,sBAAsB;QACtB,YAAY;QACZ,YAAY;QACZ,0BAA0B;IAC9B;;IAEA;QACI,SAAS;IACb;;IAEA;QACI,WAAW;QACX,uBAAuB;IAC3B;;IAEA;QACI,gCAAgC;IACpC;;IAEA,eAAe;;IAEf;QACI,gCAAgC;IACpC;;IAEA;QACI,YAAY;QACZ,WAAW;QACX,0BAA0B;IAC9B;AACJ;;AAEA;IACI;QACI,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,aAAa;QACb,4BAA4B;QAC5B,gCAAgC;IACpC;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,2BAA2B;QAC3B,4BAA4B;QAC5B,gBAAgB;QAChB,kCAAkC;IACtC;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,mBAAmB;QACnB,uBAAuB;QACvB,4BAA4B;IAChC;;IAEA;QACI,mBAAmB;QACnB,gBAAgB;IACpB;;IAEA;QACI,mBAAmB;QACnB,gBAAgB;IACpB;;IAEA;QACI,mBAAmB;QACnB,gBAAgB;IACpB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,YAAY;QACZ,0BAA0B;IAC9B;;AAEJ;;AAEA,kCAAkC;AAClC;IACI,aAAa;IACb,4BAA4B;IAC5B,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,iBAAiB;IACjB,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,gCAAgC;AACpC;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,gBAAgB;IAChB,kCAAkC;IAClC,4BAA4B;IAC5B,0BAA0B;AAC9B;;AAEA;IACI,wBAAwB;IACxB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,uBAAuB;IACvB,WAAW;IACX,UAAU;AACd;;AAEA;IACI;QACI,WAAW;IACf;AACJ;;AAEA;IACI;QACI,0BAA0B;IAC9B;;IAEA;QACI,aAAa;QACb,uBAAuB;IAC3B;;IAEA;QACI,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,0BAA0B;IAC9B;;IAEA;QACI,sBAAsB;IAC1B;AACJ;;AAEA;IACI;QACI,aAAa;IACjB;AACJ;;AAEA;IACI;QACI,aAAa;IACjB;AACJ;;AAEA;IACI;QACI,0BAA0B;IAC9B;;IAEA;QACI,eAAe;QACf,uBAAuB;IAC3B;;IAEA;QACI,aAAa;QACb,0BAA0B;IAC9B;;IAEA;QACI,aAAa;IACjB;AACJ;;AAEA;IACI;QACI,aAAa;IACjB;AACJ;;AAEA;IACI;QACI,aAAa;IACjB;;IAEA;QACI,aAAa;IACjB;AACJ;;AAEA;IACI;QACI,aAAa;IACjB;AACJ;;AAEA;IACI;QACI,aAAa;IACjB;AACJ;;AAEA;IACI;QACI,eAAe;QACf,wBAAwB;IAC5B;;IAEA;QACI,aAAa;IACjB;AACJ;;AAEA;IACI;QACI,0BAA0B;IAC9B;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,uBAAuB;IAC3B;AACJ;;AAEA;IACI;QACI,cAAc;QACd,wBAAwB;IAC5B;AACJ;;AAEA;IACI;QACI,aAAa;IACjB;AACJ;;AAEA;IACI;QACI,aAAa;IACjB;AACJ;;AAEA;IACI;QACI,YAAY;IAChB;AACJ;;AAEA,sCAAsC;AACtC;IACI,aAAa;IACb,4BAA4B;IAC5B,yBAAyB;;AAE7B;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,0BAA0B;IAC1B,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,iBAAiB;IACjB,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,gCAAgC;AACpC;;AAEA;IACI,sBAAsB;IACtB,wBAAwB;AAC5B;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,0BAA0B;IAC1B,4BAA4B;IAC5B,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,sBAAsB;IACtB,kBAAkB;IAClB,UAAU;IACV,WAAW;AACf;;AAEA;IACI;QACI,WAAW;IACf;AACJ;;AAEA;IACI;QACI,2BAA2B;IAC/B;;IAEA;QACI,aAAa;QACb,uBAAuB;IAC3B;;IAEA;QACI,aAAa;IACjB;AACJ;;AAEA;IACI;QACI,4BAA4B;QAC5B,sBAAsB;IAC1B;;IAEA;QACI,eAAe;QACf,iBAAiB;IACrB;AACJ;;AAEA;IACI;QACI,2BAA2B;IAC/B;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,aAAa;IACjB;;AAEJ;;AAEA;IACI;QACI,aAAa;IACjB;;IAEA;QACI,eAAe;QACf,iBAAiB;IACrB;AACJ;;AAEA;IACI;QACI,2BAA2B;IAC/B;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,aAAa;QACb,yBAAyB;IAC7B;;IAEA;QACI,eAAe;QACf,iBAAiB;IACrB;AACJ;;AAEA;IACI;QACI,aAAa;IACjB;;IAEA;QACI,eAAe;QACf,iBAAiB;IACrB;AACJ;;AAEA;IACI;QACI,eAAe;QACf,uBAAuB;QACvB,yBAAyB;IAC7B;;IAEA;QACI,aAAa;QACb,0BAA0B;IAC9B;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,YAAY;IAChB;AACJ;;AAEA;IACI;QACI,aAAa;IACjB;AACJ;;AAEA;IACI;QACI,yBAAyB;IAC7B;;IAEA;QACI,aAAa;IACjB;AACJ;;AAEA;IACI;QACI,aAAa;IACjB;AACJ;;AAEA;IACI;QACI,eAAe;QACf,wBAAwB;IAC5B;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,uBAAuB;QACvB,UAAU;QACV,WAAW;IACf;AACJ;;AAEA;IACI;QACI,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,YAAY;QACZ,uBAAuB;IAC3B;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,cAAc;IAClB;;AAEJ;;AAEA;IACI;QACI,0BAA0B;IAC9B;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,cAAc;QACd,wBAAwB;IAC5B;;IAEA;QACI,WAAW;IACf;AACJ;;AAEA;IACI;QACI,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,sBAAsB;IAC1B;AACJ;;AAEA;IACI;QACI,eAAe;QACf,iBAAiB;IACrB;AACJ;;AAEA;IACI;QACI,eAAe;QACf,iBAAiB;IACrB;AACJ;;AAEA,qBAAqB;AACrB;IACI,aAAa;IACb,0BAA0B;IAC1B,yBAAyB;AAC7B;;AAEA,YAAY;;AAEZ;IACI,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,MAAM;AACV;;AAEA;IACI,UAAU;IACV,kBAAkB;IAClB,QAAQ;IACR,QAAQ;IACR,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,gBAAgB;IAChB,mBAAmB;IACnB,wBAAwB;IACxB,4BAA4B;AAChC;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,UAAU;AACd;;AAEA;IACI;QACI,WAAW;IACf;AACJ;;AAEA;IACI;QACI,yBAAyB;IAC7B;;IAEA;QACI,UAAU;IACd;AACJ;;AAEA;IACI;QACI,UAAU;QACV,WAAW;QACX,QAAQ;IACZ;;IAEA;QACI,YAAY;IAChB;AACJ;;AAEA;IACI;QACI,yBAAyB;IAC7B;AACJ;;;AAGA;IACI;QACI,UAAU;IACd;AACJ;;AAEA;IACI;QACI,UAAU;IACd;AACJ;;AAEA;IACI;QACI,UAAU;IACd;AACJ;;AAEA;IACI;QACI,UAAU;IACd;;IAEA;QACI,YAAY;QACZ,UAAU;QACV,UAAU;IACd;AACJ;;AAEA;IACI;QACI,UAAU;QACV,WAAW;IACf;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,wBAAwB;QACxB,4BAA4B;IAChC;AACJ;;AAEA;IACI;QACI,sBAAsB;QACtB,YAAY;QACZ,UAAU;QACV,QAAQ;IACZ;;IAEA;QACI,yBAAyB;QACzB,4BAA4B;IAChC;AACJ;;AAEA;IACI;QACI,aAAa;IACjB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,SAAS;IACb;AACJ;;AAEA;IACI;QACI,WAAW;IACf;;IAEA;QACI,QAAQ;QACR,WAAW;IACf;AACJ;;AAEA;IACI;QACI,gBAAgB;IACpB;;IAEA;QACI,0BAA0B;QAC1B,kBAAkB;QAClB,mBAAmB;QACnB,WAAW;QACX,UAAU;QACV,UAAU;QACV,QAAQ;IACZ;;IAEA;QACI,aAAa;IACjB;AACJ;;AAEA;IACI;QACI,aAAa;IACjB;AACJ;;AAEA;IACI;QACI,aAAa;IACjB;AACJ;;AAEA;IACI;QACI,aAAa;IACjB;AACJ;;AAEA;IACI;QACI,aAAa;IACjB;;IAEA;QACI,uBAAuB;QACvB,kBAAkB;QAClB,sBAAsB;QACtB,UAAU;QACV,UAAU;QACV,WAAW;QACX,OAAO;IACX;;IAEA;QACI,aAAa;QACb,iBAAiB;IACrB;AACJ;;AAEA;IACI;QACI,QAAQ;IACZ;;IAEA;QACI,aAAa;IACjB;AACJ;;AAEA;IACI;QACI,OAAO;IACX;;IAEA;QACI,aAAa;IACjB;AACJ;;;AAGA,8CAA8C;AAC9C;IACI,aAAa;IACb,wBAAwB;IACxB,0BAA0B;AAC9B;;AAEA;IACI,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,wBAAwB;AAC5B;;AAEA;IACI,aAAa;IACb,iBAAiB;IACjB,aAAa;IACb,yBAAyB;IACzB,qBAAqB;IACrB,0BAA0B;AAC9B;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,iBAAiB;IACjB,gCAAgC;AACpC;;AAEA;IACI,WAAW;IACX,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,uBAAuB;IACvB,wBAAwB;AAC5B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,uBAAuB;IACvB,0BAA0B;IAC1B,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,2BAA2B;AAC/B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,wBAAwB;IACxB,2BAA2B;IAC3B,eAAe;IACf,0BAA0B;AAC9B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,wBAAwB;IACxB,0BAA0B;IAC1B,cAAc;AAClB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;AACb;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,0BAA0B;IAC1B,eAAe;AACnB;;AAEA;IACI,0BAA0B;IAC1B,eAAe;AACnB;;AAEA;IACI,0BAA0B;IAC1B,eAAe;AACnB;;AAEA;IACI,0BAA0B;IAC1B,eAAe;AACnB;;AAEA;IACI,0BAA0B;IAC1B,eAAe;AACnB;;AAEA;IACI,0BAA0B;IAC1B,eAAe;AACnB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI;QACI,WAAW;IACf;AACJ;;AAEA;IACI;QACI,0BAA0B;IAC9B;AACJ;;AAEA;IACI;QACI,wBAAwB;IAC5B;;IAEA;QACI,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,wBAAwB;IAC5B;AACJ;;AAEA;IACI;QACI,wBAAwB;IAC5B;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,2BAA2B;IAC/B;;IAEA;QACI,0BAA0B;QAC1B,wBAAwB;IAC5B;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,gBAAgB;IACpB;AACJ;;AAEA;IACI;QACI,aAAa;QACb,UAAU;QACV,wBAAwB;IAC5B;;IAEA;QACI,aAAa;QACb,UAAU;QACV,2BAA2B;IAC/B;AACJ;;AAEA;IACI;QACI,wBAAwB;IAC5B;;AAEJ;;AAEA;IACI;QACI,aAAa;QACb,UAAU;QACV,yBAAyB;IAC7B;;IAEA;QACI,aAAa;QACb,UAAU;QACV,2BAA2B;IAC/B;;AAEJ;;AAEA;IACI;QACI,0BAA0B;IAC9B;;IAEA;QACI,eAAe;QACf;IACJ;;IAEA;QACI,eAAe;QACf,gBAAgB;IACpB;AACJ;;AAEA;IACI;QACI,eAAe;QACf,uBAAuB;IAC3B;;IAEA;QACI,eAAe;QACf,gBAAgB;QAChB,yBAAyB;IAC7B;AACJ;;AAEA;IACI;QACI,cAAc;QACd,0BAA0B;IAC9B;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,wBAAwB;QACxB,aAAa;QACb,uBAAuB;IAC3B;;IAEA;QACI,YAAY;QACZ,mBAAmB;;IAEvB;;IAEA;QACI,uBAAuB;QACvB,eAAe;QACf,kBAAkB;QAClB,WAAW;QACX,aAAa;QACb,UAAU;QACV,qBAAqB;QACrB,YAAY;IAChB;AACJ;;AAEA;IACI;QACI,0BAA0B;IAC9B;;IAEA;QACI,WAAW;IACf;AACJ;;AAEA;IACI;QACI,yBAAyB;IAC7B;;IAEA;QACI,wBAAwB;QACxB,0BAA0B;IAC9B;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI;QACI,kBAAkB;IACtB;AACJ;;AAEA;IACI;QACI,wBAAwB;IAC5B;AACJ;;AAEA;IACI;QACI,uBAAuB;IAC3B;AACJ;;AAEA;IACI;QACI,yBAAyB;IAC7B;AACJ;;AAEA;IACI;QACI,yBAAyB;IAC7B;AACJ;;AAEA;IACI;QACI,wBAAwB;IAC5B;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,yBAAyB;IAC7B;AACJ;;AAEA;IACI;QACI,yBAAyB;IAC7B;AACJ;;AAEA;IACI;QACI,wBAAwB;IAC5B;;IAEA;QACI,yBAAyB;QACzB,WAAW;QACX,YAAY;IAChB;AACJ;;AAEA,wCAAwC;AACxC;IACI,gBAAgB;IAChB,aAAa;IACb,0BAA0B;IAC1B,yBAAyB;AAC7B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI;QACI,WAAW;IACf;;IAEA;QACI,WAAW;IACf;AACJ;;AAEA;IACI;QACI,WAAW;IACf;;AAEJ;;AAEA;IACI;QACI,yBAAyB;IAC7B;;IAEA;QACI,wBAAwB;IAC5B;AACJ;;AAEA;IACI;QACI,uBAAuB;IAC3B;;IAEA;QACI,aAAa;IACjB;AACJ;;AAEA;IACI;QACI,aAAa;IACjB;AACJ;;AAEA;IACI;QACI,aAAa;IACjB;AACJ;;AAEA;IACI;QACI,yBAAyB;IAC7B;AACJ;;;AAGA;IACI;QACI,aAAa;IACjB;AACJ;;AAEA,iCAAiC;AACjC;IACI,aAAa;IACb,0BAA0B;IAC1B,yBAAyB;IACzB,gCAAgC;IAChC,mBAAmB;AACvB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,yBAAyB;IACzB,WAAW;IACX,aAAa;IACb,6BAA6B;AACjC;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,yBAAyB;IACzB,UAAU;IACV,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;IAChB,cAAc;IACd,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,uBAAuB;AAC3B;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,wBAAwB;IACxB,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,wBAAwB;IACxB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,wBAAwB;IACxB,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,aAAa;IACb,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,gBAAgB;IAChB,iBAAiB;IACjB,sBAAsB;IACtB,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI;QACI,WAAW;IACf;AACJ;;AAEA;IACI;QACI,UAAU;IACd;;IAEA;;QAEI,aAAa;IACjB;AACJ;;AAEA;;IAEI;;QAEI,aAAa;IACjB;AACJ;;AAEA;IACI;QACI,4BAA4B;IAChC;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,UAAU;IACd;;AAEJ;;AAEA;IACI;QACI,cAAc;QACd,aAAa;QACb,sBAAsB;QACtB,mBAAmB;IACvB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,WAAW;QACX,wBAAwB;IAC5B;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;;QAEI,aAAa;IACjB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,aAAa;IACjB;;AAEJ;;AAEA;IACI;QACI,0BAA0B;IAC9B;;IAEA;QACI,WAAW;IACf;AACJ;;AAEA;IACI;QACI,sBAAsB;IAC1B;;IAEA;QACI,yBAAyB;IAC7B;AACJ;;AAEA;;6CAE6C;;AAE7C,sBAAsB;AACtB;IACI,kBAAkB;IAClB,cAAc;IACd,WAAW;IACX,gBAAgB;IAChB,oCAAoC;IACpC,gBAAgB;IAChB,eAAe;IACf,QAAQ;IACR,aAAa;IACb,uBAAuB;IACvB,6BAA6B;AACjC;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,2BAA2B;IAC3B,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,qBAAqB;IACrB,yBAAyB;IACzB,mBAAmB;IACnB,6BAA6B;IAC7B,aAAa;;;IAGb,sBAAsB;AAC1B;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,uBAAuB;IACvB,wBAAwB;IACxB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,gBAAgB;IAChB,0BAA0B;AAC9B;;AAEA;IACI,4BAA4B;IAC5B,uBAAuB;AAC3B;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,gCAAgC;IAChC,wBAAwB;IACxB,4BAA4B;AAChC;;AAEA;IACI,4BAA4B;IAC5B,uBAAuB;AAC3B;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,gCAAgC;IAChC,wBAAwB;AAC5B;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,wBAAwB;IACxB,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;IAClB,wBAAwB;IACxB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,WAAW;AACf;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI;QACI,0BAA0B;IAC9B;AACJ;;AAEA;IACI;QACI,0BAA0B;IAC9B;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,eAAe;IACnB;;AAEJ;;AAEA;IACI;QACI,yBAAyB;IAC7B;;IAEA;QACI,2BAA2B;IAC/B;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,uBAAuB;IAC3B;AACJ;;AAEA;IACI;QACI,kBAAkB;IACtB;;IAEA;QACI,eAAe;IACnB;AACJ;;AAEA,sBAAsB;AACtB;IACI,kBAAkB;IAClB,cAAc;IACd,WAAW;IACX,gBAAgB;IAChB,oCAAoC;IACpC,gBAAgB;IAChB,eAAe;IACf,QAAQ;IACR,aAAa;IACb,uBAAuB;IACvB,6BAA6B;AACjC;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,2BAA2B;IAC3B,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,gBAAgB;IAChB,yBAAyB;IACzB,mBAAmB;IACnB,6BAA6B;IAC7B,aAAa;;;IAGb,sBAAsB;AAC1B;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,uBAAuB;IACvB,wBAAwB;IACxB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,0BAA0B;AAC9B;;AAEA;IACI,4BAA4B;IAC5B,uBAAuB;AAC3B;;AAEA;IACI,wBAAwB;IACxB,gCAAgC;AACpC;;AAEA;IACI,qBAAqB;IACrB,WAAW;IACX,wBAAwB;IACxB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;IAChB,cAAc;IACd,kBAAkB;IAClB,0BAA0B;AAC9B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,wBAAwB;IACxB,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;IAClB,wBAAwB;IACxB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI;QACI,0BAA0B;IAC9B;AACJ;;AAEA;IACI;QACI,0BAA0B;IAC9B;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,eAAe;IACnB;;AAEJ;;AAEA;IACI;QACI,yBAAyB;IAC7B;;IAEA;QACI,2BAA2B;IAC/B;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,uBAAuB;IAC3B;AACJ;;AAEA;IACI;QACI,kBAAkB;IACtB;;IAEA;QACI,eAAe;IACnB;AACJ;;AAEA,sBAAsB;AACtB;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;IAChB,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,uBAAuB;IACvB,wBAAwB;IACxB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,2BAA2B;AAC/B;;AAEA;IACI,4BAA4B;IAC5B,uBAAuB;AAC3B;;AAEA;IACI,wBAAwB;IACxB,gCAAgC;AACpC;;AAEA;IACI,uBAAuB;IACvB,gCAAgC;AACpC;;AAEA;IACI,uBAAuB;IACvB,8BAA8B;AAClC;;AAEA;IACI,YAAY;IACZ,wBAAwB;IACxB,gCAAgC;AACpC;;AAEA;IACI,uBAAuB;IACvB,gCAAgC;AACpC;;AAEA;IACI,uBAAuB;IACvB,8BAA8B;AAClC;;AAEA;IACI,wBAAwB;IACxB,gCAAgC;AACpC;;AAEA;IACI;QACI,0BAA0B;IAC9B;AACJ;;AAEA;IACI;QACI,0BAA0B;IAC9B;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,eAAe;IACnB;;AAEJ;;AAEA;IACI;QACI,yBAAyB;IAC7B;;IAEA;QACI,2BAA2B;IAC/B;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,uBAAuB;IAC3B;AACJ;;AAEA;IACI;QACI,kBAAkB;IACtB;;IAEA;QACI,eAAe;IACnB;AACJ;;AAEA;;sBAEsB;;AAEtB,gCAAgC;AAChC;IACI,aAAa;IACb,wBAAwB;IACxB,yDAA6C;AACjD;;AAEA;IACI,0BAA0B;IAC1B,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI;QACI,aAAa;IACjB;AACJ;;AAEA;IACI;QACI,aAAa;IACjB;;IAEA;QACI,0BAA0B;IAC9B;AACJ;;AAEA;IACI;QACI,aAAa;IACjB;;IAEA;QACI,0BAA0B;IAC9B;AACJ;;AAEA;IACI;QACI,aAAa;QACb,yDAAiD;IACrD;;IAEA;QACI,0BAA0B;IAC9B;AACJ;;AAEA;IACI;QACI,aAAa;IACjB;;IAEA;QACI,0BAA0B;IAC9B;AACJ;;AAEA;IACI;QACI,aAAa;IACjB;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,YAAY;IAChB;AACJ;;AAEA;IACI;QACI,0BAA0B;IAC9B;;IAEA;QACI,YAAY;IAChB;AACJ;;AAEA;IACI;QACI,WAAW;IACf;AACJ;;AAEA;IACI;QACI,0BAA0B;IAC9B;;IAEA;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI;QACI,kCAAkC;QAClC,0BAA0B;IAC9B;;IAEA;QACI,yBAAyB;IAC7B;AACJ;;AAEA,8CAA8C;AAC9C;IACI,2BAA2B;AAC/B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,WAAW;IACX,aAAa;IACb,8BAA8B;IAC9B,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,4BAA4B;IAC5B,wBAAwB;IACxB,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;;AAEtB;;AAEA;IACI,yBAAyB;IACzB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,wBAAwB;IACxB,4BAA4B;IAC5B,mBAAmB;AACvB;;AAEA;IACI,uBAAuB;IACvB,wBAAwB;IACxB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,WAAW;IACX,kBAAkB;IAClB,wBAAwB;IACxB,wBAAwB;IACxB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;IAChB,WAAW;IACX,6BAA6B;AACjC;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;AACZ;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI;QACI,0BAA0B;IAC9B;AACJ;;AAEA;IACI;QACI,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,4BAA4B;IAChC;;IAEA;QACI,wBAAwB;QACxB,4BAA4B;IAChC;;IAEA;QACI,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,0BAA0B;IAC9B;AACJ;;AAEA;IACI;QACI,uBAAuB;IAC3B;;IAEA;QACI,aAAa;QACb,0BAA0B;IAC9B;AACJ;;AAEA;IACI;QACI,aAAa;IACjB;AACJ;;AAEA;IACI;QACI,eAAe;QACf,wBAAwB;IAC5B;AACJ;;AAEA;IACI;QACI,cAAc;IAClB;;IAEA;QACI,wBAAwB;IAC5B;AACJ;;AAEA;IACI;QACI,4BAA4B;IAChC;AACJ;;AAEA;;4BAE4B;AAC5B;IACI,2BAA2B;IAC3B,0BAA0B;AAC9B;;AAEA;IACI;QACI,0BAA0B;QAC1B,0BAA0B;IAC9B;AACJ;;AAEA;IACI;QACI,aAAa;IACjB;AACJ;;AAEA;IACI;QACI,aAAa;IACjB;;IAEA;QACI,0BAA0B;IAC9B;AACJ;;AAEA;IACI;QACI,aAAa;IACjB;AACJ;;AAEA;IACI;QACI,wBAAwB;IAC5B;AACJ;;AAEA;IACI;QACI,aAAa;IACjB;;IAEA;QACI,0BAA0B;IAC9B;AACJ;;AAEA;IACI;QACI,aAAa;IACjB;;IAEA;QACI,0BAA0B;IAC9B;;AAEJ;;AAEA;IACI;QACI,gCAAgC;IACpC;AACJ;;AAEA;IACI;QACI,aAAa;IACjB;;IAEA;QACI,2BAA2B;IAC/B;AACJ;;AAEA,0BAA0B;AAC1B;IACI,2BAA2B;AAC/B;;AAEA;IACI;QACI,0BAA0B;IAC9B;AACJ;;AAEA;IACI;QACI,2BAA2B;IAC/B;AACJ;;AAEA;IACI;QACI,2BAA2B;IAC/B;AACJ;;AAEA;IACI;QACI,2BAA2B;IAC/B;AACJ;;AAEA,0CAA0C;AAC1C;IACI,kBAAkB;IAClB,aAAa;IACb,2BAA2B;IAC3B,0BAA0B;AAC9B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,4BAA4B;IAC5B,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,MAAM;IACN,gCAAgC;AACpC;;AAEA,mCAAmC;;AAEnC;IACI;QACI,WAAW;IACf;AACJ;;AAEA;IACI;QACI,aAAa;IACjB;;IAEA;QACI,WAAW;IACf;AACJ;;AAEA;IACI;QACI,aAAa;IACjB;AACJ;;AAEA;IACI;QACI,WAAW;IACf;AACJ;;AAEA;IACI;QACI,WAAW;IACf;AACJ;;AAEA;IACI;QACI,kBAAkB;QAClB,0BAA0B;QAC1B,2BAA2B;IAC/B;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,WAAW;QACX,kBAAkB;QAClB,MAAM;IACV;AACJ;;;AAGA;IACI;QACI,WAAW;IACf;AACJ;;AAEA;IACI;QACI,0BAA0B;QAC1B,0BAA0B;IAC9B;AACJ;;AAEA;IACI;QACI,WAAW;IACf;AACJ;;AAEA;IACI;QACI,WAAW;IACf;AACJ;;AAEA;IACI;QACI,WAAW;IACf;AACJ;;AAEA;IACI;QACI,0BAA0B;IAC9B;;IAEA;QACI,8BAA8B;IAClC;;IAEA;QACI,kBAAkB;QAClB,WAAW;QACX,gCAAgC;IACpC;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,kBAAkB;QAClB,kBAAkB;QAClB,UAAU;QACV,WAAW;IACf;AACJ;;AAEA;IACI;QACI,0BAA0B;QAC1B,wBAAwB;IAC5B;;IAEA;QACI,0BAA0B;QAC1B,wBAAwB;IAC5B;;IAEA;QACI,wBAAwB;IAC5B;AACJ;;AAEA;IACI;QACI,2BAA2B;IAC/B;AACJ;;AAEA;IACI;QACI,iBAAiB;IACrB;AACJ;;AAEA;IACI;QACI,iBAAiB;QACjB,4BAA4B;IAChC;AACJ;;AAEA;IACI;QACI,2BAA2B;IAC/B;AACJ;;AAEA;IACI;QACI,2BAA2B;IAC/B;AACJ;;AAEA;;qBAEqB;;AAErB,gCAAgC;AAChC;IACI,aAAa;IACb,wBAAwB;IACxB,yDAA4C;AAChD;;AAEA;IACI;QACI,aAAa;IACjB;AACJ;;AAEA;IACI;QACI,aAAa;QACb,yDAAgD;QAChD,+BAA+B;IACnC;AACJ;;AAEA;IACI;QACI,0BAA0B;QAC1B,kCAAkC;IACtC;AACJ;;AAEA,mCAAmC;AACnC;IACI,yBAAyB;IACzB,2BAA2B;AAC/B;;AAEA;IACI,aAAa;IACb,eAAe;IACf,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,wBAAwB;AAC5B;;AAEA;IACI;QACI,0BAA0B;IAC9B;AACJ;;AAEA;IACI;QACI,0BAA0B;IAC9B;AACJ;;AAEA;IACI;QACI,uBAAuB;IAC3B;;IAEA;QACI,aAAa;QACb,0BAA0B;IAC9B;;AAEJ;;AAEA;IACI;QACI,eAAe;QACf,wBAAwB;IAC5B;;AAEJ;;AAEA;IACI;QACI,eAAe;IACnB;;AAEJ;;AAEA;IACI;QACI,cAAc;IAClB;;AAEJ;;AAEA;;uBAEuB;;AAEvB,qCAAqC;AACrC;IACI,aAAa;IACb,yDAA4C;AAChD;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI;QACI,aAAa;IACjB;;IAEA;QACI,0BAA0B;IAC9B;AACJ;;AAEA;IACI;QACI,aAAa;IACjB;;IAEA;QACI,0BAA0B;IAC9B;AACJ;;AAEA;IACI;QACI,aAAa;QACb,gBAAgB;IACpB;;IAEA;QACI,0BAA0B;IAC9B;AACJ;;AAEA;IACI;QACI,0BAA0B;IAC9B;AACJ;;AAEA;IACI;QACI,aAAa;QACb,yDAAgD;QAChD,+BAA+B;QAC/B,gCAAgC;;IAEpC;;IAEA;QACI,0BAA0B;IAC9B;AACJ;;AAEA;IACI;QACI,aAAa;IACjB;;IAEA;QACI,0BAA0B;IAC9B;AACJ;;AAEA;IACI;QACI,aAAa;IACjB;;IAEA;QACI,yBAAyB;IAC7B;AACJ;;AAEA;IACI;QACI,yBAAyB;IAC7B;AACJ;;AAEA,+CAA+C;AAC/C;IACI,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,MAAM;IACN,gCAAgC;AACpC;;AAEA;IACI,WAAW;IACX,wBAAwB;AAC5B;;AAEA;IACI,wBAAwB;IACxB,yBAAyB;IACzB,6BAA6B;IAC7B,WAAW;IACX,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI;QACI,aAAa;IACjB;AACJ;;AAEA;IACI;QACI,aAAa;IACjB;AACJ;;AAEA;IACI;QACI,aAAa;IACjB;AACJ;;AAEA;IACI;QACI,aAAa;IACjB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,aAAa;IACjB;AACJ;;AAEA;IACI;QACI,aAAa;IACjB;;IAEA;QACI,aAAa;IACjB;AACJ;;AAEA;IACI;QACI,aAAa;IACjB;AACJ;;AAEA;IACI;QACI,aAAa;IACjB;AACJ;;AAEA;IACI;QACI,aAAa;IACjB;AACJ;;AAEA;IACI;QACI,aAAa;IACjB;AACJ;;AAEA;IACI;QACI,2BAA2B;QAC3B,wBAAwB;IAC5B;;IAEA;QACI,8BAA8B;IAClC;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,kBAAkB;QAClB,UAAU;QACV,WAAW;QACX,uBAAuB;IAC3B;;IAEA;QACI,WAAW;IACf;AACJ;;AAEA;IACI;QACI,8BAA8B;IAClC;AACJ;;AAEA;IACI;QACI,yBAAyB;IAC7B;AACJ;;AAEA;;IAEI;QACI,aAAa;IACjB;;IAEA;QACI,aAAa;IACjB;AACJ;;AAEA;IACI;QACI,sBAAsB;IAC1B;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,wBAAwB;IAC5B;AACJ;;AAEA,8CAA8C;AAC9C;IACI,4BAA4B;AAChC;;AAEA;IACI;QACI,0BAA0B;IAC9B;AACJ;;AAEA;IACI;QACI,0BAA0B;IAC9B;AACJ;;AAEA;;2BAE2B;AAC3B;IACI,wBAAwB;IACxB,yDAA2C;AAC/C;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI;QACI,aAAa;IACjB;AACJ;;AAEA;IACI;QACI,0BAA0B;IAC9B;;IAEA;QACI,mBAAmB;IACvB;AACJ;;AAEA;IACI;QACI,4BAA4B;IAChC;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,yBAAyB;IAC7B;AACJ;;AAEA;IACI;QACI,4BAA4B;QAC5B,0BAA0B;IAC9B;AACJ;;AAEA;IACI;QACI,yBAAyB;IAC7B;AACJ;;AAEA;IACI;QACI,4BAA4B;IAChC;;AAEJ;;AAEA,uBAAuB;AACvB;IACI,sBAAsB;IACtB,8BAA8B;AAClC;;AAEA;IACI,YAAY;AAChB;;;AAGA;;6BAE6B;;AAE7B,2CAA2C;AAC3C;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI;QACI,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,0BAA0B;IAC9B;AACJ;;AAEA;IACI;QACI,2BAA2B;IAC/B;AACJ;;AAEA;IACI;QACI,2BAA2B;IAC/B;AACJ;;AAEA;IACI;QACI,4BAA4B;IAChC;AACJ;;AAEA;IACI;QACI,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,2BAA2B;IAC/B;;IAEA;QACI,0BAA0B;IAC9B;AACJ;;AAEA,mDAAmD;AACnD;IACI,wBAAwB;IACxB,4BAA4B;AAChC;;AAEA;IACI,aAAa;IACb,yBAAyB;AAC7B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI;QACI,2BAA2B;IAC/B;AACJ;;AAEA;IACI;QACI,8BAA8B;IAClC;;IAEA;QACI,cAAc;QACd,kBAAkB;QAClB,WAAW;QACX,YAAY;QACZ,gCAAgC;IACpC;;IAEA;QACI,0BAA0B;IAC9B;AACJ;;AAEA;IACI;QACI,wBAAwB;IAC5B;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,UAAU;IACd;AACJ;;AAEA;IACI;QACI,2BAA2B;IAC/B;;IAEA;QACI,0BAA0B;QAC1B,4BAA4B;IAChC;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,gCAAgC;IACpC;;IAEA;QACI,8BAA8B;IAClC;;IAEA;QACI,8BAA8B;IAClC;;IAEA;QACI,gCAAgC;IACpC;;IAEA;QACI,UAAU;IACd;AACJ;;AAEA;IACI;QACI,WAAW;IACf;AACJ;;AAEA,6CAA6C;AAC7C;IACI,aAAa;IACb,2BAA2B;IAC3B,wBAAwB;AAC5B;;AAEA;IACI,4BAA4B;IAC5B,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,uBAAuB;IACvB,aAAa;IACb,eAAe;IACf,8BAA8B;AAClC;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,wBAAwB;IACxB,0BAA0B;AAC9B;;AAEA;IACI,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,mBAAmB;IACnB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,uBAAuB;IACvB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI;QACI,WAAW;IACf;AACJ;;AAEA;IACI;QACI,eAAe;QACf,cAAc;IAClB;;IAEA;QACI,eAAe;QACf,gBAAgB;IACpB;AACJ;;;AAGA;IACI;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,0BAA0B;IAC9B;;IAEA;QACI,0BAA0B;IAC9B;AACJ;;AAEA;IACI;QACI,4BAA4B;IAChC;AACJ;;AAEA;IACI;QACI,wBAAwB;QACxB,0BAA0B;IAC9B;AACJ;;AAEA;IACI;QACI,cAAc;QACd,wBAAwB;QACxB,0BAA0B;IAC9B;AACJ;;AAEA;IACI;QACI,WAAW;IACf;;IAEA;QACI,wBAAwB;IAC5B;AACJ;;AAEA;IACI;QACI,4BAA4B;IAChC;;IAEA;QACI,yBAAyB;IAC7B;AACJ;;AAEA;IACI;QACI,yBAAyB;IAC7B;;IAEA;QACI,eAAe;IACnB;AACJ;;AAEA;;2BAE2B;;AAE3B,0BAA0B;AAC1B;IACI,aAAa;IACb,wBAAwB;IACxB,6BAA6B;AACjC;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,wBAAwB;IACxB,yBAAyB;IACzB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;IAChB,WAAW;IACX,yBAAyB;AAC7B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,OAAO;IACP,QAAQ;AACZ;;AAEA;IACI,WAAW;IACX,wBAAwB;AAC5B;;AAEA;IACI,WAAW;IACX,wBAAwB;IACxB,0BAA0B;IAC1B,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,wBAAwB;IACxB,WAAW;IACX,6BAA6B;IAC7B,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;IAChB,WAAW;IACX,yBAAyB;IACzB,eAAe;AACnB;;AAEA;IACI,sBAAsB;IACtB,wCAAwC;AAC5C;;AAEA;IACI,WAAW;IACX,6BAA6B;AACjC;;AAEA,sCAAsC;;AAEtC,sCAAsC;;AAEtC,sCAAsC;;AAEtC;IACI,WAAW;IACX,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,wBAAwB;IACxB,4BAA4B;IAC5B,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,6BAA6B;IAC7B,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;IAChB,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,wBAAwB;IACxB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,wBAAwB;IACxB,WAAW;AACf;;AAEA;IACI,wBAAwB;IACxB,WAAW;AACf;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,aAAa;IACb,UAAU;AACd;;AAEA;IACI,uBAAuB;IACvB,eAAe;AACnB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,uBAAuB;IACvB,WAAW;AACf;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,wBAAwB;IACxB,wBAAwB;IACxB,aAAa;IACb,sBAAsB;IACtB,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,4BAA4B;IAC5B,uBAAuB;IACvB,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;IACb,sBAAsB;IACtB,sBAAsB;AAC1B;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,aAAa;IACb,UAAU;AACd;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,SAAS;IACT,UAAU;AACd;;AAEA;IACI,wBAAwB;IACxB,uBAAuB;AAC3B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,iBAAiB;IACjB,sBAAsB;IACtB,cAAc;IACd,yBAAyB;IACzB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,iBAAiB;IACjB,sBAAsB;IACtB,cAAc;IACd,yBAAyB;IACzB,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,sBAAsB;IACtB,qBAAqB;AACzB;;AAEA;IACI,yGAAyG;IACzG,oCAAoC;AACxC;;AAEA;IACI,oCAAoC;IACpC,2BAA2B;AAC/B;;AAEA;IACI,2BAA2B;IAC3B,oCAAoC;IACpC,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;IACI,UAAU;IACV,kBAAkB;IAClB,YAAY;IACZ,sBAAsB;IACtB,qBAAqB;AACzB;;AAEA;IACI,yGAAyG;IACzG,oCAAoC;AACxC;;AAEA;IACI,oCAAoC;IACpC,2BAA2B;AAC/B;;AAEA;IACI,2BAA2B;IAC3B,oCAAoC;IACpC,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,wBAAwB;IACxB,YAAY;IACZ,UAAU;IACV,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,uBAAuB;IACvB,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,iBAAiB;IACjB,sBAAsB;IACtB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,wBAAwB;IACxB,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,UAAU;IACV,oBAAoB;IACpB,mBAAmB;IACnB,yBAAiB;YAAjB,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,qBAAqB;IACrB,WAAW;IACX,YAAY;IACZ,cAAc;IACd,YAAY;IACZ,wBAAwB;IACxB,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,4BAA4B;IAC5B,kCAAkC;IAClC,wBAAwB;IACxB,UAAU;AACd;;AAEA,4CAA4C;AAC5C;IACI,kBAAkB;AACtB;;AAEA,iEAAiE;AACjE;IACI,kBAAkB;AACtB;;AAEA,8CAA8C;AAC9C;IACI,gDAAgD;AACpD;;AAEA,oFAAoF;AACpF;IACI,kBAAkB;AACtB;;AAEA,0DAA0D;AAC1D;IACI,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,oCAAoC;IACpC,yDAAgD;IAChD,4BAA4B;IAC5B,kCAAkC;IAClC,wBAAwB;AAC5B;;AAEA;IACI,gBAAgB;IAChB,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,0BAA0B;IAC1B,aAAa;IACb,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;;AAEvB;;AAEA;IACI,yBAAyB;IACzB,aAAa;IACb,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,2BAA2B;AAC/B;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,uBAAuB;IACvB,0BAA0B;IAC1B,yDAAsC;IACtC,4BAA4B;IAC5B,6BAA6B;IAC7B,0BAA0B;IAC1B,gBAAgB;AACpB;;AAEA;IACI,yDAAwC;AAC5C;;AAEA;IACI,0BAA0B;IAC1B,gBAAgB;AACpB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,cAAc;IACd,0BAA0B;IAC1B,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,UAAU;IACV,WAAW;IACX,uBAAuB;AAC3B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,mBAAmB;;AAEvB;;AAEA,0BAA0B;AAC1B;IACI,WAAW;IACX,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,wBAAwB;IACxB,wBAAwB;AAC5B;;AAEA;IACI,8BAA8B;IAC9B,sBAAsB;IACtB,wBAAwB;AAC5B;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,iBAAiB;IACjB,sBAAsB;IACtB,gBAAgB;IAChB,0BAA0B;AAC9B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,0BAA0B;IAC1B,wBAAwB;AAC5B;;AAEA;IACI,WAAW;IACX,4BAA4B;IAC5B,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,0BAA0B;IAC1B,6BAA6B;IAC7B,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,wBAAwB;AAC5B;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,wBAAwB;IACxB,yBAAyB;IACzB,aAAa;IACb,eAAe;IACf,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,uBAAuB;IACvB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,iBAAiB;IACjB,6BAA6B;IAC7B,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,wBAAwB;IACxB,kBAAkB;IAClB,WAAW;IACX,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI,WAAW;IACX,wBAAwB;AAC5B;;AAEA;IACI,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,wBAAwB;IACxB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;IAChB,cAAc;IACd,eAAe;IACf,0BAA0B;IAC1B,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,QAAQ;IACR,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,WAAW;IACX,YAAY;IACZ,eAAe;;AAEnB;;AAEA;IACI,yBAAyB;;AAE7B;;AAEA;IACI,0BAA0B;IAC1B,eAAe;AACnB;;AAEA;IACI,aAAa;;AAEjB;;AAEA;IACI,cAAc;;AAElB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,iBAAiB;IACjB,sBAAsB;IACtB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,aAAa;IACb,WAAW;IACX,wBAAwB;AAC5B;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,WAAW;IACX,wBAAwB;IACxB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,wBAAwB;IACxB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,wBAAwB;IACxB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,sBAAsB;;AAE1B;;AAEA;IACI,gBAAgB;IAChB,sBAAsB;;AAE1B;;AAEA;IACI,gBAAgB;IAChB,sBAAsB;;AAE1B;;AAEA;IACI,aAAa;IACb,WAAW;IACX,wBAAwB;AAC5B;;AAEA;IACI,cAAc;IACd,WAAW;IACX,wBAAwB;IACxB,kBAAkB;IAClB,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,cAAc;IACd,WAAW;IACX,wBAAwB;IACxB,kBAAkB;IAClB,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,cAAc;IACd,WAAW;IACX,wBAAwB;IACxB,kBAAkB;IAClB,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,WAAW;IACX,wBAAwB;IACxB,kBAAkB;IAClB,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,eAAe;IACf,iBAAiB;IACjB,UAAU;IACV,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,uBAAuB;IACvB,yBAAyB;IACzB,0BAA0B;AAC9B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,YAAY;AAChB;;;;AAIA;IACI;QACI,WAAW;IACf;AACJ;;AAEA;IACI;QACI,iBAAiB;IACrB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,gCAAgC;IACpC;;IAEA;QACI,gCAAgC;IACpC;;IAEA;QACI,8BAA8B;IAClC;;IAEA;QACI,gCAAgC;IACpC;;IAEA;QACI,gCAAgC;IACpC;;IAEA;QACI,gCAAgC;IACpC;;IAEA;QACI,kCAAkC;IACtC;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,aAAa;IACjB;AACJ;;AAEA;IACI;QACI,iBAAiB;IACrB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,aAAa;IACjB;AACJ;;AAEA;IACI;QACI,iBAAiB;IACrB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,iBAAiB;QACjB,cAAc;IAClB;;IAEA;QACI,gCAAgC;IACpC;;IAEA;QACI,kCAAkC;IACtC;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,aAAa;IACjB;AACJ;;AAEA;IACI;QACI,uBAAuB;IAC3B;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,aAAa;QACb,UAAU;IACd;;IAEA;QACI,gCAAgC;IACpC;;IAEA;QACI,gCAAgC;IACpC;;IAEA;QACI,gCAAgC;IACpC;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,aAAa;QACb,QAAQ;IACZ;;IAEA;QACI,aAAa;QACb,QAAQ;IACZ;;IAEA;QACI,cAAc;QACd,eAAe;QACf,gBAAgB;QAChB,mBAAmB;QACnB,QAAQ;IACZ;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,kBAAkB;IACtB;AACJ;;AAEA;IACI;QACI,eAAe;IACnB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,aAAa;QACb,UAAU;IACd;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,eAAe;QACf,uBAAuB;IAC3B;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,gCAAgC;IACpC;;IAEA;QACI,gCAAgC;IACpC;;IAEA;QACI,kCAAkC;IACtC;;IAEA;QACI,gCAAgC;IACpC;;IAEA;QACI,gCAAgC;IACpC;;IAEA;QACI,gCAAgC;IACpC;;IAEA;QACI,gCAAgC;IACpC;;IAEA;QACI,gCAAgC;IACpC;;IAEA;QACI,gCAAgC;IACpC;;IAEA;QACI,gCAAgC;IACpC;;IAEA;QACI,gCAAgC;IACpC;;IAEA;QACI,gCAAgC;IACpC;;IAEA;QACI,kCAAkC;IACtC;;IAEA;QACI,gCAAgC;IACpC;;IAEA;QACI,gCAAgC;IACpC;;IAEA;QACI,kCAAkC;IACtC;;IAEA;QACI,gCAAgC;IACpC;;IAEA;QACI,gCAAgC;IACpC;;IAEA;QACI,kCAAkC;IACtC;;IAEA;QACI,UAAU;IACd;;AAEJ;;AAEA;IACI;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,cAAc;QACd,mCAAmC;IACvC;;IAEA;QACI,QAAQ;IACZ;;IAEA;QACI,QAAQ;IACZ;;IAEA;QACI,QAAQ;IACZ;;IAEA;QACI,QAAQ;IACZ;;AAEJ;;AAEA;IACI;QACI,UAAU;IACd;;AAEJ;;AAEA;IACI;QACI,WAAW;QACX,gBAAgB;IACpB;;IAEA;QACI,sBAAsB;QACtB,wBAAwB;IAC5B;;IAEA;;;;;;QAMI,sBAAsB;IAC1B;;IAEA;QACI,yBAAyB;QACzB,uBAAuB;IAC3B;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,cAAc;QACd,uBAAuB;IAC3B;;IAEA;QACI,cAAc;QACd,uBAAuB;IAC3B;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,cAAc;QACd,uBAAuB;IAC3B;;IAEA;QACI,cAAc;QACd,WAAW;QACX,uBAAuB;IAC3B;;IAEA;QACI,cAAc;QACd,WAAW;QACX,uBAAuB;IAC3B;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,cAAc;QACd,uBAAuB;IAC3B;;IAEA;QACI,kCAAkC;IACtC;;IAEA;QACI,cAAc;QACd,eAAe;QACf,gBAAgB;IACpB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,WAAW;QACX,0BAA0B;IAC9B;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,gBAAgB;IACpB;;AAEJ;;AAEA;IACI;QACI,sBAAsB;IAC1B;;IAEA;QACI,wBAAwB;QACxB,WAAW;IACf;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,2BAA2B;IAC/B;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,kBAAkB;IACtB;AACJ;;AAEA;IACI;QACI,2BAA2B;IAC/B;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,4BAA4B;IAChC;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,mCAAmC;IACvC;;IAEA;QACI,kCAAkC;QAClC,mCAAmC;QACnC,YAAY;IAChB;;IAEA;QACI,YAAY;IAChB;AACJ;;AAEA,2BAA2B;;AAE3B;IACI;QACI,wBAAwB;IAC5B;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,wBAAwB;IAC5B;AACJ;;AAEA;IACI;QACI,yBAAyB;QACzB,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,iBAAiB;QACjB,wBAAwB;IAC5B;;AAEJ;;AAEA;IACI;QACI,eAAe;QACf,iBAAiB;IACrB;AACJ;;AAEA;IACI;QACI,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,eAAe;IACnB;AACJ;;;AAGA;;2BAE2B;AAC3B,uBAAuB;AACvB;IACI,kBAAkB;IAClB,aAAa;IACb,+BAA+B;AACnC;;AAEA,mBAAmB;AACnB;IACI,aAAa;IACb,8BAA8B;IAC9B,wBAAwB;AAC5B;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,yBAAyB;IACzB,4BAA4B;IAC5B,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,4BAA4B;IAC5B,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;;;;CAIC;AACD;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,wBAAwB;AAC5B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA,yBAAyB;;AAEzB;IACI,aAAa;IACb,qBAAqB;AACzB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,wBAAwB;IACxB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,wBAAwB;IACxB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI;QACI,WAAW;IACf;AACJ;;AAEA;IACI;QACI,aAAa;IACjB;;IAEA;QACI,8BAA8B;IAClC;AACJ;;AAEA;IACI;QACI,aAAa;QACb,yDAAgD;IACpD;;IAEA;QACI,8BAA8B;IAClC;;IAEA;QACI,YAAY;IAChB;AACJ;;AAEA;IACI;QACI,aAAa;IACjB;AACJ;;AAEA;IACI;QACI,aAAa;IACjB;;IAEA;QACI,8BAA8B;IAClC;AACJ;;AAEA;IACI;QACI,aAAa;IACjB;;IAEA;QACI,8BAA8B;IAClC;AACJ;;AAEA;IACI;QACI,aAAa;IACjB;;AAEJ;;AAEA;IACI;QACI,WAAW;IACf;;IAEA;QACI,8BAA8B;IAClC;AACJ;;AAEA;;2BAE2B;;AAE3B,6BAA6B;AAC7B;IACI,0DAA6C;AACjD;;AAEA,sCAAsC;AACtC;IACI,kBAAkB;IAClB,aAAa;IACb,8BAA8B;IAC9B,wBAAwB;AAC5B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;IACX,0BAA0B;IAC1B,wBAAwB;IACxB,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,qBAAqB;IACrB,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,cAAc;IACd,wBAAwB;IACxB,gCAAgC;IAChC,yBAAyB;IACzB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,uBAAuB;IACvB,4BAA4B;IAC5B,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,cAAc;AAClB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,wBAAwB;AAC5B;;AAEA;IACI,wBAAwB;IACxB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,wBAAwB;IACxB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,wBAAwB;IACxB,0BAA0B;IAC1B,yBAAyB;AAC7B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI;QACI,WAAW;IACf;AACJ;;AAEA;IACI;QACI,8BAA8B;IAClC;AACJ;;AAEA;IACI;QACI,aAAa;IACjB;;IAEA;QACI,8BAA8B;IAClC;AACJ;;AAEA;IACI;QACI,aAAa;IACjB;;IAEA;QACI,6BAA6B;IACjC;AACJ;;AAEA;IACI;QACI,aAAa;IACjB;;IAEA;QACI,6BAA6B;IACjC;AACJ;;AAEA;IACI;QACI,aAAa;IACjB;;IAEA;QACI,6BAA6B;IACjC;;IAEA;QACI,wBAAwB;QACxB,wBAAwB;IAC5B;AACJ;;AAEA;IACI;QACI,aAAa;IACjB;AACJ;;AAEA;IACI;QACI,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,cAAc;IAClB;;IAEA;QACI,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,6BAA6B;IACjC;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,0BAA0B;QAC1B,wBAAwB;IAC5B;AACJ;;AAEA;IACI;QACI,sBAAsB;QACtB,uBAAuB;IAC3B;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,4BAA4B;IAChC;AACJ;;AAEA;IACI;QACI,aAAa;IACjB;;IAEA;QACI,6BAA6B;IACjC;AACJ;;AAEA;;sBAEsB;AACtB,kCAAkC;AAClC;IACI,0DAA+C;AACnD;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,YAAY;IACZ,wBAAwB;AAC5B;;AAEA;;;IAGI,WAAW;IACX,uBAAuB;AAC3B;;AAEA;IACI,4BAA4B;IAC5B,4BAA4B;IAC5B,YAAY;IACZ,YAAY;IACZ,UAAU;IACV,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,wBAAwB;IACxB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,uBAAuB;IACvB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,uBAAuB;IACvB,gCAAgC;AACpC;;AAEA;IACI,YAAY;IACZ,uBAAuB;IACvB,8BAA8B;AAClC;;AAEA;IACI,uBAAuB;IACvB,8BAA8B;AAClC;;AAEA;IACI,wBAAwB;IACxB,gCAAgC;AACpC;;AAEA;IACI,uBAAuB;IACvB,gCAAgC;AACpC;;AAEA;IACI,uBAAuB;IACvB,8BAA8B;AAClC;;AAEA;IACI,YAAY;IACZ,wBAAwB;IACxB,gCAAgC;AACpC;;AAEA;IACI,cAAc;IACd,UAAU;AACd;;AAEA;IACI,wBAAwB;IACxB,WAAW;IACX,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,eAAe;AACnB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,mBAAmB;IACnB,yBAAyB;IACzB,eAAe;AACnB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,2BAA2B;IAC3B,0BAA0B;IAC1B,4BAA4B;IAC5B,yBAAyB;IACzB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,wBAAwB;IACxB,wBAAwB;AAC5B;;AAEA;IACI,eAAe;IACf,wBAAwB;AAC5B;;AAEA;IACI,eAAe;IACf,wBAAwB;AAC5B;;AAEA;IACI,uBAAuB;IACvB,gCAAgC;AACpC;;AAEA;IACI,wBAAwB;IACxB,gCAAgC;AACpC;;AAEA;IACI;QACI,4BAA4B;IAChC;AACJ;;AAEA;IACI;QACI,4BAA4B;IAChC;AACJ;;AAEA;;IAEI;QACI,0DAAoD;IACxD;;IAEA;QACI,0DAAoD;IACxD;;IAEA;QACI,4BAA4B;IAChC;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI,4BAA4B;IAChC;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,4BAA4B;IAChC;AACJ;;AAEA;IACI;QACI,WAAW;IACf;AACJ;;AAEA;IACI;QACI,2BAA2B;IAC/B;AACJ;;AAEA;IACI;QACI,aAAa;QACb,0BAA0B;QAC1B,kCAAkC;IACtC;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,YAAY;IAChB;AACJ;;AAEA;IACI;QACI,4BAA4B;IAChC;;IAEA;;QAEI,YAAY;IAChB;;IAEA;QACI,YAAY;IAChB;AACJ;;AAEA;IACI;QACI,0BAA0B;IAC9B;AACJ;;AAEA;IACI;QACI,0BAA0B;IAC9B;AACJ;;AAEA,uBAAuB;AACvB;IACI,aAAa;IACb,2BAA2B;IAC3B,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,wBAAwB;AAC5B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;AACrB;;;AAGA;IACI;QACI,WAAW;IACf;AACJ;;AAEA;IACI;QACI,2BAA2B;IAC/B;AACJ;;AAEA;IACI;QACI,0BAA0B;IAC9B;AACJ;;AAEA;IACI;QACI,uBAAuB;IAC3B;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,aAAa;QACb,kBAAkB;IACtB;;IAEA;QACI,aAAa;QACb,kBAAkB;IACtB;;IAEA;QACI,aAAa;QACb,kBAAkB;IACtB;;IAEA;QACI,aAAa;QACb,iBAAiB;IACrB;AACJ;;AAEA;IACI;QACI,aAAa;IACjB;;IAEA,mCAAmC;;IAEnC;QACI,kBAAkB;IACtB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,iBAAiB;IACrB;AACJ;;AAEA;IACI;QACI,iBAAiB;IACrB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,iBAAiB;IACrB;AACJ;;AAEA;IACI;QACI,aAAa;QACb,kBAAkB;IACtB;AACJ;;AAEA;IACI;QACI,cAAc;IAClB;AACJ;;AAEA;;wBAEwB;AACxB;IACI,8BAA8B;AAClC;;AAEA;IACI,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,wBAAwB;IACxB,mBAAmB;IACnB,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;IAChB,4BAA4B;IAC5B,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,sBAAsB;IACtB,uBAAuB;AAC3B;;AAEA;IACI,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,gCAAgC;IAChC,wBAAwB;AAC5B;;AAEA;IACI,UAAU;IACV,wGAAwG;IACxG,8BAA8B;AAClC;AACA;IACI,YAAY;IACZ,wGAAwG;AAC5G;AACA;IACI,YAAY;AAChB;;;AAGA;IACI,UAAU;AACd;;AAEA;IACI,gBAAgB;IAChB,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,gCAAgC;IAChC,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,wBAAwB;AAC5B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,UAAU;;AAEd;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,UAAU;IACV,mBAAmB;IACnB,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,wBAAwB;AAC5B;;AAEA;IACI,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,kBAAkB;AACtB;;AAEA;;;IAGI,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,wBAAwB;IACxB,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,wBAAwB;IACxB,YAAY;AAChB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,cAAc;IACd,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,cAAc;IACd,uBAAuB;AAC3B;;AAEA;IACI,uBAAuB;IACvB,eAAe;AACnB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,cAAc;IACd,4BAA4B;;AAEhC;;AAEA;IACI,cAAc;IACd,eAAe;IACf,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,eAAe;AACnB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;AACZ;;AAEA;IACI,kBAAkB;IAClB,QAAQ;AACZ;;AAEA;IACI,cAAc;IACd,yBAAyB;IACzB,uBAAuB;AAC3B;;AAEA;IACI,WAAW;AACf;;AAEA;;;EAGE;;AAEF;IACI,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,wBAAwB;AAC5B;;AAEA;IACI,SAAS;AACb;;AAEA,QAAQ;;AAER;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,2BAA2B;IAC3B,mBAAmB;AACvB;;AAEA;IACI,wBAAwB;IACxB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,4BAA4B;IAC5B,sBAAsB;IACtB,+BAA+B;IAC/B,mBAAmB;AACvB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,WAAW;IACX,eAAe;IACf,0BAA0B;AAC9B;;AAEA;IACI,8BAA8B;IAC9B,YAAY;IACZ,0BAA0B;AAC9B;;AAEA;IACI;QACI,8BAA8B;IAClC;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,wBAAwB;QACxB,uBAAuB;IAC3B;;IAEA;QACI,gCAAgC;IACpC;;IAEA;QACI,gCAAgC;IACpC;;IAEA;QACI,wBAAwB;IAC5B;AACJ;;AAEA;IACI;QACI,6BAA6B;IACjC;AACJ;;AAEA;IACI;QACI,eAAe;IACnB;;IAEA;QACI,cAAc;QACd,uBAAuB;QACvB,wBAAwB;IAC5B;AACJ;;AAEA;IACI;QACI,8BAA8B;IAClC;;IAEA;QACI,eAAe;QACf,sBAAsB;QACtB,iBAAiB;QACjB,sBAAsB;IAC1B;;IAEA;QACI,YAAY;QACZ,uBAAuB;IAC3B;;IAEA;QACI,YAAY;QACZ,uBAAuB;IAC3B;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,WAAW;IACf;AACJ;;AAEA;IACI;QACI,sBAAsB;IAC1B;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,wBAAwB;QACxB,wBAAwB;IAC5B;AACJ;;AAEA;IACI;QACI,4BAA4B;IAChC;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,wBAAwB;IAC5B;AACJ;;;AAGA,QAAQ;AACR;IACI,WAAW;AACf;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,MAAM;IACN,OAAO;IACP,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,sCAAsC;IACtC,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;;IAEhC,2BAA2B;IAC3B,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,gBAAgB;IAChB,yBAAyB;IACzB,mBAAmB;IACnB,6BAA6B;IAC7B,aAAa;AACjB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI;QACI,aAAa;IACjB;;IAEA;QACI,wBAAwB;QACxB,kBAAkB;QAClB,gBAAgB;QAChB,eAAe;QACf,kBAAkB;QAClB,WAAW;QACX,kBAAkB;IACtB;;IAEA;QACI,mBAAmB;IACvB;AACJ;;AAEA;IACI;QACI,wBAAwB;QACxB,kBAAkB;QAClB,gBAAgB;QAChB,eAAe;QACf,kBAAkB;QAClB,WAAW;QACX,kBAAkB;QAClB,aAAa;QACb,SAAS;QACT,2BAA2B;IAC/B;;IAEA;QACI,aAAa;IACjB;AACJ;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,wBAAwB;AAC5B;;;AAGA;IACI,0DAA6C;AACjD;;AAEA;IACI;QACI;YACI,iBAAiB;QACrB;IACJ;AACJ;;AAEA;IACI,aAAa;;AAEjB;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,mBAAmB;IACnB,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,4CAA4C;AAChD","sourcesContent":["* {\n    margin: 0;\n    padding: 0;\n    box-sizing: border-box;\n}\n\nbody {\n    position: relative;\n    margin: 0;\n    padding: 0;\n    font-family: 'Geologica', sans-serif;\n    background: #f5f5f5;\n}\n\nbutton {\n    font-family: 'Geologica', sans-serif;\n}\n\nli {\n    list-style-type: none;\n}\n\na {\n    color: #000;\n    text-decoration: none;\n    cursor: pointer;\n}\n\n/******** header ************/\n.header {\n    z-index: 1;\n    width: 1920px;\n    padding: 0px 0px 0px 0px;\n    margin: 0px auto 0px auto;\n    position: relative;\n}\n\n.header-contant {\n    width: 100%;\n    padding: 20px 50px 0px 50px;\n    margin: 0px 0px 0px 0px;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n}\n\n.header-contant-logo {\n    flex: 0 0 90%;\n    display: flex;\n    justify-content: flex-start;\n}\n\n.header-contant-user {\n    flex: 0 0 5%;\n    display: flex;\n    justify-content: flex-end;\n}\n\n.header-contant-menu {\n    flex: 0 0 3%;\n    display: flex;\n    justify-content: flex-end;\n}\n\n.burger-1 {\n    cursor: pointer;\n}\n\n.burger-2 {\n    display: block;\n    cursor: pointer;\n    z-index: 1000;\n    position: absolute;\n    width: 18px;\n    height: 18px;\n    top: 15px;\n    right: 15px;\n    transition-duration: 0.5s;\n}\n\n.burger-2:hover {\n    opacity: 0.3;\n}\n\n.mobile-container {\n    display: block;\n    z-index: 999;\n    position: absolute;\n    width: 260px;\n    /*height: 597px;*/\n    height: auto;\n    right: 0px;\n    top: 70px;\n    background: rgba(79, 79, 79, 0.9);\n    mix-blend-mode: normal;\n    backdrop-filter: blur(2px);\n    border-radius: 20px 0px 0px 20px;\n}\n\n.mobile-container-vnutr {\n    position: relative;\n    padding: 50px 40px 20px 40px;\n    height: auto;\n}\n\n.main-menu li {\n    margin: 0px 0px 10px 0px;\n}\n\n.main-menu a {\n    font-family: 'Geologica';\n    font-style: normal;\n    font-weight: 300;\n    font-size: 16px;\n    line-height: 120%;\n    color: #FFFFFF;\n    transition-duration: 0.5s;\n}\n\n.main-menu a:hover {\n    opacity: 0.7;\n}\n\n.main-menu li.main-menu-up {\n    margin: 0px 0px 30px 0px;\n}\n\n@media (max-width: 1920px) {\n    .header {\n        width: 100%;\n    }\n}\n\n@media (max-width: 1366px) {\n    .mobile-container {\n        /*height: 500px;*/\n    }\n}\n\n@media (max-width: 1280px) {\n    .mobile-container {\n        width: 260px;\n    }\n\n    .main-menu a {\n        font-size: 14px;\n        line-height: 140%;\n    }\n}\n\n\n@media (max-width: 1080px) {\n    .header-contant-logo img {\n        height: 40px;\n    }\n\n    .mobile-container {\n        /*height: 430px;*/\n    }\n}\n\n@media (max-width: 1024px) {\n    .header-contant {\n        padding: 20px 20px 0px 20px;\n    }\n\n    .mobile-container {\n        /*height: 410px;*/\n    }\n}\n\n@media (max-width: 900px) {\n    .header-contant-logo img {\n        height: 36px;\n    }\n}\n\n@media (max-width: 899px) {\n    .header-contant-logo img {\n        height: 34px;\n    }\n}\n\n@media (max-width: 768px) {\n    .header-contant-logo {\n        flex: 0 0 85%;\n    }\n\n    .header-contant-logo img {\n        height: 32px;\n    }\n}\n\n@media (max-width: 600px) {\n    .header-contant-logo {\n        flex: 0 0 80%;\n    }\n\n    .header-contant-logo img {\n        height: 30px;\n    }\n}\n\n@media (max-width: 500px) {\n    .header-contant-logo {\n        flex: 0 0 75%;\n    }\n\n    .header-contant-logo img {\n        height: 28px;\n    }\n\n    .mobile-container {\n        /*height: 597px;*/\n    }\n\n    .user {\n        opacity: 0.6;\n    }\n\n    .burger-1 {\n        opacity: 0.6;\n    }\n}\n\n@media (max-width: 390px) {\n    .header-contant-logo {\n        flex: 0 0 70%;\n    }\n}\n\n/******** one-ekran ************/\n.one-ekran {\n    position: relative;\n    width: 1920px;\n    height: 878px;\n    margin: -70px auto 0px auto;\n    padding: 0px 0px 0px 0px;\n    background-image: url(../img/fon-1-main.jpg);\n    background-repeat: no-repeat;\n    background-position: bottom center;\n    background-size: cover;\n    border-radius: 0px 0px 50px 50px;\n}\n\n.conteiner {\n    width: 1344px;\n    padding: 0px 0px 0px 0px;\n    margin: 0px auto 0px auto;\n}\n\n.one-ekran-contant {\n    width: 100%;\n    padding: 200px 0px 0px 0px;\n}\n\n.h1 {\n    font-family: 'Geologica';\n    font-style: normal;\n    font-weight: 600;\n    font-size: 60px;\n    line-height: 110%;\n    text-align: center;\n    color: #000000;\n}\n\n.one-ekran-contant-text {\n    margin: 20px 0px 0px 0px;\n    font-family: 'Geologica';\n    font-style: normal;\n    font-weight: 400;\n    font-size: 24px;\n    line-height: 30px;\n    text-align: center;\n    color: #000000;\n}\n\n.form-1 {\n    margin: 100px auto 0px auto;\n    width: 100%;\n    height: 70px;\n    height: auto;\n    display: flex;\n}\n\n.form-1-col {\n    position: relative;\n    padding: 5px 20px 20px 20px;\n    margin: 0px 5px 0px 0px;\n    height: 100%;\n    flex: 0 0 25%;\n    background: #fff;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n}\n\n.form-1-col-1 {\n    border-radius: 10px 0px 0px 10px;\n}\n\n.form-1-col-3 {\n    padding-top: 11px;\n    border-radius: 0px 10px 10px 0px;\n}\n\n.form-1 label {\n    margin: 0px 0px 5px 0px;\n    font-family: 'Geologica';\n    font-style: normal;\n    font-weight: 400;\n    font-size: 11px;\n    line-height: 14px;\n    /*color: #828282;*/\n    color: #000;\n}\n\n/* *******************\nSelect c dropdown на JS\n******************* */\n\n.dropdown {\n    /*position: relative;*/\n    width: 100%;\n}\n\n.dropdown__button {\n    position: relative;\n    display: block;\n    width: 100%;\n    text-align: left;\n\n    background: #FFFFFF;\n    border: 0px solid #7E9BBD;\n    border-radius: 0px;\n    height: 25px;\n\n    padding-top: 0px;\n    padding-bottom: 15px;\n    padding-left: 0px;\n    padding-right: 35px;\n    /*padding-right: 35px;*/\n\n    font-weight: 500;\n    font-size: 16px;\n    line-height: 20px;\n\n    cursor: pointer;\n    font-family: 'Geologica';\n    font-style: normal;\n    font-weight: 400;\n    font-size: 16px;\n    line-height: 20px;\n    /*color: #000000;*/\n    color: #828282;\n}\n\n.dropdown__button:focus,\n.dropdown__button--active {\n    outline: none;\n    box-shadow: 0px 0px 0px 0px rgba(176, 198, 225, 0.6);\n}\n\n.dropdown__button::after {\n    content: \"\";\n    position: absolute;\n    top: 50%;\n    right: 0px;\n    /*right: 15px;*/\n    transform: translateY(-50%);\n\n    /* Рисуем треугольник */\n    width: 0;\n    height: 0;\n    border-width: 10.4px 6px 0 6px;\n    border-color: #828282 transparent transparent transparent;\n    border-style: solid;\n\n    /* Снимаем клик с треугольника */\n    pointer-events: none;\n}\n\n.dropdown__list_prc {\n    display: block;\n    position: absolute;\n    left: 0px;\n    top: 70px;\n    margin: 0;\n    padding: 0;\n    list-style-type: none;\n\n    background: #ffffff00;\n    box-shadow: 0px 4px 8px rgba(176, 198, 225, 0.6);\n    overflow-x: hidden;\n    overflow-y: scroll;\n    border: 1px solid #5e5d5d;\n    /*border: 1px solid #fff;*/\n    border-radius: 0 0 10px 10px;\n    width: 100%;\n    max-height: 205px;\n    z-index: 2;\n}\n\n.dropdown__list {\n    display: block;\n    position: absolute;\n    left: 0px;\n    top: 70px;\n    margin: 0;\n    padding: 0;\n    list-style-type: none;\n\n    background: #ffffff00;\n    box-shadow: 0px 4px 8px rgba(176, 198, 225, 0.6);\n    overflow: hidden;\n    border: 1px solid #5e5d5d;\n    /*border: 1px solid #fff;*/\n    border-radius: 0 0 10px 10px;\n    width: 100%;\n    max-height: 205px;\n    z-index: 2;\n}\n\n.dropdown__list:hover {\n    border: 1px solid #5e5d5d;\n}\n\n.dropdown__list--visible {\n    display: block;\n}\n\n.dropdown__list-item {\n    position: relative;\n    width: 100%;\n    margin: 0;\n    padding: 0;\n    background: #fff;\n    border-left: 0px solid #ccc;\n    border-top: 0px solid #ccc;\n    border-bottom: 0px;\n    padding: 10px 20px 10px 20px;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n}\n\n.dropdown__list-item span {\n    font-size: 11px;\n    font-weight: 400;\n    line-height: 14px;\n    letter-spacing: 0em;\n    text-align: right;\n}\n\n.dropdown__list-item-text {\n    margin: 3px 0px 0px 0px;\n    font-size: 11px;\n    font-weight: 400;\n    line-height: 14px;\n    letter-spacing: 0em;\n    text-align: right;\n}\n\n.dropdown__list-item-text-2 {\n    position: absolute;\n    z-index: 2;\n    right: 10px;\n    top: 10px;\n}\n\n.dropdown__list-item-2 {\n    padding: 10px 20px 10px 40px;\n}\n\n.dropdown__list-item:first-child {\n    border-radius: 0px 0px 0 0;\n}\n\n.dropdown__list-item:last-child {\n    border-radius: 0 0 10px 10px;\n    border-bottom: 0px solid #828282;\n}\n\n.dropdown__list-item:hover {\n    background: #FFEB39;\n}\n\n.dropdown__input-hidden {\n    display: none;\n}\n\n.pole {\n    font-family: 'Geologica';\n    font-style: normal;\n    font-weight: 400;\n    font-size: 16px;\n    line-height: 20px;\n    color: #000000;\n    border: none;\n    outline: none;\n    width: 100%;\n\n}\n\n.pole::placeholder {\n    /*color: #000000;*/\n    color: #828282;\n    opacity: 1;\n}\n\n.pole:-ms-input-placeholder {\n    color: #000000;\n}\n\n.pole::-ms-input-placeholder {\n    color: #000000;\n}\n\n.button {\n    width: 25%;\n    height: 70px;\n    background: #FFEB39;\n    border-radius: 10px;\n    border: none;\n    font-style: normal;\n    font-weight: 400;\n    font-size: 17px;\n    line-height: 21px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    text-align: center;\n    color: #000000;\n    cursor: pointer;\n}\n\n.button:hover {\n    background: linear-gradient(0deg, rgba(255, 255, 255, 0.5), rgba(255, 255, 255, 0.5)), #FFEB39;\n}\n\n.button:active {\n    border: 2px solid #000000;\n    background: none;\n}\n\n.button:visited {\n    background: none;\n    border: 2px solid #828282;\n    /*color: #828282;*/\n    color: #000;\n}\n\n.bank-image {\n    width: 18px;\n    position: absolute;\n    top: 30%;\n    left: 15px;\n    margin: 0px 0px 0px 0px;\n}\n\n@media (max-width: 1920px) {\n    .one-ekran {\n        width: 100%;\n        height: 878px;\n    }\n}\n\n@media (max-width: 1600px) {\n    .one-ekran {\n        height: 760px;\n    }\n\n    .conteiner {\n        /*width: 1360px;*/\n        width: 1120px;\n    }\n}\n\n@media (max-width: 1366px) {\n    .one-ekran {\n        height: 650px;\n    }\n\n    .conteiner {\n        /*width: 1200px;*/\n        width: 1000px;\n    }\n\n    .one-ekran-contant {\n        padding: 150px 0px 0px 0px;\n    }\n\n    .form-1 {\n        margin: 70px auto 0px auto;\n    }\n}\n\n@media (max-width: 1280px) {\n    .one-ekran {\n        height: 584px;\n        background-image: url(../img/fon-1-main-mob.jpg);\n    }\n\n    .conteiner {\n        width: 954px;\n    }\n\n    .one-ekran-contant {\n        padding: 120px 0px 0px 0px;\n    }\n\n    .form-1 {\n        margin: 50px auto 0px auto;\n    }\n}\n\n@media (max-width: 1180px) {\n    .h1 {\n        font-size: 56px;\n    }\n\n    .one-ekran-contant-text {\n        font-size: 22px;\n        line-height: 26px;\n    }\n\n    .form-1 {\n        /*height: 60px;*/\n    }\n\n    .dropdown__list {\n        /* top: 60px;*/\n    }\n\n    .button {\n        /*height: 60px;*/\n    }\n}\n\n@media (max-width: 1100px) {\n    .conteiner {\n        width: 100%;\n        padding: 0px 20px 0px 20px;\n    }\n}\n\n@media (max-width: 1080px) {\n    .one-ekran {\n        height: 550px;\n    }\n\n    .h1 {\n        font-size: 52px;\n    }\n\n    .one-ekran-contant-text {\n        font-size: 20px;\n        line-height: 22px;\n    }\n\n    .form-1 {\n        /*height: 58px;*/\n    }\n\n    .dropdown__list {\n        /*top: 58px;*/\n    }\n\n    .button {\n        /*height: 58px;*/\n    }\n}\n\n@media (max-width: 1024px) {\n    .one-ekran {\n        height: 510px;\n    }\n\n    .conteiner {\n        width: 100%;\n        padding: 0px 20px 0px 20px;\n    }\n\n    .h1 {\n        font-size: 44px;\n    }\n\n    .one-ekran-contant-text {\n        font-size: 18px;\n        line-height: 20px;\n    }\n}\n\n@media (max-width: 900px) {\n    .one-ekran {\n        height: 500px;\n    }\n\n    .h1 {\n        font-size: 40px;\n    }\n\n    .one-ekran-contant-text {\n        font-size: 16px;\n        line-height: 18px;\n    }\n}\n\n@media (max-width: 899px) {\n    .one-ekran {\n        height: 550px;\n    }\n\n    .one-ekran-contant {\n        padding: 100px 0px 0px 0px;\n    }\n\n    .h1 {\n        font-size: 38px;\n    }\n\n    .form-1 {\n        flex-direction: column;\n        width: 400px;\n        height: 70px;\n        margin: 20px auto 0px auto;\n    }\n\n    .dropdown__list {\n        top: 57px;\n    }\n\n    .form-1-col {\n        width: 100%;\n        margin: 0px 0px 5px 0px;\n    }\n\n    .form-1-col-1 {\n        border-radius: 10px 10px 0px 0px;\n    }\n\n    .form-1-col-2 {}\n\n    .form-1-col-3 {\n        border-radius: 0px 0px 10px 10px;\n    }\n\n    .button {\n        height: 70px;\n        width: 100%;\n        padding: 25px 0px 24px 0px;\n    }\n}\n\n@media (max-width: 768px) {\n    .h1 {\n        font-size: 36px;\n    }\n}\n\n@media (max-width: 500px) {\n    .one-ekran {\n        height: 400px;\n        margin: 20px auto 250px auto;\n        border-radius: 50px 50px 0px 0px;\n    }\n\n    .one-ekran-contant {\n        padding: 70px 0px 0px 0px;\n    }\n\n    .h1 {\n        font-size: 32px;\n    }\n\n    .one-ekran-contant-text {\n        margin: 10px 0px 0px 0px;\n    }\n\n    .form-1 {\n        width: 100%;\n        height: auto;\n        margin: 150px auto 0px auto;\n        padding: 20px 20px 20px 20px;\n        background: #fff;\n        border-radius: 30px 30px 30px 30px;\n    }\n\n    .dropdown__button {\n        background: #f5f5f5;\n    }\n\n    .form-1-col {\n        width: 100%;\n        height: 58px;\n        background: #f5f5f5;\n        margin: 0px 0px 5px 0px;\n        padding: 12px 20px 20px 20px;\n    }\n\n    .pole::placeholder {\n        background: #f5f5f5;\n        font-weight: 500;\n    }\n\n    .pole:-ms-input-placeholder {\n        background: #f5f5f5;\n        font-weight: 500;\n    }\n\n    .pole::-ms-input-placeholder {\n        background: #f5f5f5;\n        font-weight: 500;\n    }\n\n    .pole {\n        background: #f5f5f5;\n    }\n\n    .button {\n        height: auto;\n        padding: 25px 0px 25px 0px;\n    }\n\n}\n\n/******** section-two ************/\n.section-two {\n    width: 1920px;\n    padding: 120px 0px 100px 0px;\n    margin: 0px auto 0px auto;\n}\n\n.section-two-contant {\n    width: 100%;\n    display: flex;\n    justify-content: space-between;\n}\n\n.section-two-item {\n    flex: 0 0 33.333%;\n    margin: 0px 5px 0px 5px;\n}\n\n.section-two-item img {\n    width: 100%;\n    border-radius: 30px 30px 0px 0px;\n}\n\n.section-two-bloktext {\n    position: relative;\n    width: 100%;\n    height: 190px;\n    background: #fff;\n    border-radius: 30px 30px 30px 30px;\n    padding: 30px 30px 30px 30px;\n    margin: -130px 0px 0px 0px;\n}\n\n.section-two-text-1 {\n    margin: 0px 0px 20px 0px;\n    font-size: 18px;\n    font-weight: 600;\n    line-height: 20px;\n    letter-spacing: 0em;\n    text-align: left;\n}\n\n.section-two-text-2 {\n    font-size: 14px;\n    font-weight: 300;\n    line-height: 17px;\n    letter-spacing: 0em;\n    text-align: left;\n    color: #828282;\n}\n\n.section-two-icon {\n    position: absolute;\n    width: 103px !important;\n    right: 10px;\n    top: -35px;\n}\n\n@media (max-width: 1920px) {\n    .section-two {\n        width: 100%;\n    }\n}\n\n@media (max-width: 1366px) {\n    .section-two {\n        padding: 80px 0px 70px 0px;\n    }\n\n    .section-two-item {\n        flex: 0 0 32%;\n        margin: 0px 0px 0px 0px;\n    }\n\n    .section-two-item img {\n        max-width: 100%;\n    }\n}\n\n@media (max-width: 1024px) {\n    .section-two {\n        padding: 60px 0px 50px 0px;\n    }\n\n    .section-two-icon {\n        width: 90px !important;\n    }\n}\n\n@media (max-width: 940px) {\n    .section-two-bloktext {\n        height: 205px;\n    }\n}\n\n@media (max-width: 900px) {\n    .section-two-bloktext {\n        height: 220px;\n    }\n}\n\n@media (max-width: 899px) {\n    .section-two {\n        padding: 60px 0px 20px 0px;\n    }\n\n    .section-two-contant {\n        flex-wrap: wrap;\n        justify-content: center;\n    }\n\n    .section-two-item {\n        flex: 0 0 47%;\n        margin: 0px 10px 30px 10px;\n    }\n\n    .section-two-bloktext {\n        height: 180px;\n    }\n}\n\n@media (max-width: 710px) {\n    .section-two-item {\n        flex: 0 0 46%;\n    }\n}\n\n@media (max-width: 700px) {\n    .section-two-item {\n        flex: 0 0 46%;\n    }\n\n    .section-two-bloktext {\n        height: 190px;\n    }\n}\n\n@media (max-width: 667px) {\n    .section-two-bloktext {\n        height: 200px;\n    }\n}\n\n@media (max-width: 620px) {\n    .section-two-bloktext {\n        height: 220px;\n    }\n}\n\n@media (max-width: 600px) {\n    .section-two-item {\n        flex: 0 0 350px;\n        margin: 0px 0px 30px 0px;\n    }\n\n    .section-two-bloktext {\n        height: 160px;\n    }\n}\n\n@media (max-width: 500px) {\n    .section-two {\n        padding: 50px 0px 20px 0px;\n    }\n\n    .section-two-image {\n        display: none;\n    }\n\n    .section-two-bloktext {\n        margin: 0px 0px 0px 0px;\n    }\n\n    .section-two-bloktext-mob {\n        margin: -130px 0px 0px 0px;\n    }\n\n    .section-two-icon {\n        width: 100px !important;\n    }\n}\n\n@media (max-width: 428px) {\n    .section-two-item {\n        flex: 0 0 100%;\n        margin: 0px 0px 10px 0px;\n    }\n}\n\n@media (max-width: 390px) {\n    .section-two-bloktext {\n        height: 180px;\n    }\n}\n\n@media (max-width: 330px) {\n    .section-two-bloktext {\n        height: 190px;\n    }\n}\n\n@media (max-width: 330px) {\n    .section-two-bloktext {\n        height: auto;\n    }\n}\n\n/********** section-three ************/\n.section-three {\n    width: 1920px;\n    padding: 0px 50px 100px 50px;\n    margin: 0px auto 0px auto;\n\n}\n\n.section-three-contant {\n    width: 100%;\n    background: #FFf;\n    padding: 60px 0px 60px 0px;\n    border-radius: 60px;\n}\n\n.h2 {\n    font-size: 36px;\n    font-weight: 400;\n    line-height: 43px;\n    letter-spacing: 0em;\n    text-align: center;\n}\n\n.h2-s3-2 {\n    display: none;\n}\n\n.section-three-items {\n    width: 100%;\n    margin: 50px 0px 40px 0px;\n    display: flex;\n    justify-content: space-between;\n}\n\n.section-three-item {\n    flex: 0 0 33.333%;\n    margin: 0px 5px 0px 5px;\n}\n\n.section-three-item img {\n    width: 100%;\n    border-radius: 10px 10px 0px 0px;\n}\n\n.s3-icon {\n    width: 24px !important;\n    margin: 0px 0px 10px 0px;\n}\n\n.section-three-bloktext {\n    height: 230px;\n    position: relative;\n    margin: -100px 0px 0px 0px;\n    padding: 30px 30px 30px 30px;\n    background: #f5f5f5;\n    border-radius: 10px;\n}\n\n.button-1 {\n    margin: 0px auto 0px auto;\n}\n\n.section-three-img-4 {\n    display: none;\n}\n\n.s3-icon-4 {\n    width: 94px !important;\n    position: absolute;\n    top: -30px;\n    right: 20px;\n}\n\n@media (max-width: 1920px) {\n    .section-three {\n        width: 100%;\n    }\n}\n\n@media (max-width: 1366px) {\n    .section-three {\n        padding: 0px 50px 80px 50px;\n    }\n\n    .section-three-item {\n        flex: 0 0 32%;\n        margin: 0px 0px 0px 0px;\n    }\n\n    .section-three-bloktext {\n        height: 260px;\n    }\n}\n\n@media (max-width: 1180px) {\n    .section-three-contant {\n        padding: 60px 20px 60px 20px;\n        box-sizing: border-box;\n    }\n\n    .h2 {\n        font-size: 32px;\n        line-height: 36px;\n    }\n}\n\n@media (max-width: 1100px) {\n    .section-three {\n        padding: 0px 20px 70px 20px;\n    }\n\n    .section-three-items {\n        margin: 30px 0px 40px 0px;\n    }\n\n    .section-three-item {\n        flex: 0 0 31%;\n    }\n\n}\n\n@media (max-width: 1080px) {\n    .section-three-bloktext {\n        height: 280px;\n    }\n\n    .h2 {\n        font-size: 30px;\n        line-height: 32px;\n    }\n}\n\n@media (max-width: 1024px) {\n    .section-three {\n        padding: 0px 20px 50px 20px;\n    }\n\n    .section-three-item {\n        flex: 0 0 32%;\n    }\n\n    .section-three-bloktext {\n        height: 300px;\n        margin: -65px 0px 0px 0px;\n    }\n\n    .h2 {\n        font-size: 28px;\n        line-height: 30px;\n    }\n}\n\n@media (max-width: 960px) {\n    .section-three-bloktext {\n        height: 300px;\n    }\n\n    .h2 {\n        font-size: 26px;\n        line-height: 28px;\n    }\n}\n\n@media (max-width: 899px) {\n    .section-three-items {\n        flex-wrap: wrap;\n        justify-content: center;\n        margin: 30px 0px 30px 0px;\n    }\n\n    .section-three-item {\n        flex: 0 0 46%;\n        margin: 0px 10px 20px 10px;\n    }\n\n    .section-three-bloktext {\n        height: 240px;\n    }\n\n    .h2 {\n        font-size: 24px;\n        line-height: 26px;\n    }\n\n    .button-1 {\n        width: 350px;\n    }\n}\n\n@media (max-width: 812px) {\n    .section-three-bloktext {\n        height: 260px;\n    }\n}\n\n@media (max-width: 700px) {\n    .section-three {\n        padding: 0px 0px 50px 0px;\n    }\n\n    .section-three-bloktext {\n        height: 280px;\n    }\n}\n\n@media (max-width: 630px) {\n    .section-three-bloktext {\n        height: 300px;\n    }\n}\n\n@media (max-width: 600px) {\n    .section-three-item {\n        flex: 0 0 350px;\n        margin: 0px 0px 20px 0px;\n    }\n\n    .section-three-bloktext {\n        height: 260px;\n    }\n\n    .s3-icon-4 {\n        width: 110px !important;\n        top: -35px;\n        right: 10px;\n    }\n}\n\n@media (max-width: 500px) {\n    .h2 {\n        font-size: 24px;\n        line-height: 26px;\n    }\n\n    .section-three-image {\n        display: none;\n    }\n\n    .section-three-bloktext {\n        height: auto;\n        margin: 0px 0px 0px 0px;\n    }\n\n    .section-three-bloktext-3 {\n        margin: -20px 0px 0px 0px;\n    }\n\n    .section-three-items {\n        margin: 30px 0px 30px 0px;\n    }\n\n    .section-three-item {\n        margin: 0px 0px 10px 0px;\n    }\n\n    .section-three-img-3 {\n        display: none;\n    }\n\n    .section-three-img-4 {\n        display: block;\n    }\n\n}\n\n@media (max-width: 428px) {\n    .section-three-contant {\n        padding: 60px 0px 60px 0px;\n    }\n\n    .h2 {\n        text-align: left;\n    }\n\n    .h2-s3 {\n        padding: 0px 20px 0px 20px;\n    }\n\n    .h2-s3-1 {\n        display: none;\n    }\n\n    .h2-s3-2 {\n        display: block;\n    }\n\n    .section-three-item {\n        flex: 0 0 100%;\n        margin: 0px 0px 15px 0px;\n    }\n\n    .button-1 {\n        width: 100%;\n    }\n}\n\n@media (max-width: 389px) {\n    .h2 {\n        font-size: 22px;\n        line-height: 24px;\n    }\n\n    .s3-icon-4 {\n        width: 90px !important;\n    }\n}\n\n@media (max-width: 360px) {\n    .h2 {\n        font-size: 20px;\n        line-height: 22px;\n    }\n}\n\n@media (max-width: 320px) {\n    .h2 {\n        font-size: 18px;\n        line-height: 20px;\n    }\n}\n\n/********************/\n.section-foor {\n    width: 1920px;\n    padding: 0px 0px 100px 0px;\n    margin: 0px auto 0px auto;\n}\n\n.conteiner {}\n\n.section-foor-contant {\n    position: relative;\n}\n\n.section-foor-image {\n    max-width: 100%;\n    border-radius: 30px;\n}\n\n.h2-s4 {\n    position: absolute;\n    right: 0;\n    top: 0;\n}\n\n.section-foor-item {\n    width: 60%;\n    position: absolute;\n    right: 0;\n    top: 40%;\n    display: flex;\n}\n\n.section-foor-bloktext {\n    position: relative;\n    flex: 0 0 50%;\n    background: #FFf;\n    border-radius: 20px;\n    margin: 0px 0px 0px 20px;\n    padding: 30px 30px 30px 30px;\n}\n\n.section-foor-icon {\n    position: absolute;\n    right: -10px;\n    top: -60px;\n}\n\n@media (max-width: 1920px) {\n    .section-foor {\n        width: 100%;\n    }\n}\n\n@media (max-width: 1366px) {\n    .section-foor {\n        padding: 0px 0px 70px 0px;\n    }\n\n    .section-foor-item {\n        width: 70%;\n    }\n}\n\n@media (max-width: 1100px) {\n    .section-foor-item {\n        width: 70%;\n        right: 40px;\n        top: 31%;\n    }\n\n    .section-foor-image {\n        width: 500px;\n    }\n}\n\n@media (max-width: 1024px) {\n    .section-foor {\n        padding: 0px 0px 50px 0px;\n    }\n}\n\n\n@media (max-width: 960px) {\n    .section-foor-item {\n        width: 80%;\n    }\n}\n\n@media (max-width: 900px) {\n    .section-foor-item {\n        width: 85%;\n    }\n}\n\n@media (max-width: 800px) {\n    .section-foor-item {\n        width: 90%;\n    }\n}\n\n@media (max-width: 768px) {\n    .section-foor-item {\n        width: 95%;\n    }\n\n    .section-foor-icon {\n        width: 109px;\n        right: 0px;\n        top: -45px;\n    }\n}\n\n@media (max-width: 700px) {\n    .section-foor-item {\n        width: 95%;\n        right: 20px;\n    }\n\n    .section-foor-icon {\n        display: none;\n    }\n\n    .section-foor-bloktext {\n        margin: 0px 0px 0px 10px;\n        padding: 20px 20px 20px 20px;\n    }\n}\n\n@media (max-width: 667px) {\n    .section-foor-item {\n        flex-direction: column;\n        width: 315px;\n        right: 0px;\n        top: 12%;\n    }\n\n    .section-foor-bloktext {\n        margin: 0px 0px 10px 10px;\n        padding: 20px 20px 20px 20px;\n    }\n}\n\n@media (max-width: 630px) {\n    .h2-s4 {\n        display: none;\n    }\n\n    .section-foor-image {\n        width: 400px;\n    }\n\n    .section-foor-item {\n        top: 3.5%;\n    }\n}\n\n@media (max-width: 600px) {\n    .section-foor-image {\n        width: 100%;\n    }\n\n    .section-foor-item {\n        top: 16%;\n        right: 10px;\n    }\n}\n\n@media (max-width: 500px) {\n    .section-foor {\n        overflow: hidden;\n    }\n\n    .section-foor-item {\n        margin: -180px 0px 0px 0px;\n        position: relative;\n        flex-direction: row;\n        width: 100%;\n        left: 10px;\n        right: 0px;\n        top: 48%;\n    }\n\n    .section-foor-bloktext {\n        flex: 0 0 55%;\n    }\n}\n\n@media (max-width: 428px) {\n    .section-foor-bloktext {\n        flex: 0 0 70%;\n    }\n}\n\n@media (max-width: 414px) {\n    .section-foor-bloktext {\n        flex: 0 0 73%;\n    }\n}\n\n@media (max-width: 390px) {\n    .section-foor-bloktext {\n        flex: 0 0 76%;\n    }\n}\n\n@media (max-width: 389px) {\n    .section-foor-bloktext {\n        flex: 0 0 76%;\n    }\n\n    .section-foor-item {\n        margin: 0px 0px 0px 0px;\n        position: absolute;\n        flex-direction: column;\n        width: 92%;\n        left: 10px;\n        right: 10px;\n        top: 9%;\n    }\n\n    .section-foor-image {\n        height: 320px;\n        object-fit: cover;\n    }\n}\n\n@media (max-width: 340px) {\n    .section-foor-item {\n        top: 12%;\n    }\n\n    .section-foor-image {\n        height: 350px;\n    }\n}\n\n@media (max-width: 320px) {\n    .section-foor-item {\n        top: 9%;\n    }\n\n    .section-foor-image {\n        height: 360px;\n    }\n}\n\n\n/********  vopros  ***************************/\n.prodat-section-4 {\n    width: 1920px;\n    padding: 0px 0px 0px 0px;\n    margin: 0px auto 40px auto;\n}\n\n.prodat-section-4 {\n    text-align: center;\n    display: flex;\n}\n\n.vopros-col-1 {\n    flex: 0 0 70%;\n    padding: 0px 0px 0px 15%;\n}\n\n.vopros-col-2 {\n    flex: 0 0 30%;\n    text-align: right;\n    display: flex;\n    justify-content: flex-end;\n    align-items: flex-end;\n    padding: 90px 0px 70px 0px;\n}\n\n.vopros-col-2 img {\n    max-width: 100%;\n    height: 100%;\n    object-fit: cover;\n    border-radius: 20px 0px 0px 20px;\n}\n\n.prodat-section-4-contant {\n    width: 100%;\n    padding: 0px 0px 30px 0px;\n}\n\n.vopros {\n    width: 100%;\n    margin: 0px 0px 0px 0px;\n    padding: 0px 0px 0px 0px;\n}\n\n.h2-vopros {\n    text-align: left;\n}\n\n.vopros-contant {\n    width: 100%;\n    margin: 0px 0px 0px 0px;\n    padding: 100px 0px 0px 0px;\n    text-align: center;\n}\n\n.vopros-spoiler {\n    width: 100%;\n    margin: 0px auto 0px auto;\n    padding: 20px 20px 20px 0px;\n}\n\n.vopros-spoiler-vopros-wrapper {\n    text-align: left;\n}\n\n.vopros-spoiler-vopros {\n    position: relative;\n    font-size: 20px;\n    font-weight: 600;\n    margin: 30px 0px 0px 0px;\n    padding: 20px 40px 20px 0px;\n    cursor: pointer;\n    border-top: 1px solid #bbb;\n}\n\n.vopros-spoiler-vopros:hover {\n    color: #000;\n}\n\n.vopros-spoiler-otvet {\n    font-size: 16px;\n    font-weight: 400;\n    line-height: 1.3;\n    margin: 0px 0px 30px 0px;\n    padding: 0px 30px 20px 0px;\n    color: #828282;\n}\n\n.vopros-spoiler-vopros-1 {\n    color: #000;\n}\n\n.vopros-spoiler-otvet-1 {\n    display: none;\n}\n\n.vopros-spoiler-otvet-2 {\n    display: none;\n}\n\n.vopros-spoiler-otvet-3 {\n    display: none;\n}\n\n.vopros-spoiler-otvet-4 {\n    display: none;\n}\n\n.vopros-spoiler-otvet-5 {\n    display: none;\n}\n\n.vopros-spoiler-otvet-6 {\n    display: none;\n}\n\n.block {\n    display: block;\n}\n\n.none {\n    display: none;\n}\n\n.button-vopros {\n    margin: 0px 0px 0px 0px;\n}\n\n.icon-down-arrow {\n    position: absolute;\n    right: 0;\n    top: 25px;\n}\n\n.rotate-1 .vopros-spoiler-otvet-1 {\n    display: block;\n}\n\n.rotate-1 .icon-down-arrow-1 {\n    transform: rotate(-180deg);\n    transition: .3s;\n}\n\n.rotate-2 .icon-down-arrow-2 {\n    transform: rotate(-180deg);\n    transition: .3s;\n}\n\n.rotate-3 .icon-down-arrow-3 {\n    transform: rotate(-180deg);\n    transition: .3s;\n}\n\n.rotate-4 .icon-down-arrow-4 {\n    transform: rotate(-180deg);\n    transition: .3s;\n}\n\n.rotate-5 .icon-down-arrow-5 {\n    transform: rotate(-180deg);\n    transition: .3s;\n}\n\n.rotate-6 .icon-down-arrow-6 {\n    transform: rotate(-180deg);\n    transition: .3s;\n}\n\n#controls span {\n    display: inline-block;\n}\n\n.video-blok {\n    display: none;\n    justify-content: center;\n}\n\n@media (max-width: 1920px) {\n    .prodat-section-4 {\n        width: 100%;\n    }\n}\n\n@media (max-width: 1600px) {\n    .vopros-col-2 {\n        padding: 90px 0px 60px 0px;\n    }\n}\n\n@media (max-width: 1536px) {\n    .vopros-col-1 {\n        padding: 0px 0px 0px 14%;\n    }\n\n    .vopros-col-2 img {\n        max-width: 100%;\n    }\n}\n\n@media (max-width: 1440px) {\n    .vopros-col-1 {\n        padding: 0px 0px 0px 12%;\n    }\n}\n\n@media (max-width: 1366px) {\n    .prodat-section-4 {\n        padding: 0px 0px 0px 0px;\n    }\n\n    .vopros-col-1 {\n        padding: 0px 0px 0px 14%;\n    }\n\n    .vopros-col-2 {\n        padding: 70px 0px 40px 10px;\n    }\n\n    .vopros-spoiler {\n        margin: 20px auto 0px auto;\n        padding: 0px 0px 0px 0px;\n    }\n\n    .vopros-spoiler-vopros {\n        font-size: 19px;\n    }\n\n    .vopros-spoiler-otvet {\n        font-size: 15px;\n        line-height: 1.4;\n    }\n}\n\n@media (max-width: 1280px) {\n    .vopros-col-1 {\n        flex: 0 0 60%;\n        width: 60%;\n        padding: 0px 0px 0px 13%;\n    }\n\n    .vopros-col-2 {\n        flex: 0 0 40%;\n        width: 40%;\n        padding: 70px 0px 40px 20px;\n    }\n}\n\n@media (max-width: 1180px) {\n    .vopros-col-1 {\n        padding: 0px 0px 0px 10%;\n    }\n\n}\n\n@media (max-width: 1100px) {\n    .vopros-col-1 {\n        flex: 0 0 55%;\n        width: 55%;\n        padding: 0px 0px 0px 20px;\n    }\n\n    .vopros-col-2 {\n        flex: 0 0 45%;\n        width: 45%;\n        padding: 60px 0px 40px 20px;\n    }\n\n}\n\n@media (max-width: 1024px) {\n    .vopros-spoiler {\n        margin: 30px auto 0px auto;\n    }\n\n    .vopros-spoiler-vopros {\n        font-size: 18px;\n        margin: 0px 0px 20px 0px\n    }\n\n    .vopros-spoiler-otvet {\n        font-size: 14px;\n        line-height: 1.4;\n    }\n}\n\n@media (max-width: 900px) {\n    .vopros-spoiler-vopros {\n        font-size: 16px;\n        margin: 0px 0px 0px 0px;\n    }\n\n    .vopros-spoiler-otvet {\n        font-size: 14px;\n        line-height: 1.4;\n        padding: 0px 30px 0px 0px;\n    }\n}\n\n@media (max-width: 899px) {\n    .vopros-col-1 {\n        flex: 0 0 100%;\n        padding: 0px 20px 0px 20px;\n    }\n\n    .vopros-col-2 {\n        display: none;\n    }\n\n    .vopros-col-2 img {\n        display: none;\n    }\n\n    .video-blok {\n        margin: 0px 0px 60px 0px;\n        display: flex;\n        justify-content: center;\n    }\n\n    .video-player {\n        width: 500px;\n        border-radius: 20px;\n\n    }\n\n    .video-button {\n        padding: 6% 0px 0px 0px;\n        margin-top: 0px;\n        position: absolute;\n        width: 100%;\n        height: 246px;\n        opacity: 1;\n        background: #ffeb3900;\n        border: none;\n    }\n}\n\n@media (max-width: 568px) {\n    .video-blok {\n        padding: 0px 20px 0px 20px;\n    }\n\n    .video-player {\n        width: 100%;\n    }\n}\n\n@media (max-width: 500px) {\n    .prodat-section-4 {\n        padding: 20px 0px 0px 0px;\n    }\n\n    .vopros-spoiler-vopros {\n        margin: 0px 0px 30px 0px;\n        padding: 20px 35px 0px 0px;\n    }\n\n    .vopros-spoiler-otvet {\n        padding: 0px 30px 0px 0px;\n    }\n\n    .dropdown__button-popup {\n        background: #fff;\n    }\n}\n\n@media (max-width: 460px) {\n    .h2-vopros {\n        text-align: center;\n    }\n}\n\n@media (max-width: 460px) {\n    .prodat-section-4-contant {\n        padding: 0px 0px 0px 0px;\n    }\n}\n\n@media (max-width: 428px) {\n    .video-button {\n        padding: 0% 0px 0px 0px;\n    }\n}\n\n@media (max-width: 414px) {\n    .video-button img {\n        margin: -25px 0px 0px 0px;\n    }\n}\n\n@media (max-width: 390px) {\n    .video-button img {\n        margin: -35px 0px 0px 0px;\n    }\n}\n\n@media (max-width: 375px) {\n    .prodat-section-4 {\n        padding: 0px 0px 0px 0px;\n    }\n\n    .vopros-spoiler-vopros {\n        padding: 0px 20px 0px 0px;\n    }\n\n    .video-button img {\n        margin: -50px 0px 0px 0px;\n    }\n}\n\n@media (max-width: 360px) {\n    .video-button img {\n        margin: -60px 0px 0px 0px;\n    }\n}\n\n@media (max-width: 320px) {\n    .video-button {\n        padding: 0% 0px 40px 0px;\n    }\n\n    .video-button img {\n        margin: -80px 0px 0px 0px;\n        width: 60px;\n        height: 60px;\n    }\n}\n\n/************ section-six **************/\n.section-six {\n    overflow: hidden;\n    width: 1920px;\n    padding: 0px 0px 120px 0px;\n    margin: 0px auto 0px auto;\n}\n\n.section-six-contant {\n    width: 100%;\n}\n\n.h2-news {\n    margin: 0px 0px 40px 0px;\n}\n\n.section-six-link:hover {\n    text-decoration: underline;\n}\n\n.section-six-text-2 {\n    margin: 20px 0px 0px 0px;\n}\n\n.swiper {\n    width: 100%;\n}\n\n.section-six-bloktext {\n    margin: -40px 0px 0px 0px;\n}\n\n@media (max-width: 1920px) {\n    .section-six {\n        width: 100%;\n    }\n\n    .section-six-contant {\n        width: 135%;\n    }\n}\n\n@media (max-width: 1100px) {\n    .section-six-contant {\n        width: 110%;\n    }\n\n}\n\n@media (max-width: 1024px) {\n    .section-six {\n        padding: 0px 0px 80px 0px;\n    }\n\n    .h2-news {\n        margin: 0px 0px 20px 0px;\n    }\n}\n\n@media (max-width: 899px) {\n    .section-six-item {\n        margin: 0px 0px 0px 0px;\n    }\n\n    .section-six-bloktext {\n        height: 220px;\n    }\n}\n\n@media (max-width: 700px) {\n    .section-six-bloktext {\n        height: 200px;\n    }\n}\n\n@media (max-width: 667px) {\n    .section-six-bloktext {\n        height: 200px;\n    }\n}\n\n@media (max-width: 390px) {\n    .section-six {\n        padding: 0px 0px 60px 0px;\n    }\n}\n\n\n@media (max-width: 320px) {\n    .section-six-bloktext {\n        height: 230px;\n    }\n}\n\n/********** footer **************/\n.footer {\n    width: 1920px;\n    padding: 80px 0px 80px 0px;\n    margin: 0px auto 0px auto;\n    border-radius: 60px 60px 0px 0px;\n    background: #4f4f4f;\n}\n\n.footer a:hover {\n    opacity: 0.7;\n}\n\n.footer-contant {\n    width: 100%;\n}\n\n.footer-contant-up {\n    padding: 0px 0px 30px 0px;\n    width: 100%;\n    display: flex;\n    border-bottom: 1px solid #ccc;\n}\n\n.footer-contant-up-col-1 {\n    flex: 0 0 60%;\n}\n\n.h2-footer {\n    text-align: left;\n    color: #FFf;\n}\n\n.footer-contacts-row {\n    margin: 20px 0px 20px 0px;\n    width: 30%;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n}\n\n.footer-phone-link {\n    font-size: 16px;\n    font-weight: 300;\n    line-height: 20px;\n    letter-spacing: 0em;\n    text-align: left;\n    color: #fff;\n}\n\n.footer-phone-text {\n    font-size: 16px;\n    font-weight: 300;\n    line-height: 20px;\n    letter-spacing: 0em;\n    text-align: left;\n    color: #828282;\n    margin: 0 !important;\n}\n\n.footer-contant-up-col-2 {\n    flex: 0 0 40%;\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n}\n\n.footer-button-text {\n    font-size: 16px;\n    font-weight: 300;\n    line-height: 20px;\n    letter-spacing: 0em;\n    text-align: left;\n    color: #fff;\n}\n\n.button-footer {\n    margin: 30px 0px 0px 0px;\n    width: 393px;\n    height: 57px;\n}\n\n.footer-contant-down {\n    width: 100%;\n    padding: 40px 0px 0px 0px;\n    display: flex;\n}\n\n.footer-contant-down-col-1 {\n    flex: 0 0 60%;\n}\n\n.footer-logo-text {\n    margin: 10px 0px 0px 0px;\n    font-size: 14px;\n    font-weight: 300;\n    line-height: 17px;\n    letter-spacing: 0em;\n    text-align: left;\n    color: #ccc;\n}\n\n.footer-blok-link {\n    margin: 50px 0px 0px 0px;\n    display: flex;\n}\n\n.footer-blok-link-left {\n    flex: 0 0 25%;\n    display: flex;\n    flex-direction: column;\n}\n\n.footer-link-text {\n    margin: 0px 0px 20px 0px;\n}\n\n.footer-link {\n    margin: 0px 0px 10px 0px;\n}\n\n.footer-blok-link-right {\n    flex: 0 0 25%;\n    display: flex;\n    flex-direction: column;\n}\n\n.footer-contant-down-col-2 {\n    flex: 0 0 40%;\n    display: flex;\n    flex-direction: column;\n}\n\n.footer-link-right {\n    text-decoration: underline;\n}\n\n.footer-description {\n    margin: 30px 0px 60px 0px;\n    font-size: 9px;\n    font-weight: 300;\n    line-height: 11px;\n    letter-spacing: 0.01em;\n    text-align: left;\n    color: #ccc;\n}\n\n@media (max-width: 1920px) {\n    .footer {\n        width: 100%;\n    }\n}\n\n@media (max-width: 1600px) {\n    .footer-contacts-row {\n        width: 40%;\n    }\n\n    .footer-blok-link-left,\n    .footer-blok-link-right {\n        flex: 0 0 30%;\n    }\n}\n\n@media (max-width: 1280px) {\n\n    .footer-blok-link-left,\n    .footer-blok-link-right {\n        flex: 0 0 40%;\n    }\n}\n\n@media (max-width: 1100px) {\n    .footer {\n        padding: 50px 20px 50px 20px;\n    }\n\n    .button-footer {\n        width: 100%;\n    }\n\n    .footer-contant-down-col-2 img {\n        max-width: 100%;\n    }\n}\n\n@media (max-width: 960px) {\n    .footer-contacts-row {\n        width: 50%;\n    }\n\n}\n\n@media (max-width: 768px) {\n    .footer-contant-up-col-1 {\n        flex: 0 0 100%;\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n    }\n\n    .footer-contant-up-col-2 {\n        display: none;\n    }\n\n    .h2-footer {\n        margin: 0px 0px 0px 0px;\n    }\n\n    .footer-contacts-row {\n        width: 100%;\n        margin: 10px 0px 0px 0px;\n    }\n\n    .button-footer {\n        width: 350px;\n    }\n\n    .footer-contant-down {\n        flex-direction: column;\n    }\n\n    .footer-contant-down-col-2 {\n        padding: 30px 0px 0px 0px;\n    }\n\n    .footer-blok-link-left,\n    .footer-blok-link-right {\n        flex: 0 0 50%;\n    }\n\n    .footer-phone-link-1 {\n        display: none;\n    }\n\n    .footer-phone-text {\n        display: none;\n    }\n\n    .footer-button-text-1 {\n        display: none;\n    }\n\n}\n\n@media (max-width: 500px) {\n    .footer {\n        padding: 50px 0px 50px 0px;\n    }\n\n    .button-footer {\n        width: 100%;\n    }\n}\n\n@media (max-width: 389px) {\n    .footer-blok-link {\n        flex-direction: column;\n    }\n\n    .footer-blok-link-right {\n        padding: 40px 0px 0px 0px;\n    }\n}\n\n/******************************************\n*************** POPUPS *********************\n*********************************************/\n\n/***** popup-1 *******/\n.b-popup {\n    position: relative;\n    display: block;\n    width: 100%;\n    min-height: 100%;\n    background-color: rgba(0, 0, 0, 0.5);\n    overflow: hidden;\n    position: fixed;\n    top: 0px;\n    z-index: 1006;\n    height: 95vh !important;\n    overflow-y: scroll !important;\n}\n\n.b-popup-vnutr {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n}\n\n.b-popup .b-popup-content {\n    position: relative;\n    margin: 20px auto 20px auto;\n    width: 390px;\n    height: auto;\n    padding: 20px;\n    background: #4F4F4FE5;\n    border: 0px solid #92B96A;\n    border-radius: 30px;\n    box-shadow: 0px 0px 10px #000;\n    z-index: 1007;\n\n\n    /*text-align: center;*/\n}\n\n.popup-title {\n    margin-bottom: 20px;\n    color: #FFf;\n    font-size: 18px;\n    font-weight: 300;\n    line-height: 20px;\n    letter-spacing: 0em;\n    text-align: left;\n}\n\n.popup-text {\n    font-size: 15px;\n    font-weight: 400;\n    margin-bottom: 20px;\n}\n\n.form-popup {\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n}\n\n.form-popup label {\n    margin: 0px 0px 5px 0px;\n    font-family: 'Geologica';\n    font-style: normal;\n    font-weight: 400;\n    font-size: 11px;\n    line-height: 14px;\n    color: #828282;\n}\n\n.one-ryad-popup {\n    position: relative;\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    background: #fff;\n    padding: 20px 0px 0px 20px;\n}\n\n.one-ryad-popup-1 {\n    border-radius: 10px 10px 0 0;\n    margin: 0px 0px 2px 0px;\n}\n\n.one-ryad-popup-2 {\n    margin: 0px 0px 2px 0px;\n}\n\n.one-ryad-popup-3 {\n    border-radius: 0px 0px 10px 10px;\n    margin: 0px 0px 20px 0px;\n    padding: 20px 20px 20px 20px;\n}\n\n.one-ryad-popup-4 {\n    border-radius: 10px 10px 0 0;\n    margin: 0px 0px 2px 0px;\n}\n\n.one-ryad-popup-5 {\n    margin: 0px 0px 2px 0px;\n}\n\n.one-ryad-popup-6 {\n    border-radius: 0px 0px 10px 10px;\n    margin: 0px 0px 20px 0px;\n}\n\n.pole-popup {\n    width: 100%;\n    padding: 0px 10px 0px 0px;\n    margin: 0px 0px 20px 0px;\n    text-align: left;\n    border: 0px solid #92B96A;\n    border-radius: 0px;\n    font-family: 'Geologica';\n    font-style: normal;\n    font-weight: 400;\n    font-size: 16px;\n    line-height: 20px;\n    color: #000000;\n    outline: none;\n}\n\n.button-popup-1 {\n    width: 100%;\n    cursor: pointer;\n    margin: 0px 0px 0px 0px;\n}\n\n.popup-close {\n    position: absolute;\n    top: 20px;\n    right: 20px;\n    width: 20px;\n}\n\n.popup-close img {\n    max-width: 100%;\n}\n\n.popup-close:hover {\n    opacity: 0.7;\n}\n\n@media (max-width: 1023px) {\n    .b-popup .b-popup-content {\n        margin: 10px auto 0px auto;\n    }\n}\n\n@media (max-width: 500px) {\n    .b-popup {\n        padding: 0px 20px 0px 20px;\n    }\n\n    .b-popup .b-popup-content {\n        width: 100%;\n    }\n\n    .popup-title {\n        font-size: 18px;\n    }\n\n}\n\n@media (max-width: 428px) {\n    .one-ryad-popup {\n        padding: 5px 0px 0px 20px;\n    }\n\n    .one-ryad-popup-3 {\n        padding: 5px 10px 14px 20px;\n    }\n\n    .dropdown__button-popup {\n        background: #fff;\n    }\n\n    .form-popup label {\n        margin: 5px 0px 5px 0px;\n    }\n}\n\n@media (max-width: 320px) {\n    .one-ryad-popup {\n        padding-left: 10px;\n    }\n\n    .popup-title {\n        font-size: 16px;\n    }\n}\n\n/***** popup-2 *******/\n.b-popup {\n    position: relative;\n    display: block;\n    width: 100%;\n    min-height: 100%;\n    background-color: rgba(0, 0, 0, 0.5);\n    overflow: hidden;\n    position: fixed;\n    top: 0px;\n    z-index: 1006;\n    height: 95vh !important;\n    overflow-y: scroll !important;\n}\n\n.b-popup-vnutr {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n}\n\n.b-popup .b-popup-content-2 {\n    position: relative;\n    margin: 20px auto 20px auto;\n    width: 390px;\n    height: auto;\n    padding: 20px;\n    background: #fff;\n    border: 0px solid #92B96A;\n    border-radius: 30px;\n    box-shadow: 0px 0px 10px #000;\n    z-index: 1007;\n\n\n    /*text-align: center;*/\n}\n\n.popup-title-2 {\n    margin-bottom: 20px;\n    color: #000;\n    font-size: 18px;\n    font-weight: 300;\n    line-height: 20px;\n    letter-spacing: 0em;\n    text-align: left;\n}\n\n.popup-text {\n    font-size: 15px;\n    font-weight: 400;\n    margin-bottom: 20px;\n}\n\n.form-popup {\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n}\n\n.form-popup label {\n    margin: 0px 0px 5px 0px;\n    font-family: 'Geologica';\n    font-style: normal;\n    font-weight: 400;\n    font-size: 11px;\n    line-height: 14px;\n    color: #828282;\n}\n\n.one-ryad-popup-user {\n    position: relative;\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    background: #f5f5f5;\n    padding: 20px 0px 0px 20px;\n}\n\n.one-ryad-popup-user-1 {\n    border-radius: 10px 10px 0 0;\n    margin: 0px 0px 3px 0px;\n}\n\n.one-ryad-popup-user-2 {\n    margin: 0px 0px 13px 0px;\n    border-radius: 0px 0px 10px 10px;\n}\n\n.popup2-link {\n    display: inline-block;\n    width: auto;\n    margin: 10px 0px 0px 0px;\n    font-size: 11px;\n    font-weight: 400;\n    line-height: 14px;\n    letter-spacing: 0em;\n    text-align: left;\n    color: #828282;\n    text-align: center;\n    text-decoration: underline;\n}\n\n.popup2-link:hover {\n    color: #000;\n}\n\n.pole-popup-user {\n    width: 100%;\n    padding: 0px 10px 0px 0px;\n    margin: 0px 0px 20px 0px;\n    text-align: left;\n    border: 0px solid #92B96A;\n    border-radius: 0px;\n    font-family: 'Geologica';\n    font-style: normal;\n    font-weight: 400;\n    font-size: 16px;\n    line-height: 20px;\n    color: #000000;\n    background: #f5f5f5;\n    outline: none;\n}\n\n@media (max-width: 1023px) {\n    .b-popup .b-popup-content {\n        margin: 10px auto 0px auto;\n    }\n}\n\n@media (max-width: 500px) {\n    .b-popup {\n        padding: 0px 20px 0px 20px;\n    }\n\n    .b-popup .b-popup-content {\n        width: 100%;\n    }\n\n    .popup-title {\n        font-size: 18px;\n    }\n\n}\n\n@media (max-width: 428px) {\n    .one-ryad-popup {\n        padding: 5px 0px 0px 20px;\n    }\n\n    .one-ryad-popup-3 {\n        padding: 5px 10px 14px 20px;\n    }\n\n    .dropdown__button-popup {\n        background: #fff;\n    }\n\n    .form-popup label {\n        margin: 5px 0px 5px 0px;\n    }\n}\n\n@media (max-width: 320px) {\n    .one-ryad-popup {\n        padding-left: 10px;\n    }\n\n    .popup-title {\n        font-size: 16px;\n    }\n}\n\n/***** popup-3 *******/\n.popup-text {\n    font-size: 11px;\n    font-weight: 400;\n    line-height: 14px;\n    letter-spacing: 0em;\n    text-align: left;\n    color: #828282;\n    margin-bottom: 20px;\n}\n\n.form-popup {\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n}\n\n.form-popup label {\n    margin: 0px 0px 5px 0px;\n    font-family: 'Geologica';\n    font-style: normal;\n    font-weight: 400;\n    font-size: 11px;\n    line-height: 14px;\n    color: #828282;\n}\n\n.dropdown__button-popup-user {\n    background: #f5f5f5;\n}\n\n.one-ryad-popup-user {\n    position: relative;\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    background: #f5f5f5;\n    padding: 20px 20px 0px 20px;\n}\n\n.one-ryad-popup-user-1 {\n    border-radius: 10px 10px 0 0;\n    margin: 0px 0px 3px 0px;\n}\n\n.one-ryad-popup-user-2 {\n    margin: 0px 0px 13px 0px;\n    border-radius: 0px 0px 10px 10px;\n}\n\n.one-ryad-popup-user-3 {\n    margin: 0px 0px 3px 0px;\n    border-radius: 10px 10px 0px 0px;\n}\n\n.one-ryad-popup-user-4 {\n    margin: 0px 0px 3px 0px;\n    border-radius: 0px 0px 0px 0px;\n}\n\n.one-ryad-popup-user-5 {\n    height: 79px;\n    margin: 0px 0px 20px 0px;\n    border-radius: 0px 0px 10px 10px;\n}\n\n.one-ryad-popup-user-6 {\n    margin: 0px 0px 3px 0px;\n    border-radius: 10px 10px 0px 0px;\n}\n\n.one-ryad-popup-user-7 {\n    margin: 0px 0px 3px 0px;\n    border-radius: 0px 0px 0px 0px;\n}\n\n.one-ryad-popup-user-8 {\n    margin: 0px 0px 20px 0px;\n    border-radius: 0px 0px 10px 10px;\n}\n\n@media (max-width: 1023px) {\n    .b-popup .b-popup-content {\n        margin: 10px auto 0px auto;\n    }\n}\n\n@media (max-width: 500px) {\n    .b-popup {\n        padding: 0px 20px 0px 20px;\n    }\n\n    .b-popup .b-popup-content {\n        width: 100%;\n    }\n\n    .popup-title {\n        font-size: 18px;\n    }\n\n}\n\n@media (max-width: 428px) {\n    .one-ryad-popup {\n        padding: 5px 0px 0px 20px;\n    }\n\n    .one-ryad-popup-3 {\n        padding: 5px 10px 14px 20px;\n    }\n\n    .dropdown__button-popup-user {\n        background: #f5f5f5;\n    }\n\n    .form-popup label {\n        margin: 5px 0px 5px 0px;\n    }\n}\n\n@media (max-width: 320px) {\n    .one-ryad-popup {\n        padding-left: 10px;\n    }\n\n    .popup-title {\n        font-size: 16px;\n    }\n}\n\n/**********************\n******** PAGE BANKS **********\n**********************/\n\n/******** one-ekran ************/\n.one-ekran-banks {\n    height: 705px;\n    padding: 0px 0px 0px 0px;\n    background-image: url(../img/fon-1-banks.jpg);\n}\n\n.one-ekran-banks-text {\n    margin: 20px auto 0px auto;\n    width: 760px;\n    text-align: center;\n}\n\n@media (max-width: 1600px) {\n    .one-ekran-banks {\n        height: 650px;\n    }\n}\n\n@media (max-width: 1440px) {\n    .one-ekran-banks {\n        height: 620px;\n    }\n\n    .one-ekran-contant-banks {\n        padding: 160px 0px 0px 0px;\n    }\n}\n\n@media (max-width: 1366px) {\n    .one-ekran-banks {\n        height: 570px;\n    }\n\n    .one-ekran-contant-banks {\n        padding: 160px 0px 0px 0px;\n    }\n}\n\n@media (max-width: 1280px) {\n    .one-ekran-banks {\n        height: 470px;\n        background-image: url(../img/fon-1-banks-mob.jpg);\n    }\n\n    .one-ekran-contant-banks {\n        padding: 120px 0px 0px 0px;\n    }\n}\n\n@media (max-width: 1080px) {\n    .one-ekran-banks {\n        height: 400px;\n    }\n\n    .one-ekran-contant-banks {\n        padding: 100px 0px 0px 0px;\n    }\n}\n\n@media (max-width: 900px) {\n    .one-ekran-banks {\n        height: 385px;\n    }\n\n    .one-ekran-contant-banks {\n        padding: 130px 0px 0px 0px;\n    }\n\n    .one-ekran-banks-text {\n        width: 700px;\n    }\n}\n\n@media (max-width: 800px) {\n    .one-ekran-contant-banks {\n        padding: 120px 0px 0px 0px;\n    }\n\n    .one-ekran-banks-text {\n        width: 600px;\n    }\n}\n\n@media (max-width: 700px) {\n    .one-ekran-banks-text {\n        width: 100%;\n    }\n}\n\n@media (max-width: 600px) {\n    .one-ekran-contant-banks {\n        padding: 150px 0px 0px 0px;\n    }\n\n    .one-ekran-banks-text {\n        font-weight: 600;\n    }\n}\n\n@media (max-width: 500px) {\n    .one-ekran-banks {\n        border-radius: 50px 50px 50px 50px;\n        margin: 20px auto 0px auto;\n    }\n\n    .one-ekran-contant-banks {\n        padding: 50px 0px 0px 0px;\n    }\n}\n\n/*********** section-two-banks ***************/\n.section-two-banks {\n    padding: 100px 0px 70px 0px;\n}\n\n.h2-banks {\n    margin: 0px 0px 40px 0px;\n}\n\n.section-two-contant-banks {\n    width: 100%;\n    display: flex;\n    justify-content: space-between;\n    flex-wrap: wrap;\n}\n\n.section-two-item-banks {\n    flex: 0 0 32%;\n    padding: 70px 40px 60px 40px;\n    margin: 0px 0px 30px 0px;\n    border-radius: 30px;\n    background: #fff;\n    text-align: center;\n\n}\n\n.section-two-banks-text-1 {\n    margin: 20px 0px 30px 0px;\n    font-size: 24px;\n    font-weight: 400;\n    line-height: 29px;\n    letter-spacing: 0em;\n    text-align: center;\n}\n\n.section-two-banks-bloktext {\n    text-align: left;\n    margin: 0px 0px 20px 0px;\n    padding: 20px 20px 20px 20px;\n    background: #f5f5f5;\n}\n\n.section-two-banks-text-2 {\n    margin: 0px 0px 5px 0px;\n    font-family: 'Geologica';\n    font-style: normal;\n    font-weight: 400;\n    font-size: 11px;\n    line-height: 14px;\n    /*color: #828282;*/\n    color: #000;\n}\n\n.section-two-banks-text-3 {\n    font-size: 16px;\n    font-weight: 400;\n    line-height: 20px;\n    letter-spacing: 0em;\n    text-align: left;\n}\n\n.section-two-banks-link {\n    display: block;\n    width: 100%;\n    position: relative;\n    margin: 20px 0px 0px 0px;\n    padding: 0px 0px 5px 0px;\n    font-size: 13px;\n    font-weight: 400;\n    line-height: 14px;\n    letter-spacing: 0em;\n    text-align: left;\n    color: #000;\n    border-bottom: 1px solid #000;\n}\n\n.section-two-banks-link:hover {\n    opacity: 0.7;\n}\n\n.arrow-2 {\n    position: absolute;\n    right: 0;\n}\n\n.button-2 {\n    margin: 0px 0px 20px 0px;\n}\n\n@media (max-width: 1600px) {\n    .section-two-banks {\n        padding: 80px 0px 50px 0px;\n    }\n}\n\n@media (max-width: 1366px) {\n    .section-two-banks-link {\n        font-size: 12px;\n    }\n}\n\n@media (max-width: 1280px) {\n    .section-two-item-banks {\n        padding: 40px 30px 40px 30px;\n    }\n\n    .section-two-banks-bloktext {\n        margin: 0px 0px 15px 0px;\n        padding: 15px 15px 15px 15px;\n    }\n\n    .section-two-banks-link {\n        font-size: 11px;\n    }\n}\n\n@media (max-width: 1024px) {\n    .section-two-banks {\n        padding: 50px 0px 20px 0px;\n    }\n}\n\n@media (max-width: 930px) {\n    .section-two-contant-banks {\n        justify-content: center;\n    }\n\n    .section-two-item-banks {\n        flex: 0 0 44%;\n        margin: 0px 15px 30px 15px;\n    }\n}\n\n@media (max-width: 768px) {\n    .section-two-item-banks {\n        flex: 0 0 45%;\n    }\n}\n\n@media (max-width: 667px) {\n    .section-two-item-banks {\n        flex: 0 0 320px;\n        margin: 0px 0px 30px 0px;\n    }\n}\n\n@media (max-width: 428px) {\n    .section-two-item-banks {\n        flex: 0 0 100%;\n    }\n\n    .h2-banks {\n        margin: 0px 0px 25px 0px;\n    }\n}\n\n@media (max-width: 320px) {\n    .section-two-item-banks {\n        padding: 30px 15px 30px 15px;\n    }\n}\n\n/******************************\n********* PAGE BANKS-1 ***********\n****************************/\n.section-three-banks-1 {\n    margin: 100px auto 0px auto;\n    padding: 0px 50px 0px 50px;\n}\n\n@media (max-width: 1100px) {\n    .section-three-banks-1 {\n        margin: 80px auto 0px auto;\n        padding: 0px 20px 0px 20px;\n    }\n}\n\n@media (max-width: 900px) {\n    .one-ekran-banks {\n        height: 500px;\n    }\n}\n\n@media (max-width: 900px) {\n    .one-ekran-banks-1 {\n        height: 550px;\n    }\n\n    .section-three-banks-1 {\n        margin: 60px auto 0px auto;\n    }\n}\n\n@media (max-width: 670px) {\n    .one-ekran-banks {\n        height: 560px;\n    }\n}\n\n@media (max-width: 700px) {\n    .section-three-banks-1 {\n        padding: 0px 0px 0px 0px;\n    }\n}\n\n@media (max-width: 600px) {\n    .one-ekran-banks-1 {\n        height: 600px;\n    }\n\n    .one-ekran-contant-banks-1 {\n        padding: 110px 0px 0px 0px;\n    }\n}\n\n@media (max-width: 500px) {\n    .one-ekran-banks {\n        height: 400px;\n    }\n\n    .form-1-banks-1 {\n        margin: 70px auto 0px auto;\n    }\n\n}\n\n@media (max-width: 375px) {\n    .one-ekran-banks {\n        border-radius: 50px 50px 0px 0px;\n    }\n}\n\n@media (max-width: 374px) {\n    .one-ekran-banks {\n        height: 360px;\n    }\n\n    .form-1-banks {\n        margin: 100px auto 0px auto;\n    }\n}\n\n/*************************/\n.section-three-banks {\n    margin: 100px auto 0px auto;\n}\n\n@media (max-width: 900px) {\n    .section-three-banks {\n        margin: 60px auto 0px auto;\n    }\n}\n\n@media (max-width: 500px) {\n    .section-three-banks {\n        margin: 270px auto 0px auto;\n    }\n}\n\n@media (max-width: 375px) {\n    .section-three-banks {\n        margin: 300px auto 0px auto;\n    }\n}\n\n@media (max-width: 320px) {\n    .section-three-banks {\n        margin: 320px auto 0px auto;\n    }\n}\n\n/******** section-three-banks ************/\n.section-three-banks {\n    position: relative;\n    width: 1920px;\n    margin: 100px auto 0px auto;\n    padding: 0px 50px 0px 50px;\n}\n\n.section-three-banks-contant {\n    display: flex;\n}\n\n.section-three-banks-contant-col1 {\n    flex: 0 0 50%;\n    background: #fff;\n    padding: 40px 30px 40px 30px;\n    border-radius: 30px;\n}\n\n.h2-s3-banks {\n    text-align: left;\n}\n\n.section-three-banks-text-1 {\n    margin: 20px 0px 20px 0px;\n    font-size: 14px;\n    font-weight: 300;\n    line-height: 17px;\n    letter-spacing: 0em;\n    text-align: left;\n}\n\n.section-three-banks-text-2 {\n    font-size: 16px;\n    font-weight: 500;\n    line-height: 20px;\n    letter-spacing: 0em;\n    text-align: left;\n}\n\n.section-three-banks-image {\n    position: absolute;\n    right: 0;\n    top: 0;\n    border-radius: 30px 0px 0px 30px;\n}\n\n.section-three-banks-contant-col2 {}\n\n@media (max-width: 1920px) {\n    .section-three-banks {\n        width: 100%;\n    }\n}\n\n@media (max-width: 1366px) {\n    .section-three-banks-contant-col1 {\n        flex: 0 0 60%;\n    }\n\n    .section-three-banks-image {\n        height: 70%;\n    }\n}\n\n@media (max-width: 1280px) {\n    .section-three-banks-contant-col1 {\n        flex: 0 0 55%;\n    }\n}\n\n@media (max-width: 1230px) {\n    .section-three-banks-image {\n        height: 65%;\n    }\n}\n\n@media (max-width: 1130px) {\n    .section-three-banks-image {\n        height: 60%;\n    }\n}\n\n@media (max-width: 1100px) {\n    .section-three-banks-2 {\n        position: relative;\n        margin: 80px auto 0px auto;\n        padding: 0px 20px 80px 20px;\n    }\n\n    .section-three-banks-contant-col2 {\n        /*position: relative;*/\n    }\n\n    .section-three-banks-image-1 {\n        height: 50%;\n        position: absolute;\n        top: 0;\n    }\n}\n\n\n@media (max-width: 1050px) {\n    .section-three-banks-image-1 {\n        height: 47%;\n    }\n}\n\n@media (max-width: 1024px) {\n    .section-three-banks {\n        margin: 80px auto 0px auto;\n        padding: 0px 20px 0px 20px;\n    }\n}\n\n@media (max-width: 960px) {\n    .section-three-banks-image-1 {\n        height: 40%;\n    }\n}\n\n@media (max-width: 910px) {\n    .section-three-banks-image-1 {\n        height: 40%;\n    }\n}\n\n@media (max-width: 900px) {\n    .section-three-banks-image {\n        height: 45%;\n    }\n}\n\n@media (max-width: 899px) {\n    .section-three-banks {\n        margin: 60px auto 0px auto;\n    }\n\n    .section-three-banks-contant {\n        flex-direction: column-reverse;\n    }\n\n    .section-three-banks-image {\n        position: relative;\n        width: 100%;\n        border-radius: 30px 30px 0px 0px;\n    }\n\n    .section-three-banks-contant-col2 {\n        width: 100%;\n    }\n\n    .section-three-banks-contant-col1 {\n        position: relative;\n        margin-top: -100px;\n        z-index: 1;\n        width: 100%;\n    }\n}\n\n@media (max-width: 600px) {\n    .section-three-banks {\n        margin: 60px auto 0px auto;\n        padding: 0px 0px 0px 0px;\n    }\n\n    .section-three-banks-2 {\n        margin: 60px auto 0px auto;\n        padding: 0px 0px 0px 0px;\n    }\n\n    .section-three-banks-2-contant {\n        padding: 0px 0px 0px 0px;\n    }\n}\n\n@media (max-width: 500px) {\n    .section-three-banks-1 {\n        margin: 320px auto 0px auto;\n    }\n}\n\n@media (max-width: 428px) {\n    .section-three-banks-contant-col1 {\n        margin-top: -50px;\n    }\n}\n\n@media (max-width: 390px) {\n    .section-three-banks-contant-col1 {\n        margin-top: -40px;\n        padding: 30px 20px 30px 20px;\n    }\n}\n\n@media (max-width: 375px) {\n    .section-three-banks-1 {\n        margin: 290px auto 0px auto;\n    }\n}\n\n@media (max-width: 374px) {\n    .section-three-banks-1 {\n        margin: 360px auto 0px auto;\n    }\n}\n\n/********************\n********* PAGE NEWS *********\n*********************/\n\n/******* one-ekran-news ********/\n.one-ekran-news {\n    height: 420px;\n    padding: 0px 0px 0px 0px;\n    background-image: url(../img/fon-1-news.jpg);\n}\n\n@media (max-width: 1366px) {\n    .one-ekran-news {\n        height: 360px;\n    }\n}\n\n@media (max-width: 768px) {\n    .one-ekran-news {\n        height: 460px;\n        background-image: url(../img/fon-1-news-mob.jpg);\n        background-position: top center;\n    }\n}\n\n@media (max-width: 500px) {\n    .one-ekran-news {\n        margin: 20px auto 0px auto;\n        border-radius: 50px 50px 50px 50px;\n    }\n}\n\n/******* section-two-news *********/\n.section-two-news {\n    margin: 0px auto 0px auto;\n    padding: 100px 0px 80px 0px;\n}\n\n.section-two-news-contant {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: space-between;\n}\n\n.section-two-news-item {\n    flex: 0 0 32%;\n    margin: 0px 5px 20px 5px;\n}\n\n@media (max-width: 1279px) {\n    .section-two-news {\n        padding: 80px 0px 60px 0px;\n    }\n}\n\n@media (max-width: 1024px) {\n    .section-two-news {\n        padding: 60px 0px 40px 0px;\n    }\n}\n\n@media (max-width: 930px) {\n    .section-two-news-contant {\n        justify-content: center;\n    }\n\n    .section-two-news-item {\n        flex: 0 0 42%;\n        margin: 0px 10px 20px 10px;\n    }\n\n}\n\n@media (max-width: 700px) {\n    .section-two-news-item {\n        flex: 0 0 400px;\n        margin: 0px 0px 20px 0px;\n    }\n\n}\n\n@media (max-width: 500px) {\n    .section-two-news-item {\n        flex: 0 0 320px;\n    }\n\n}\n\n@media (max-width: 414px) {\n    .section-two-news-item {\n        flex: 0 0 100%;\n    }\n\n}\n\n/********************\n******** PAGE STATIA ********\n***********************/\n\n/******** one-ekran-statia **********/\n.one-ekran-statia {\n    height: 600px;\n    background-image: url(../img/fon-1-news.jpg);\n}\n\n.one-ekran-statia-contant {\n    padding: 200px 0px 0px 0px;\n}\n\n@media (max-width: 1440px) {\n    .one-ekran-statia {\n        height: 500px;\n    }\n\n    .one-ekran-statia-contant {\n        padding: 160px 0px 0px 0px;\n    }\n}\n\n@media (max-width: 1280px) {\n    .one-ekran-statia {\n        height: 400px;\n    }\n\n    .one-ekran-statia-contant {\n        padding: 120px 0px 0px 0px;\n    }\n}\n\n@media (max-width: 900px) {\n    .one-ekran-statia {\n        height: 360px;\n        border-radius: 0;\n    }\n\n    .one-ekran-statia-contant {\n        padding: 110px 0px 0px 0px;\n    }\n}\n\n@media (max-width: 768px) {\n    .one-ekran-statia-contant {\n        padding: 120px 0px 0px 0px;\n    }\n}\n\n@media (max-width: 700px) {\n    .one-ekran-statia {\n        height: 360px;\n        background-image: url(../img/fon-1-news-mob.jpg);\n        background-position: top center;\n        border-radius: 0px 0px 50px 50px;\n\n    }\n\n    .one-ekran-statia-contant {\n        padding: 130px 0px 0px 0px;\n    }\n}\n\n@media (max-width: 600px) {\n    .one-ekran-statia {\n        height: 430px;\n    }\n\n    .one-ekran-statia-contant {\n        padding: 150px 0px 0px 0px;\n    }\n}\n\n@media (max-width: 500px) {\n    .one-ekran-statia {\n        height: 430px;\n    }\n\n    .one-ekran-statia-contant {\n        padding: 90px 0px 0px 0px;\n    }\n}\n\n@media (max-width: 428px) {\n    .one-ekran-statia-contant {\n        padding: 80px 0px 0px 0px;\n    }\n}\n\n/************* section-two-statia *************/\n.section-two-statia-contant-col1 {\n    flex: 0 0 65%;\n}\n\n.section-two-statia-image-2 {\n    position: absolute;\n    right: 0;\n    top: 0;\n    border-radius: 30px 0px 0px 30px;\n}\n\n.section-two-statia-image-1 {\n    width: 100%;\n    margin: 0px 0px 20px 0px;\n}\n\n.section-two-statia-bloktext {\n    margin: 20px 0px 0px 0px;\n    padding: 10px 0px 0px 0px;\n    border-top: 1px solid #828282;\n    width: 100%;\n    display: flex;\n}\n\n.section-two-statia-bloktext-col1 {\n    flex: 0 0 25%;\n    font-size: 14px;\n    font-weight: 300;\n    line-height: 17px;\n    letter-spacing: 0em;\n    text-align: left;\n}\n\n.section-two-statia-bloktext-col2 {\n    flex: 0 0 75%;\n    font-size: 14px;\n    font-weight: 300;\n    line-height: 17px;\n    letter-spacing: 0em;\n    text-align: left;\n    color: #828282;\n}\n\n@media (max-width: 1760px) {\n    .section-two-statia-contant-col1 {\n        flex: 0 0 60%;\n    }\n}\n\n@media (max-width: 1640px) {\n    .section-two-statia-contant-col1 {\n        flex: 0 0 57%;\n    }\n}\n\n@media (max-width: 1536px) {\n    .section-two-statia-contant-col1 {\n        flex: 0 0 50%;\n    }\n}\n\n@media (max-width: 1366px) {\n    .section-two-statia-image-2 {\n        height: 650px;\n    }\n\n    .section-two-statia-bloktext-col1 {\n        flex: 0 0 30%;\n    }\n\n    .section-two-statia-bloktext-col2 {\n        flex: 0 0 70%;\n    }\n}\n\n@media (max-width: 1280px) {\n    .section-two-statia-image-2 {\n        height: 570px;\n    }\n\n    .section-two-statia-contant-col1 {\n        flex: 0 0 55%;\n    }\n}\n\n@media (max-width: 1180px) {\n    .section-two-statia-image-2 {\n        height: 500px;\n    }\n}\n\n@media (max-width: 1080px) {\n    .section-two-statia-image-2 {\n        height: 450px;\n    }\n}\n\n@media (max-width: 992px) {\n    .section-two-statia-image-2 {\n        height: 450px;\n    }\n}\n\n@media (max-width: 960px) {\n    .section-two-statia-image-2 {\n        height: 420px;\n    }\n}\n\n@media (max-width: 900px) {\n    .section-two-statia {\n        margin: -70px auto 0px auto;\n        padding: 0px 0px 0px 0px;\n    }\n\n    .section-two-statia-contant {\n        flex-direction: column-reverse;\n    }\n\n    .section-two-statia-image-2 {\n        display: none;\n    }\n\n    .section-two-statia-contant-col1 {\n        position: relative;\n        z-index: 0;\n        width: 100%;\n        margin: 0px 0px 0px 0px;\n    }\n\n    .section-two-statia-image-1 {\n        width: 100%;\n    }\n}\n\n@media (max-width: 768px) {\n    .section-two-statia {\n        /*margin: 0px auto 60px auto;*/\n    }\n}\n\n@media (max-width: 700px) {\n    .section-two-statia-bloktext-col2 {\n        padding: 0px 0px 0px 10px;\n    }\n}\n\n@media (max-width: 500px) {\n\n    .section-two-statia-bloktext-col1 {\n        flex: 0 0 35%;\n    }\n\n    .section-two-statia-bloktext-col2 {\n        flex: 0 0 65%;\n    }\n}\n\n@media (max-width: 428px) {\n    .section-two-statia-bloktext {\n        flex-direction: column;\n    }\n\n    .section-two-statia-bloktext-col1 {\n        margin: 0px 0px 10px 0px;\n    }\n\n    .section-two-statia-bloktext-col2 {\n        padding: 0px 0px 0px 0px;\n    }\n}\n\n/********** section-three-statia *************/\n.section-three-statia {\n    padding: 100px 0px 100px 0px;\n}\n\n@media (max-width: 1280px) {\n    .section-three-statia {\n        padding: 80px 0px 80px 0px;\n    }\n}\n\n@media (max-width: 1100px) {\n    .section-three-statia {\n        padding: 60px 0px 60px 0px;\n    }\n}\n\n/***********************\n****** PAGE NOVOSTROIKI ********\n***************************/\n.one-ekran-nov {\n    padding: 0px 0px 0px 0px;\n    background-image: url(../img/fon-1-nov.jpg);\n}\n\n.form-1-col-2-nov {\n    border-radius: 0px 10px 10px 0px;\n}\n\n.section-two-bloktext-nov {\n    margin: 0px 0px 0px 0px;\n}\n\n.two-ekran-novostroiki-image {\n    display: none;\n}\n\n@media (max-width: 899px) {\n    .one-ekran-nov {\n        height: 600px;\n    }\n}\n\n@media (max-width: 600px) {\n    .one-ekran-contant-nov {\n        padding: 100px 0px 0px 0px;\n    }\n\n    .h2-novostroiki-1 {\n        padding-right: 50px;\n    }\n}\n\n@media (max-width: 500px) {\n    .one-ekran-nov {\n        margin: 20px auto 160px auto;\n    }\n\n    .two-ekran-novostroiki {\n        padding: 50px 0px 20px 0px;\n    }\n\n    .two-ekran-novostroiki-image {\n        display: block;\n    }\n\n    .section-two-bloktext-nov-2 {\n        margin: -50px 0px 0px 0px;\n    }\n}\n\n@media (max-width: 428px) {\n    .one-ekran-nov {\n        margin: 20px auto 160px auto;\n        background-size: 220% 160%;\n    }\n}\n\n@media (max-width: 390px) {\n    .one-ekran-contant-nov {\n        padding: 60px 0px 0px 0px;\n    }\n}\n\n@media (max-width: 374px) {\n    .one-ekran-nov {\n        margin: 20px auto 120px auto;\n    }\n\n}\n\n/**********************/\n.arrow-2 {\n    width: auto !important;\n    border-radius: 0px 0px 0px 0px;\n}\n\n.three-ekran-novostroiki-bloktext {\n    height: auto;\n}\n\n\n/****************************\n******* PAGE NOVOSTROIKI-1 ******\n*****************************/\n\n/******* one-ekran-novostroiki-1 **********/\n.one-ekran-nov-text-1 {\n    font-size: 36px;\n    line-height: 1;\n}\n\n@media (max-width: 1024px) {\n    .one-ekran-nov-text-1 {\n        font-size: 24px;\n    }\n}\n\n@media (max-width: 460px) {\n    .one-ekran-nov-text-1 {\n        padding: 0px 40px 0px 40px;\n    }\n}\n\n@media (max-width: 500px) {\n    .one-ekran-nov-1 {\n        margin: 20px auto 50px auto;\n    }\n}\n\n@media (max-width: 470px) {\n    .one-ekran-nov-1 {\n        margin: 20px auto 70px auto;\n    }\n}\n\n@media (max-width: 460px) {\n    .one-ekran-nov-1 {\n        margin: 20px auto 100px auto;\n    }\n}\n\n@media (max-width: 389px) {\n    .one-ekran-nov-text-1 {\n        font-size: 22px;\n    }\n}\n\n@media (max-width: 360px) {\n    .one-ekran-nov-1 {\n        margin: 20px auto 80px auto;\n    }\n\n    .one-ekran-nov-text-1 {\n        padding: 0px 20px 0px 20px;\n    }\n}\n\n/******** three-ekran-novostroiki-1 ***************/\n.three-ekran-novostroiki-1 {\n    padding: 0px 0px 0px 0px;\n    margin: 20px auto 100px auto;\n}\n\n.three-ekran-novostroiki-blokinfo {\n    display: flex;\n    margin: 30px 0px 30px 0px;\n}\n\n.three-ekran-novostroiki-blokinfo-col {\n    flex: 0 0 50%;\n}\n\n.three-ekran-novostroiki-blokinfo-col1 {\n    padding: 0px 10px 0px 0px;\n}\n\n.three-ekran-novostroiki-blokinfo-col2 {\n    padding: 0px 0px 0px 10px;\n}\n\n.three-ekran-novostroiki-blokinfo-item-1 {\n    border-radius: 10px 10px 0px 0px;\n}\n\n.three-ekran-novostroiki-blokinfo-item-4 {\n    border-radius: 0px 0px 10px 10px;\n}\n\n.three-ekran-novostroiki-blokinfo-item-5 {\n    border-radius: 10px 10px 0px 0px;\n}\n\n.three-ekran-novostroiki-blokinfo-item-8 {\n    border-radius: 0px 0px 10px 10px;\n}\n\n@media (max-width: 1024px) {\n    .three-ekran-novostroiki-1 {\n        margin: 10px auto 60px auto;\n    }\n}\n\n@media (max-width: 900px) {\n    .three-ekran-novostroiki-1-contant {\n        flex-direction: column-reverse;\n    }\n\n    .three-ekran-novostroiki-1-image {\n        display: block;\n        position: relative;\n        width: 100%;\n        height: auto;\n        border-radius: 30px 30px 0px 0px;\n    }\n\n    .three-ekran-novostroiki-1-col1 {\n        margin: -200px 0px 0px 0px;\n    }\n}\n\n@media (max-width: 500px) {\n    .three-ekran-novostroiki-blokinfo-col1 {\n        padding: 0px 5px 0px 0px;\n    }\n\n    .three-ekran-novostroiki-blokinfo-col2 {\n        padding: 0px 0px 0px 5px;\n    }\n\n    .h2-s3-novostroiki-1 {\n        width: 88%;\n    }\n}\n\n@media (max-width: 428px) {\n    .three-ekran-novostroiki-1 {\n        margin: 30px auto 60px auto;\n    }\n\n    .three-ekran-novostroiki-1-col1 {\n        margin: -100px 0px 0px 0px;\n        padding: 30px 20px 30px 20px;\n    }\n\n    .three-ekran-novostroiki-blokinfo {\n        flex-direction: column;\n    }\n\n    .three-ekran-novostroiki-blokinfo-col1 {\n        padding: 0px 0px 0px 0px;\n    }\n\n    .three-ekran-novostroiki-blokinfo-col2 {\n        padding: 0px 0px 0px 0px;\n    }\n\n    .three-ekran-novostroiki-blokinfo-item-1 {\n        border-radius: 10px 10px 0px 0px;\n    }\n\n    .three-ekran-novostroiki-blokinfo-item-4 {\n        border-radius: 0px 0px 0px 0px;\n    }\n\n    .three-ekran-novostroiki-blokinfo-item-5 {\n        border-radius: 0px 0px 0px 0px;\n    }\n\n    .three-ekran-novostroiki-blokinfo-item-8 {\n        border-radius: 0px 0px 10px 10px;\n    }\n\n    .h2-s3-novostroiki-1 {\n        width: 85%;\n    }\n}\n\n@media (max-width: 390px) {\n    .h2-s3-novostroiki-1 {\n        width: 100%;\n    }\n}\n\n/******* foor-ekran-novostroiki-1 ***********/\n.foor-ekran-novostroiki-1 {\n    width: 1920px;\n    margin: 0px auto 100px auto;\n    padding: 0px 0px 0px 0px;\n}\n\n.foor-ekran-novostroiki-1-contant {\n    padding: 60px 60px 60px 60px;\n    background: #fff;\n    border-radius: 30px;\n}\n\n.foor-ekran-novostroiki-1-contant-items {\n    margin: 0px 0px 0px 0px;\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: space-between;\n}\n\n.foor-ekran-novostroiki-1-contant-item {\n    position: relative;\n    flex: 0 0 50%;\n    margin: 0px 0px 60px 0px;\n    padding: 0px 10px 0px 50px;\n}\n\n.foor-ekran-novostroiki-1-text-1 {\n    position: absolute;\n    left: 0;\n    top: 0px;\n    font-size: 60px;\n    font-weight: 500;\n    line-height: 1;\n    letter-spacing: 0em;\n    text-align: left;\n    color: #FFEB39;\n}\n\n.foor-ekran-novostroiki-1-text-2 {\n    margin: 0px 0px 5px 0px;\n    font-size: 20px;\n    font-weight: 300;\n    line-height: 26px;\n    letter-spacing: 0em;\n    text-align: left;\n    color: #000;\n}\n\n.foor-ekran-novostroiki-1-text-3 {\n    font-size: 18px;\n    font-weight: 300;\n    line-height: 20px;\n    letter-spacing: 0em;\n    text-align: left;\n    color: #828282;\n}\n\n.button-novostroiki-1 {\n    width: 450px;\n}\n\n@media (max-width: 1920px) {\n    .foor-ekran-novostroiki-1 {\n        width: 100%;\n    }\n}\n\n@media (max-width: 1600px) {\n    .foor-ekran-novostroiki-1-text-2 {\n        font-size: 18px;\n        line-height: 1;\n    }\n\n    .foor-ekran-novostroiki-1-text-3 {\n        font-size: 16px;\n        line-height: 1.3;\n    }\n}\n\n\n@media (max-width: 1280px) {\n    .foor-ekran-novostroiki-1-text-2 {\n        font-size: 16px;\n    }\n\n    .foor-ekran-novostroiki-1-text-3 {\n        font-size: 14px;\n    }\n}\n\n@media (max-width: 900px) {\n    .foor-ekran-novostroiki-1 {\n        margin: 0px auto 60px auto;\n    }\n\n    .foor-ekran-novostroiki-1-contant-item {\n        padding: 0px 20px 0px 50px;\n    }\n}\n\n@media (max-width: 768px) {\n    .foor-ekran-novostroiki-1-contant {\n        padding: 40px 30px 40px 30px;\n    }\n}\n\n@media (max-width: 700px) {\n    .foor-ekran-novostroiki-1-contant-item {\n        margin: 0px 0px 40px 0px;\n        padding: 0px 20px 0px 40px;\n    }\n}\n\n@media (max-width: 600px) {\n    .foor-ekran-novostroiki-1-contant-item {\n        flex: 0 0 100%;\n        margin: 0px 0px 40px 0px;\n        padding: 0px 20px 0px 50px;\n    }\n}\n\n@media (max-width: 500px) {\n    .button-novostroiki-1 {\n        width: 100%;\n    }\n\n    .foor-ekran-novostroiki-1-text-2 {\n        margin: 0px 0px 10px 0px;\n    }\n}\n\n@media (max-width: 428px) {\n    .foor-ekran-novostroiki-1-contant {\n        padding: 40px 20px 40px 20px;\n    }\n\n    .foor-ekran-novostroiki-1-contant-item {\n        padding: 0px 0px 0px 50px;\n    }\n}\n\n@media (max-width: 360px) {\n    .foor-ekran-novostroiki-1-contant-item {\n        padding: 0px 0px 0px 40px;\n    }\n\n    .foor-ekran-novostroiki-1-text-1 {\n        font-size: 50px;\n    }\n}\n\n/***********************\n****** PAGE CALCULATOR ********\n***************************/\n\n/*************************/\n.section-calculator {\n    width: 1920px;\n    padding: 0px 0px 0px 0px;\n    margin: 100px auto 100px auto;\n}\n\n.section-calculator-contant {\n    width: 100%;\n}\n\n.section-calculator-link {\n    position: relative;\n    margin: 0px 0px 0px 30px;\n    padding: 0px 0px 0px 20px;\n    font-size: 18px;\n    font-weight: 400;\n    line-height: 20px;\n    letter-spacing: 0em;\n    text-align: left;\n    color: #ccc;\n    transition-duration: 0.5s;\n}\n\n.section-calculator-link:hover {\n    color: #000;\n}\n\n.section-calculator-link::before {\n    content: '<';\n    position: absolute;\n    left: 0;\n    top: 0px;\n}\n\n.section-calculator-tab {\n    width: 100%;\n    margin: 40px 0px 0px 0px;\n}\n\n.section-calculator-tab-title {\n    width: 100%;\n    margin: 0px 0px 40px 0px;\n    padding: 0px 30px 0px 30px;\n    display: flex;\n    justify-content: space-between;\n}\n\n.section-calculator-tab-title-item {\n    padding: 0px 0px 2px 0px;\n    width: auto;\n    border-bottom: 1px solid #ccc;\n    font-size: 18px;\n    font-weight: 400;\n    line-height: 20px;\n    letter-spacing: 0em;\n    text-align: left;\n    color: #ccc;\n    transition-duration: 0.5s;\n    cursor: pointer;\n}\n\n.section-calculator-tab-title-item:hover {\n    color: #000 !important;\n    border-bottom: 1px solid #000 !important;\n}\n\n.section-calculator-tab-title-item-1 {\n    color: #000;\n    border-bottom: 1px solid #000;\n}\n\n.section-calculator-tab-title-item-2 {}\n\n.section-calculator-tab-title-item-3 {}\n\n.section-calculator-tab-title-item-4 {}\n\n.section-calculator-tab-body {\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n}\n\n.calculator-tab-body-1 {\n    display: flex;\n}\n\n.calculator-tab-body-2 {\n    display: block;\n}\n\n.calculator-tab-body-3 {\n    display: block;\n}\n\n.calculator-tab-body-4 {\n    display: block;\n}\n\n.calculator-tab-body-blok {\n    width: 100%;\n    margin: 0px 0px 40px 0px;\n    padding: 30px 30px 30px 30px;\n    background: #fff;\n    border-radius: 30px;\n}\n\n.calculator-tab-body-blok-title {\n    /* margin: 0px 0px 20px 0px;*/\n    font-size: 18px;\n    font-weight: 400;\n    line-height: 20px;\n    letter-spacing: 0em;\n    text-align: left;\n    color: #000;\n    cursor: pointer;\n}\n\n.block-1 {\n    display: none;\n}\n\n.block-2 {\n    display: block;\n}\n\n.calculator-tab-body-blok-title-11 {\n    display: none;\n}\n\n.calculator-tab-body-blok-title-21 {\n    display: none;\n}\n\n.calculator-tab-body-blok-title span {\n    margin: 0px 0px 0px 10px;\n    font-size: 11px;\n    font-weight: 400;\n    line-height: 14px;\n    letter-spacing: 0em;\n    text-align: left;\n    color: #ccc;\n}\n\n.tab-body-blok-info {\n    margin: 20px 0px 0px 0px;\n    width: 100%;\n}\n\n.tab-body-blok-info-301 {\n    margin: 20px 0px 0px 0px;\n    width: 100%;\n}\n\n.tab-body-blok-info-1 {\n    display: block;\n}\n\n.tab-body-blok-info-2 {\n    display: block;\n}\n\n.tab-body-blok-info-3 {\n    display: block;\n}\n\n.tab-body-blok-info-4 {\n    display: none;\n}\n\n.tab-body-blok-info-303 {\n    display: block;\n}\n\n.tab-body-blok-info-row {\n    width: 100%;\n    display: flex;\n    box-sizing: border-box;\n}\n\n.tab-body-blok-info-row-2 {\n    flex-wrap: wrap;\n}\n\n.tab-body-blok-info-row-1 .tab-body-blok-info-element {\n    flex: 0 0 33.333%;\n}\n\n.tab-body-blok-info-row-2 .tab-body-blok-info-element {\n    flex: 0 0 25%;\n}\n\n.tab-body-blok-info-row-3 .tab-body-blok-info-element {\n    flex: 0 0 50%;\n}\n\n.tab-body-blok-info-row-4 {\n    margin: 20px 0px 0px 0px;\n}\n\n.tab-body-blok-info-row-4 .tab-body-blok-info-element {\n    flex: 0 0 25%;\n    width: 25%;\n}\n\n.tab-body-blok-info-row-4-1 {\n    margin: 0px 0px 0px 0px;\n    flex-wrap: wrap;\n}\n\n#tab-body-blok-info-row-4-1 {\n    margin: 20px 0px 0px 0px;\n}\n\n.tab-body-blok-info-row-4-1 .tab-body-blok-info-element {\n    flex: 0 0 50%;\n}\n\n.tab-body-blok-info-row-5 .tab-body-blok-info-element {\n    flex: 0 0 33.333%;\n    width: 33.333%;\n}\n\n.tab-body-blok-info-row-6 .tab-body-blok-info-element {\n    flex: 0 0 33.333%;\n}\n\n.tab-body-blok-info-row-66 .tab-body-blok-info-element {\n    flex: 0 0 50%;\n}\n\n.tab-body-blok-info-row-7 .tab-body-blok-info-element {\n    flex: 0 0 50%;\n}\n\n.tab-body-blok-info-row-201 .tab-body-blok-info-element {\n    flex: 0 0 33.333%;\n}\n\n.tab-body-blok-info-row-202 .tab-body-blok-info-element {\n    flex: 0 0 50%;\n}\n\n.tab-body-blok-info-row-203 {\n    display: flex;\n}\n\n.tab-body-blok-info-row-203 .tab-body-blok-info-element {\n    flex: 0 0 50%;\n}\n\n.tab-body-blok-info-row-307 {\n    justify-content: center;\n    width: 100%;\n}\n\n.tab-body-blok-info-row-303 .tab-body-blok-info-element {\n    flex: 0 0 25%;\n}\n\n.tab-body-blok-info-row-304 .tab-body-blok-info-element {\n    flex: 0 0 25%;\n}\n\n.tab-body-blok-info-row-304 .tab-body-blok-info-element-305 {\n    flex: 0 0 25%;\n}\n\n.tab-body-blok-info-row-304 .tab-body-blok-info-element-306 {\n    flex: 0 0 25%;\n}\n\n.tab-body-blok-info-row-304 .tab-body-blok-info-element-307 {\n    flex: 0 0 50%;\n}\n\n.tab-body-blok-info-row-305 {\n    flex-wrap: wrap;\n    margin-bottom: 20px;\n}\n\n.tab-body-blok-info-row-305 .checkbox-box-zalog {\n    flex: 0 0 50%;\n}\n\n.checkbox-box-zalog-1 {\n    padding: 0px 10px 0px 0px !important;\n}\n\n.checkbox-box-zalog-2 {\n    padding: 0px 0px 0px 8px !important;\n}\n\n.checkbox-box-zalog-3 {\n    padding: 0px 10px 0px 0px !important;\n}\n\n.checkbox-box-zalog-4 {\n    padding: 0px 0px 0px 8px !important;\n}\n\n.tab-body-blok-info-element {\n    padding: 0px 4px 0px 0px;\n    margin: 0px 0px 15px 0px;\n    display: flex;\n    flex-direction: column;\n    box-sizing: border-box;\n}\n\n.tab-body-blok-info-element-vnutr {\n    width: 100%;\n    height: 65px;\n    /* srg old 100% */\n    padding: 10px 10px 10px 20px;\n    margin: 0px 0px 0px 0px;\n    background: #f5f5f5;\n    /*background: #e20e0e;*/\n    display: flex;\n    flex-direction: column;\n    box-sizing: border-box;\n}\n\n.tab-body-blok-info-element-1 .tab-body-blok-info-element-vnutr {\n    border-radius: 10px 0px 0px 10px;\n}\n\n.tab-body-blok-info-element-2 .tab-body-blok-info-element-vnutr {\n    border-radius: 0px 0px 0px 0px;\n}\n\n.tab-body-blok-info-element-3 .tab-body-blok-info-element-vnutr {\n    border-radius: 0px 10px 10px 0px;\n}\n\n.tab-body-blok-info-element-4 .tab-body-blok-info-element-vnutr {\n    border-radius: 10px 0px 0px 10px;\n}\n\n.tab-body-blok-info-element-5 .tab-body-blok-info-element-vnutr {\n    border-radius: 0px 0px 0px 0px;\n}\n\n.tab-body-blok-info-element-6.tab-body-blok-info-element-vnutr {\n    border-radius: 0px 0px 0px 0px;\n}\n\n.tab-body-blok-info-element-7 .tab-body-blok-info-element-vnutr {\n    border-radius: 0px 10px 10px 0px;\n}\n\n.tab-body-blok-info-element-8 .tab-body-blok-info-element-vnutr {\n    border-radius: 10px 0px 0px 10px;\n}\n\n.tab-body-blok-info-element-9 .tab-body-blok-info-element-vnutr {\n    border-radius: 0px 0px 0px 0px;\n}\n\n.tab-body-blok-info-element-10.tab-body-blok-info-element-vnutr {\n    border-radius: 0px 0px 0px 0px;\n}\n\n.tab-body-blok-info-element-11 .tab-body-blok-info-element-vnutr {\n    border-radius: 0px 10px 10px 0px;\n}\n\n.tab-body-blok-info-element-12 .tab-body-blok-info-element-vnutr {\n    border-radius: 10px 0px 0px 10px;\n}\n\n.tab-body-blok-info-element-13 .tab-body-blok-info-element-vnutr {\n    border-radius: 0px 10px 10px 0px;\n}\n\n.tab-body-blok-info-element-14 .tab-body-blok-info-element-vnutr {\n    border-radius: 10px 0px 0px 10px;\n}\n\n.tab-body-blok-info-element-15 .tab-body-blok-info-element-vnutr {\n    border-radius: 0px 0px 0px 0px;\n}\n\n.tab-body-blok-info-element-16.tab-body-blok-info-element-vnutr {\n    border-radius: 0px 0px 0px 0px;\n}\n\n.tab-body-blok-info-element-17 .tab-body-blok-info-element-vnutr {\n    border-radius: 0px 10px 10px 0px;\n}\n\n.tab-body-blok-info-element-16-1.tab-body-blok-info-element-vnutr {\n    border-radius: 10px 0px 0px 10px;\n}\n\n.tab-body-blok-info-element-17-1 .tab-body-blok-info-element-vnutr {\n    border-radius: 0px 10px 10px 0px;\n}\n\n.tab-body-blok-info-element-18 .tab-body-blok-info-element-vnutr {\n    border-radius: 10px 0px 0px 10px;\n}\n\n.tab-body-blok-info-element-19 .tab-body-blok-info-element-vnutr {\n    border-radius: 0px 0px 0px 0px;\n}\n\n.tab-body-blok-info-element-20 .tab-body-blok-info-element-vnutr {\n    border-radius: 0px 10px 10px 0px;\n}\n\n.tab-body-blok-info-element-21 .tab-body-blok-info-element-vnutr {\n    border-radius: 10px 0px 0px 10px;\n}\n\n.tab-body-blok-info-element-22 .tab-body-blok-info-element-vnutr {\n    border-radius: 0px 10px 10px 0px;\n}\n\n.tab-body-blok-info-element-23 .tab-body-blok-info-element-vnutr {\n    border-radius: 10px 10px 10px 10px;\n}\n\n.tab-body-blok-info-element-201 .tab-body-blok-info-element-vnutr {\n    border-radius: 10px 0px 0px 10px;\n}\n\n.tab-body-blok-info-element-202 .tab-body-blok-info-element-vnutr {\n    border-radius: 0px 0px 0px 0px;\n}\n\n.tab-body-blok-info-element-203 .tab-body-blok-info-element-vnutr {\n    border-radius: 0px 10px 10px 0px;\n}\n\n.tab-body-blok-info-element-204 .tab-body-blok-info-element-vnutr {\n    border-radius: 10px 0px 0px 10px;\n}\n\n.tab-body-blok-info-element-205 .tab-body-blok-info-element-vnutr {\n    border-radius: 0px 10px 10px 0px;\n}\n\n.tab-body-blok-info-element-206 .tab-body-blok-info-element-vnutr {\n    border-radius: 10px 0px 0px 10px;\n}\n\n.tab-body-blok-info-element-207 .tab-body-blok-info-element-vnutr {\n    border-radius: 0px 10px 10px 0px;\n}\n\n.tab-body-blok-info-element-208 .tab-body-blok-info-element-vnutr {\n    border-radius: 0px 10px 10px 0px;\n}\n\n.tab-body-blok-info-element-210 .tab-body-blok-info-element-vnutr {\n    border-radius: 0px 10px 10px 0px;\n}\n\n.tab-body-blok-info-element-301 .tab-body-blok-info-element-vnutr {\n    border-radius: 10px 0px 0px 10px;\n}\n\n.tab-body-blok-info-element-302 .tab-body-blok-info-element-vnutr {\n    border-radius: 0px 10px 10px 0px;\n}\n\n.tab-body-blok-info-element-302 {\n    padding-right: 8px;\n}\n\n.tab-body-blok-info-element-303 .tab-body-blok-info-element-vnutr {\n    border-radius: 10px 0px 0px 10px;\n}\n\n.tab-body-blok-info-element-303 {\n    padding-left: 8px;\n}\n\n.tab-body-blok-info-element-304 .tab-body-blok-info-element-vnutr {\n    border-radius: 0px 10px 10px 0px;\n}\n\n.tab-body-blok-info-element-305 .tab-body-blok-info-element-vnutr {\n    border-radius: 10px 0px 0px 10px;\n}\n\n.tab-body-blok-info-element-306 .tab-body-blok-info-element-vnutr {\n    border-radius: 0px 10px 10px 0px;\n}\n\n.tab-body-blok-info-element-306 {\n    padding-right: 8px;\n}\n\n.tab-body-blok-info-element-307 .tab-body-blok-info-element-vnutr {\n    border-radius: 10px 10px 10px 10px;\n}\n\n.tab-body-blok-info-element-307 {\n    padding-left: 8px;\n}\n\n.tab-body-blok-info-element-220 {\n    display: block;\n    flex: 0 0 50%;\n    width: 50%;\n}\n\n.tab-body-blok-info-element-vnutr-chek {\n    position: relative;\n}\n\n.pole-step-2 {\n    position: relative;\n    background: #f5f5f5;\n    color: #828282;\n}\n\n.pole-2-chek {\n    display: none;\n    position: absolute;\n    width: 24px;\n    right: 10px;\n    top: 20px;\n    z-index: 1;\n}\n\n.tab-body-blok-info-element .form-1-col {\n    padding: 0px 0px 0px 0px;\n    margin: 0px 0px 0px 0px;\n}\n\n.button-step-21 {\n    margin-top: 30px;\n}\n\n.button-step-22 {\n    display: none;\n    margin-top: 30px;\n}\n\n.button-step-23 {\n    display: flex;\n    margin-top: 30px;\n}\n\n.button-step-24 {\n    display: none;\n    margin-top: 30px;\n}\n\n.button-step-202 {\n    display: none;\n    margin-top: 30px;\n}\n\n.button-step-203 {\n    display: none;\n    margin-top: 30px;\n}\n\n.button-step-303 {\n    display: none;\n    margin-top: 30px;\n    opacity: 0/7;\n}\n\n.calculator-blok-vopros {\n    width: 100%;\n    display: flex;\n    align-items: center;\n}\n\n.calculator-blok-vopros-1 {\n    display: none;\n}\n\n.calculator-blok-vopros-image {\n    cursor: pointer;\n}\n\n.calculator-blok-vopros-image-2 {\n    display: none;\n}\n\n.calculator-blok-vopros-text {\n    display: none;\n    padding: 0px 0px 0px 10px;\n    font-style: normal;\n    font-weight: 400;\n    font-size: 9px;\n    line-height: 11px;\n    letter-spacing: 0.01em;\n    color: #000000;\n    transition-duration: 0.5s;\n    cursor: pointer;\n}\n\n.calculator-blok-vopros-text-1 {\n    display: none;\n    padding: 0px 0px 0px 10px;\n    font-style: normal;\n    font-weight: 400;\n    font-size: 9px;\n    line-height: 11px;\n    letter-spacing: 0.01em;\n    color: #000000;\n    transition-duration: 0.5s;\n    cursor: pointer;\n}\n\n.button-step-2 {\n    position: relative;\n    height: 59px;\n    border: 2px solid #000;\n    background: #ffeb3900;\n}\n\n.button-step-2:hover {\n    background: linear-gradient(0deg, rgba(255, 255, 255, 0.5), rgba(255, 255, 255, 0.5)), #FFEB39 !important;\n    border: 2px solid #FFEB39 !important;\n}\n\n.button-step-2:active {\n    border: 2px solid #000000 !important;\n    background: none !important;\n}\n\n.button-step-2:visited {\n    background: none !important;\n    border: 2px solid #828282 !important;\n    /*color: #828282;*/\n    color: #000 !important;\n}\n\n.button-step-210 {\n    width: 50%;\n    position: relative;\n    height: 59px;\n    border: 2px solid #000;\n    background: #ffeb3900;\n}\n\n.button-step-210:hover {\n    background: linear-gradient(0deg, rgba(255, 255, 255, 0.5), rgba(255, 255, 255, 0.5)), #FFEB39 !important;\n    border: 2px solid #FFEB39 !important;\n}\n\n.button-step-210:active {\n    border: 2px solid #000000 !important;\n    background: none !important;\n}\n\n.button-step-210:visited {\n    background: none !important;\n    border: 2px solid #828282 !important;\n    /*color: #828282;*/\n    color: #000 !important;\n}\n\n.button-step-301 {\n    opacity: 0.7;\n}\n\n.checkbox-box {\n    padding: 0px 0px 0px 5px;\n    height: 59px;\n    width: 50%;\n    display: flex;\n    align-items: center;\n}\n\n.checkbox-box label {\n    margin: 0px 0px 0px 0px;\n    padding: 0px 0px 0px 40px;\n    font-style: normal;\n    font-weight: 300;\n    font-size: 9px;\n    line-height: 11px;\n    letter-spacing: 0.01em;\n    color: #828282;\n}\n\n.checkbox-box-301 {\n    width: 33.333%;\n    padding: 0px 0px 0px 0px;\n    height: auto;\n    margin: 10px 0px 30px 0px;\n}\n\n.checkbox-1 {\n    position: absolute;\n    z-index: 1;\n    opacity: 1;\n    display: inline-flex;\n    align-items: center;\n    user-select: none;\n}\n\n.checkbox-1::before {\n    content: '';\n    display: inline-block;\n    width: 28px;\n    height: 28px;\n    flex-shrink: 0;\n    flex-grow: 0;\n    border: 1.5px solid #000;\n    border-radius: 6px;\n    margin-right: 10px;\n    background: #fff;\n    background-repeat: no-repeat;\n    background-position: center center;\n    background-size: 50% 50%;\n    opacity: 1;\n}\n\n/* стили при наведении курсора на checkbox */\n.checkbox-1:not(:disabled):not(:checked):hover::before {\n    border-color: #000;\n}\n\n/* стили для активного состояния чекбокса (при нажатии на него) */\n.checkbox-1:not(:disabled):active::before {\n    border-color: #ccc;\n}\n\n/* стили для чекбокса, находящегося в фокусе */\n.checkbox-1:focus::before {\n    box-shadow: 0 0 0 0.0rem rgba(0, 123, 255, 0.25);\n}\n\n/* стили для чекбокса, находящегося в фокусе и не находящегося в состоянии checked */\n.checkbox-1:focus:not(:checked)::before {\n    border-color: #ccc;\n}\n\n/* стили для чекбокса, находящегося в состоянии disabled */\n.checkbox-1:disabled::before {\n    background-color: #e9ecef;\n}\n\n.checkbox-1:checked::before {\n    border-color: #ccc;\n    background-color: rgb(255, 255, 255);\n    background-image: url('../img/icon-checked.svg');\n    background-repeat: no-repeat;\n    background-position: center center;\n    background-size: 90% 90%;\n}\n\n.dropdown__list-calc {\n    overflow: scroll;\n    height: 120px;\n}\n\n.tab-body-blok-info-animation {\n    width: 100%;\n    padding: 10px 0px 20px 0px;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n}\n\n.tab-body-blok-info-animation-2 {\n    display: flex;\n    flex-direction: row;\n\n}\n\n.tab-body-blok-info-animation-col {\n    padding: 0px 10px 0px 0px;\n    flex: 0 0 50%;\n    text-align: left;\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    justify-content: flex-start;\n}\n\n.tab-body-blok-info-animation-text {\n    font-size: 14px;\n    font-weight: 500;\n    line-height: 17px;\n    letter-spacing: 0em;\n    text-align: center;\n    color: #000;\n}\n\n.tab-body-blok-info-animation-text-2 {\n    margin: 0px 0px 0px 0px;\n    padding: 0px 0px 15px 30px;\n    background-image: url(../img/Info.svg);\n    background-repeat: no-repeat;\n    background-position: left top;\n    background-size: 20px auto;\n    text-align: left;\n}\n\n.tab-body-blok-info-animation-text-22 {\n    background-image: url(../img/Info-2.svg);\n}\n\n.tab-body-blok-info-animation-text-3 {\n    padding: 15px 0px 15px 0px;\n    text-align: left;\n}\n\n.blok-info-animation {\n    padding: 30px 0px 30px 0px;\n}\n\n.tab-body-blok-info-animation-link {\n    font-size: 11px;\n    font-weight: 400;\n    line-height: 14px;\n    letter-spacing: 0em;\n    color: #828282;\n    text-decoration: underline;\n    cursor: pointer;\n    text-align: center;\n}\n\n.tab-body-blok-info-animation-link:hover {\n    color: #000;\n}\n\n.tab-body-blok-info-animation-link-3 {\n    margin: 5px 0px 0px 0px;\n}\n\n#tab-body-blok-info-animation-link-1 {\n    display: none;\n}\n\n.circle-box {\n    display: flex;\n}\n\n.circle {\n    background: #000;\n    border-radius: 0%;\n    width: 6px;\n    height: 6px;\n    margin: 0px 7px 0px 7px;\n}\n\n.circle-1 {\n    animation-delay: 0s;\n}\n\n.circle-2 {\n    animation-delay: 0.4s;\n}\n\n.circle-3 {\n    animation-delay: 0.8s;\n}\n\n.tab-body-blok-info-animation-2 {\n    display: flex;\n    flex-direction: row;\n\n}\n\n/*************************/\n.tab-body-blok-contant-401-up {\n    width: 100%;\n    display: block;\n}\n\n.tab-body-blok-info-400 {\n    width: 100%;\n    padding: 0px 0px 0px 0px;\n    margin: 0px 0px 30px 0px;\n}\n\n.tab-body-blok-info-element-400 {\n    border-radius: 10px !important;\n    border: 1px solid #000;\n    padding: 0px 0px 0px 0px;\n}\n\n.tab-body-blok-info-element-400 .tab-body-blok-info-element-vnutr {\n    border-radius: 10px !important;\n}\n\n.tab-body-blok-info-element-400-text {\n    font-size: 9px;\n    font-weight: 400;\n    line-height: 11px;\n    letter-spacing: 0.01em;\n    text-align: left;\n    background-size: 18px auto;\n}\n\n.button-step-400 {\n    width: 100%;\n}\n\n.tab-body-blok-contant-401 {\n    width: 500px;\n    margin: 40px auto 0px auto;\n    padding: 0px 0px 0px 0px;\n}\n\n.tab-body-blok-info-401 {\n    width: 100%;\n    padding: 10px 20px 30px 20px;\n    border: 2px solid #000;\n    border-radius: 10px;\n}\n\n#tab-body-blok-info-401-4 {\n    display: none;\n}\n\n#tab-body-blok-info-401-5 {\n    display: none;\n}\n\n#tab-body-blok-info-401-6 {\n    display: block;\n}\n\n.tab-body-blok-info-401-element {\n    width: 100%;\n    padding: 20px 0px 15px 0px;\n    border-bottom: 1px solid #ccc;\n    display: flex;\n    align-items: center;\n}\n\n.tab-body-blok-info-401-element img {\n    width: 24px;\n    margin: 0px 10px 0px 0px;\n}\n\n.blok-info-401-element-text {\n    font-size: 16px;\n    font-weight: 400;\n    line-height: 20px;\n    letter-spacing: 0em;\n    text-align: left;\n    color: #000;\n}\n\n.tab-body-4-blok-price {\n    width: 120px;\n    margin: 0px 0px 0px auto;\n    padding: 20px 0px 0px 0px;\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: flex-end;\n    align-items: flex-end;\n}\n\n.tab-body-4-price-1 {\n    margin: 0px 5px 0px 0px;\n    font-size: 11px;\n    font-weight: 400;\n    line-height: 14px;\n    letter-spacing: 0em;\n    text-align: right;\n    text-decoration: line-through;\n    color: #828282;\n}\n\n.tab-body-4-price-2 {\n    font-size: 11px;\n    font-weight: 400;\n    line-height: 14px;\n    letter-spacing: 0em;\n    padding: 2px 6px 2px 6px;\n    border-radius: 2px;\n    color: #fff;\n    background: #000;\n    text-align: center;\n}\n\n.tab-body-4-price-3 {\n    font-size: 24px;\n    font-weight: 400;\n    line-height: 26px;\n    letter-spacing: 0em;\n    text-align: right;\n    color: #000;\n}\n\n.button-step-401 {\n    width: 100%;\n    margin: 30px 0px 0px 0px;\n}\n\n.tab-body-4-dopinfo-blok-link {\n    position: relative;\n    width: 110px;\n}\n\n.tab-body-4-dopinfo-link {\n    position: relative;\n    margin: 0px 0px 10px 0px;\n    font-size: 11px;\n    font-weight: 400;\n    line-height: 14px;\n    letter-spacing: 0em;\n    text-align: left;\n    color: #828282;\n    cursor: pointer;\n    text-decoration: underline;\n    transition-duration: 0.5s;\n}\n\n.tab-body-4-dopinfo-link:hover {\n    text-decoration: none;\n}\n\n.icon-down-arrow-401 {\n    position: absolute;\n    width: 15px;\n    top: 0px;\n    cursor: pointer;\n}\n\n.tab-body-4-blok-dopinfo {\n    display: flex;\n    width: 100%;\n    height: auto;\n    flex-wrap: wrap;\n\n}\n\n.tab-body-4-blok-dopinfo-1 {\n    padding: 0px 0px 30px 0px;\n\n}\n\n.rotate-401 .icon-down-arrow-401 {\n    transform: rotate(-180deg);\n    transition: .3s;\n}\n\n.block {\n    display: flex;\n\n}\n\n.block-2 {\n    display: block;\n\n}\n\n.rotate-401 #tab-body-4-blok-dopinfo-1 {\n    display: block;\n}\n\n.rotate-401 #tab-body-4-blok-dopinfo-2 {\n    display: block;\n}\n\n.rotate-401 #tab-body-4-blok-dopinfo-3 {\n    display: block;\n}\n\n.rotate-401 #tab-body-4-blok-dopinfo-4 {\n    display: block;\n}\n\n.rotate-401 #tab-body-4-blok-dopinfo-5 {\n    display: block;\n}\n\n.rotate-401 #tab-body-4-blok-dopinfo-6 {\n    display: block;\n}\n\n.none {\n    display: none;\n}\n\n.tab-body-4-blok-dopinfo-col {\n    flex: 0 0 50%;\n}\n\n.icon-home-gray {\n    margin: 0px 0px 10px 0px;\n}\n\n.tab-body-4-blok-dopinfo-text {\n    font-size: 9px;\n    font-weight: 300;\n    line-height: 11px;\n    letter-spacing: 0.01em;\n    text-align: left;\n    color: #828282;\n}\n\n.button-step-201 {\n    margin: 30px auto 0px auto;\n}\n\n.button-step-402 {\n    display: none;\n    width: 100%;\n    margin: 30px 0px 0px 0px;\n}\n\n.tab-body-4-blok-dopinfo-text-3 {\n    line-height: 13px;\n}\n\n.tab-body-4-blok-dopinfo-2 {\n    padding: 0px 0px 0px 0px;\n}\n\n.button-step-4000 {\n    width: 100%;\n    margin: 30px 0px 0px 0px;\n    border-radius: 0px;\n}\n\n.button-step-4001 {\n    width: 100%;\n    margin: 30px 0px 0px 0px;\n    border-radius: 0px;\n}\n\n.button-step-4002 {\n    width: 100%;\n    margin: 30px 0px 0px 0px;\n    border-radius: 0px;\n}\n\n.button-step-4000-active {\n    background: #fff;\n    border: 2px solid #000;\n\n}\n\n.button-step-4001-active {\n    background: #fff;\n    border: 2px solid #000;\n\n}\n\n.button-step-4002-active {\n    background: #fff;\n    border: 2px solid #000;\n\n}\n\n.button-step-finish {\n    display: none;\n    width: 100%;\n    margin: 30px 0px 0px 0px;\n}\n\n.validacia {\n    display: block;\n    width: 100%;\n    margin: 20px 0px 0px 0px;\n    text-align: center;\n    display: flex;\n    justify-content: center;\n}\n\n.validacia-2 {\n    display: block;\n    width: 100%;\n    margin: 20px 0px 0px 0px;\n    text-align: center;\n    display: flex;\n    justify-content: center;\n}\n\n.validacia-3 {\n    display: block;\n    width: 100%;\n    margin: 20px 0px 0px 0px;\n    text-align: center;\n    display: flex;\n    justify-content: center;\n}\n\n.validacia-4 {\n    display: none;\n    width: 100%;\n    margin: 20px 0px 0px 0px;\n    text-align: center;\n    justify-content: center;\n}\n\n#validacia-text {\n    width: auto;\n    font-size: 11px;\n    line-height: 17px;\n    color: red;\n    font-weight: 500;\n}\n\n#validacia-text-2 {\n    font-size: 9px;\n    margin: 5px 0px 0px 0px;\n    padding: 0px 0px 5px 18px;\n    background-size: 14px auto;\n}\n\n#tab-body-blok-info-303-vnutr {\n    margin: 0px 0px 30px 0px;\n}\n\n.tab-body-blok-info-element-301 {\n    height: 64px;\n}\n\n\n\n@media (max-width: 1920px) {\n    .section-calculator {\n        width: 100%;\n    }\n}\n\n@media (max-width: 1280px) {\n    .tab-body-blok-info-row-2 .tab-body-blok-info-element {\n        flex: 0 0 33.333%;\n    }\n\n    .tab-body-blok-info-row-4 .tab-body-blok-info-element {\n        flex: 0 0 24%;\n    }\n\n    .tab-body-blok-info-element-6 .tab-body-blok-info-element-vnutr {\n        border-radius: 0px 10px 10px 0px;\n    }\n\n    .tab-body-blok-info-element-7 .tab-body-blok-info-element-vnutr {\n        border-radius: 10px 0px 0px 10px;\n    }\n\n    .tab-body-blok-info-element-8 .tab-body-blok-info-element-vnutr {\n        border-radius: 0px 0px 0px 0px;\n    }\n\n    .tab-body-blok-info-element-9 .tab-body-blok-info-element-vnutr {\n        border-radius: 0px 10px 10px 0px;\n    }\n\n    .tab-body-blok-info-element-10 .tab-body-blok-info-element-vnutr {\n        border-radius: 10px 0px 0px 10px;\n    }\n\n    .tab-body-blok-info-element-11 .tab-body-blok-info-element-vnutr {\n        border-radius: 0px 10px 10px 0px;\n    }\n\n    .tab-body-blok-info-element-220 .tab-body-blok-info-element-vnutr {\n        border-radius: 10px 10px 10px 10px;\n    }\n\n    .tab-body-blok-info-row-303 .tab-body-blok-info-element {\n        flex: 0 0 24%;\n    }\n\n    .tab-body-blok-info-row-304 .tab-body-blok-info-element {\n        flex: 0 0 24%;\n    }\n\n    .tab-body-blok-info-row-304 .tab-body-blok-info-element-305 {\n        flex: 0 0 26%;\n    }\n\n    .tab-body-blok-info-row-304 .tab-body-blok-info-element-306 {\n        flex: 0 0 26.5%;\n    }\n\n    .tab-body-blok-info-row-304 .tab-body-blok-info-element-307 {\n        flex: 0 0 48%;\n    }\n\n    .tab-body-blok-info-row .tab-body-blok-info-element {\n        box-sizing: border-box;\n    }\n\n    .tab-body-blok-info-element-vnutr {\n        box-sizing: border-box;\n    }\n\n    .tab-body-blok-info-row-305 .checkbox-box-zalog {\n        flex: 0 0 50%;\n    }\n}\n\n@media (max-width: 1100px) {\n    .tab-body-blok-info-row-2 .tab-body-blok-info-element {\n        flex: 0 0 33.333%;\n    }\n\n    .tab-body-blok-info-row-4 .tab-body-blok-info-element {\n        flex: 0 0 25%;\n    }\n\n    .tab-body-blok-info-row-303 .tab-body-blok-info-element {\n        flex: 0 0 25%;\n    }\n\n    .tab-body-blok-info-row-304 .tab-body-blok-info-element {\n        flex: 0 0 25%;\n    }\n\n    .tab-body-blok-info-row-304 .tab-body-blok-info-element-305 {\n        flex: 0 0 25%;\n    }\n\n    .tab-body-blok-info-row-304 .tab-body-blok-info-element-306 {\n        flex: 0 0 25%;\n    }\n\n    .tab-body-blok-info-row-304 .tab-body-blok-info-element-307 {\n        flex: 0 0 50%;\n    }\n}\n\n@media (max-width: 1030px) {\n    .tab-body-blok-info-row-2 .tab-body-blok-info-element {\n        flex: 0 0 33.333%;\n    }\n\n    .tab-body-blok-info-row-4 {\n        flex-wrap: wrap;\n    }\n\n    .tab-body-blok-info-row-4 .tab-body-blok-info-element {\n        flex: 0 0 33.333%;\n        width: 33.333%;\n    }\n\n    .tab-body-blok-info-element-16 .tab-body-blok-info-element-vnutr {\n        border-radius: 0px 10px 10px 0px;\n    }\n\n    .tab-body-blok-info-element-17 .tab-body-blok-info-element-vnutr {\n        border-radius: 10px 10px 10px 10px;\n    }\n\n    .tab-body-blok-info-element-302 {\n        padding-right: 5px;\n    }\n\n    .tab-body-blok-info-element-306 {\n        padding-right: 5px;\n    }\n\n    .tab-body-blok-info-row-303 .tab-body-blok-info-element {\n        flex: 0 0 25%;\n    }\n\n    .tab-body-blok-info-row-304 .tab-body-blok-info-element {\n        flex: 0 0 25%;\n    }\n\n    .tab-body-blok-info-row-304 .tab-body-blok-info-element-305 {\n        flex: 0 0 25%;\n    }\n\n    .tab-body-blok-info-row-304 .tab-body-blok-info-element-306 {\n        flex: 0 0 25%;\n    }\n\n    .tab-body-blok-info-row-304 .tab-body-blok-info-element-307 {\n        flex: 0 0 50%;\n    }\n}\n\n@media (max-width: 1024px) {\n    .tab-body-blok-info-303 {\n        margin: 0px 0px 0px 0px;\n    }\n\n    .tab-body-blok-info-row-2 .tab-body-blok-info-element {\n        flex: 0 0 33.333%;\n    }\n\n    .tab-body-blok-info-row-4 .tab-body-blok-info-element {\n        flex: 0 0 50%;\n        width: 50%;\n    }\n\n    .tab-body-blok-info-element-15 .tab-body-blok-info-element-vnutr {\n        border-radius: 0px 10px 10px 0px;\n    }\n\n    .tab-body-blok-info-element-16 .tab-body-blok-info-element-vnutr {\n        border-radius: 10px 0px 0px 10px;\n    }\n\n    .tab-body-blok-info-element-17 .tab-body-blok-info-element-vnutr {\n        border-radius: 0px 10px 10px 0px;\n    }\n\n    .tab-body-blok-info-row-303 {\n        flex-wrap: wrap;\n    }\n\n    .tab-body-blok-info-row-303 .tab-body-blok-info-element {\n        flex: 0 0 50%;\n    }\n\n    .tab-body-blok-info-row-303 .tab-body-blok-info-element-302 {\n        padding-right: 0;\n    }\n\n    .tab-body-blok-info-row-303 .tab-body-blok-info-element-303 {\n        padding-left: 0;\n    }\n\n    .tab-body-blok-info-row-303 .tab-body-blok-info-element-304 {\n        padding-right: 0;\n    }\n\n    .tab-body-blok-info-row-303 .tab-body-blok-info-element-306 {\n        padding-right: 0;\n    }\n\n    .tab-body-blok-info-row-304 {\n        flex-wrap: wrap;\n    }\n\n    .tab-body-blok-info-row-304 .tab-body-blok-info-element {\n        flex: 0 0 50%;\n    }\n\n    .tab-body-blok-info-row-304 .tab-body-blok-info-element-305 {\n        flex: 0 0 50%;\n        order: 1;\n    }\n\n    .tab-body-blok-info-row-304 .tab-body-blok-info-element-306 {\n        flex: 0 0 50%;\n        order: 2;\n    }\n\n    .tab-body-blok-info-row-304 .tab-body-blok-info-element-307 {\n        flex: 0 0 100%;\n        padding-left: 0;\n        padding-right: 0;\n        margin-bottom: 30px;\n        order: 0;\n    }\n\n    .tab-body-blok-info-element-302 {\n        padding-right: 5px;\n    }\n\n    .tab-body-blok-info-element-303 {\n        padding-left: 5px;\n    }\n\n    .tab-body-blok-info-element-306 {\n        padding-right: 3px;\n    }\n}\n\n@media (max-width: 800px) {\n    .tab-body-blok-info-row-1 {\n        flex-wrap: wrap;\n    }\n\n    .tab-body-blok-info-row-1 .tab-body-blok-info-element {\n        flex: 0 0 50%;\n    }\n\n    .tab-body-blok-info-row-2 .tab-body-blok-info-element {\n        flex: 0 0 50%;\n    }\n\n    .tab-body-blok-info-row-4 .tab-body-blok-info-element {\n        flex: 0 0 50%;\n    }\n\n    .tab-body-blok-info-row-5 {\n        flex-wrap: wrap;\n    }\n\n    .tab-body-blok-info-row-5 .tab-body-blok-info-element {\n        flex: 0 0 50%;\n        width: 50%;\n    }\n\n    .tab-body-blok-info-row-6 {\n        flex-wrap: wrap;\n    }\n\n    .tab-body-blok-info-row-6 .tab-body-blok-info-element {\n        flex: 0 0 50%;\n    }\n\n    .tab-body-blok-info-row-7 {\n        flex-wrap: wrap;\n        margin: 0px 0px 0px 0px;\n    }\n\n    .tab-body-blok-info-row-201 {\n        flex-wrap: wrap;\n    }\n\n    .tab-body-blok-info-row-201 .tab-body-blok-info-element {\n        flex: 0 0 50%;\n    }\n\n    .tab-body-blok-info-row-203 {\n        flex-wrap: wrap;\n    }\n\n    .tab-body-blok-info-row-203 .tab-body-blok-info-element {\n        flex: 0 0 50%;\n    }\n\n    .tab-body-blok-info-element-1 .tab-body-blok-info-element-vnutr {\n        border-radius: 10px 0px 0px 10px;\n    }\n\n    .tab-body-blok-info-element-2 .tab-body-blok-info-element-vnutr {\n        border-radius: 0px 10px 10px 0px;\n    }\n\n    .tab-body-blok-info-element-3 .tab-body-blok-info-element-vnutr {\n        border-radius: 10px 10px 10px 10px;\n    }\n\n    .tab-body-blok-info-element-4 .tab-body-blok-info-element-vnutr {\n        border-radius: 10px 0px 0px 10px;\n    }\n\n    .tab-body-blok-info-element-5 .tab-body-blok-info-element-vnutr {\n        border-radius: 0px 10px 10px 0px;\n    }\n\n    .tab-body-blok-info-element-6 .tab-body-blok-info-element-vnutr {\n        border-radius: 10px 0px 0px 10px;\n    }\n\n    .tab-body-blok-info-element-7 .tab-body-blok-info-element-vnutr {\n        border-radius: 0px 10px 10px 0px;\n    }\n\n    .tab-body-blok-info-element-8 .tab-body-blok-info-element-vnutr {\n        border-radius: 10px 0px 0px 10px;\n    }\n\n    .tab-body-blok-info-element-9 .tab-body-blok-info-element-vnutr {\n        border-radius: 0px 10px 10px 0px;\n    }\n\n    .tab-body-blok-info-element-10 .tab-body-blok-info-element-vnutr {\n        border-radius: 10px 0px 0px 10px;\n    }\n\n    .tab-body-blok-info-element-11 .tab-body-blok-info-element-vnutr {\n        border-radius: 0px 10px 10px 0px;\n    }\n\n    .tab-body-blok-info-element-19 .tab-body-blok-info-element-vnutr {\n        border-radius: 0px 10px 10px 0px;\n    }\n\n    .tab-body-blok-info-element-20 .tab-body-blok-info-element-vnutr {\n        border-radius: 10px 10px 10px 10px;\n    }\n\n    .tab-body-blok-info-element-201 .tab-body-blok-info-element-vnutr {\n        border-radius: 10px 0px 0px 10px;\n    }\n\n    .tab-body-blok-info-element-202 .tab-body-blok-info-element-vnutr {\n        border-radius: 0px 10px 10px 0px;\n    }\n\n    .tab-body-blok-info-element-203 .tab-body-blok-info-element-vnutr {\n        border-radius: 10px 10px 10px 10px;\n    }\n\n    .tab-body-blok-info-element-206 .tab-body-blok-info-element-vnutr {\n        border-radius: 10px 0px 0px 10px;\n    }\n\n    .tab-body-blok-info-element-207 .tab-body-blok-info-element-vnutr {\n        border-radius: 0px 10px 10px 0px;\n    }\n\n    .tab-body-blok-info-element-208 .tab-body-blok-info-element-vnutr {\n        border-radius: 10px 10px 10px 10px;\n    }\n\n    .checkbox-box-301 {\n        width: 45%;\n    }\n\n}\n\n@media (max-width: 767px) {\n    .section-calculator-link {\n        font-size: 16px;\n    }\n\n    .section-calculator-tab-title-item {\n        font-size: 16px;\n    }\n}\n\n@media (max-width: 700px) {\n    .section-calculator-link {\n        font-size: 15px;\n    }\n\n    .tab-body-blok-info-animation-text {\n        font-size: 12px;\n        line-height: 14px;\n    }\n\n    .section-calculator-tab-title-item {\n        font-size: 15px;\n    }\n\n    .tab-body-blok-info-row-7 .tab-body-blok-info-element {\n        flex: 0 0 100%;\n    }\n\n    .checkbox-box {\n        width: 100%;\n    }\n\n    .checkbox-box-301 {\n        width: 50%;\n    }\n\n    .tab-body-blok-info-row-305 .checkbox-box-zalog {\n        flex: 0 0 100%;\n        padding: 0px 0px 0px 0px !important;\n    }\n\n    .checkbox-box-zalog-1 {\n        order: 0;\n    }\n\n    .checkbox-box-zalog-2 {\n        order: 3;\n    }\n\n    .checkbox-box-zalog-3 {\n        order: 2;\n    }\n\n    .checkbox-box-zalog-4 {\n        order: 4;\n    }\n\n}\n\n@media (max-width: 640px) {\n    .checkbox-box-301 {\n        width: 65%;\n    }\n\n}\n\n@media (max-width: 600px) {\n    .button-step-2 {\n        width: 100%;\n        margin-top: 10px;\n    }\n\n    .checkbox-box-301 {\n        width: 100% !important;\n        margin: 0px 0px 20px 0px;\n    }\n\n    .button-step-301,\n    .button-step-21,\n    .button-step-22,\n    .button-step-23,\n    .button-step-201,\n    .button-step-202 {\n        width: 100% !important;\n    }\n\n    .tab-body-blok-info-row-6 .tab-body-blok-info-element {\n        flex: 0 0 100% !important;\n        margin: 0px 0px 5px 0px;\n    }\n\n    .tab-body-blok-info-row-6 .tab-body-blok-info-element-22 {\n        margin: 0px 0px 20px 0px;\n    }\n\n    .tab-body-blok-info-row-7 .tab-body-blok-info-element {\n        margin: 0px 0px 5px 0px;\n    }\n\n    .tab-body-blok-info-row-1 .tab-body-blok-info-element {\n        flex: 0 0 100%;\n        margin: 0px 0px 5px 0px;\n    }\n\n    .tab-body-blok-info-row-2 .tab-body-blok-info-element {\n        flex: 0 0 100%;\n        margin: 0px 0px 5px 0px;\n    }\n\n    .tab-body-blok-info-row-3 {\n        flex-wrap: wrap;\n    }\n\n    .tab-body-blok-info-row-3 .tab-body-blok-info-element {\n        flex: 0 0 100%;\n        margin: 0px 0px 5px 0px;\n    }\n\n    .tab-body-blok-info-row-4 .tab-body-blok-info-element {\n        flex: 0 0 100%;\n        width: 100%;\n        margin: 0px 0px 5px 0px;\n    }\n\n    .tab-body-blok-info-row-5 .tab-body-blok-info-element {\n        flex: 0 0 100%;\n        width: 100%;\n        margin: 0px 0px 5px 0px;\n    }\n\n    .tab-body-blok-info-row-201 .tab-body-blok-info-element {\n        flex: 0 0 100%;\n    }\n\n    .tab-body-blok-info-row-202 {\n        flex-wrap: wrap;\n    }\n\n    .tab-body-blok-info-row-202 .tab-body-blok-info-element {\n        flex: 0 0 100%;\n    }\n\n    .tab-body-blok-info-row-203 .tab-body-blok-info-element {\n        flex: 0 0 100%;\n    }\n\n    .tab-body-blok-info-row .tab-body-blok-info-element {\n        flex: 0 0 100%;\n        margin: 0px 0px 5px 0px;\n    }\n\n    .tab-body-blok-info-element .tab-body-blok-info-element-vnutr {\n        border-radius: 10px 10px 10px 10px;\n    }\n\n    .tab-body-blok-info-row .tab-body-blok-info-element {\n        flex: 0 0 100%;\n        padding-left: 0;\n        padding-right: 0;\n    }\n\n    .tab-body-blok-info-row-304 .tab-body-blok-info-element-307 {\n        margin-bottom: 30px;\n    }\n\n    .tab-body-blok-contant-401 {\n        width: 100%;\n        margin: 20px auto 0px auto;\n    }\n\n    .tab-body-4-blok-dopinfo-col {\n        flex: 0 0 100%;\n    }\n\n    .icon-home-gray {\n        margin: 0px 0px 0px 0px;\n    }\n\n    .tab-body-4-blok-dopinfo-text-1 {\n        margin: 0px 0px 20px 0px;\n    }\n\n    .checkbox-box-301 {\n        margin-top: 10px;\n    }\n\n}\n\n@media (max-width: 599px) {\n    .tab-body-blok-info-animation-2 {\n        flex-direction: column;\n    }\n\n    .tab-body-blok-info-animation-col {\n        padding: 0px 0px 0px 0px;\n        width: 100%;\n    }\n\n    #tab-body-blok-info-animation-link {\n        margin-top: 0px !important;\n    }\n\n    .tab-body-blok-info-animation-text-3 {\n        padding: 20px 0px 10px 30px;\n    }\n\n    .tab-body-blok-info-5 {\n        margin: 20px 0px 0px 0px;\n    }\n\n    .tab-body-blok-info-animation-link-2 {\n        padding-left: 30px;\n    }\n}\n\n@media (max-width: 500px) {\n    .section-calculator {\n        margin: 50px auto 30px auto;\n    }\n\n    .section-calculator-tab {\n        margin: 30px 0px 0px 0px;\n    }\n\n    .section-calculator-link {\n        margin: 0px 0px 0px 20px;\n    }\n\n    .section-calculator-tab-title {\n        padding: 0px 20px 0px 20px;\n    }\n\n    .tab-body-blok-info {\n        margin: 15px 0px 0px 0px;\n    }\n\n    .calculator-tab-body-blok {\n        padding: 20px 20px 30px 20px;\n    }\n\n    .section-calculator-link {\n        font-size: 12px;\n    }\n\n    .section-calculator-tab-title-item {\n        font-size: 12px;\n    }\n\n    .tab-body-blok-info-row-303 {\n        padding: 0px 0px 0px 0px !important;\n    }\n\n    .tab-body-blok-info-row .tab-body-blok-info-element {\n        margin: 0px 0px 5px 0px !important;\n        padding: 0px 0px 0px 0px !important;\n        height: 64px;\n    }\n\n    #tab-body-blok-info-303 .tab-body-blok-info-element {\n        height: auto;\n    }\n}\n\n@media (max-width: 475px) {}\n\n@media (max-width: 428px) {\n    .section-calculator-tab {\n        margin: 30px 0px 0px 0px;\n    }\n\n    .section-calculator-tab-title {\n        margin: 0px 0px 30px 0px;\n    }\n\n    .section-calculator-link {\n        margin: 0px 0px 0px 20px;\n    }\n}\n\n@media (max-width: 390px) {\n    .section-calculator-link {\n        padding: 0px 0px 0px 15px;\n        font-size: 11px;\n    }\n\n    .section-calculator-tab-title-item {\n        font-size: 11px;\n        line-height: 16px;\n        padding: 0px 0px 0px 0px;\n    }\n\n}\n\n@media (max-width: 389px) {\n    .calculator-tab-body-blok-title {\n        font-size: 15px;\n        line-height: 16px;\n    }\n}\n\n@media (max-width: 359px) {\n    .calculator-tab-body-blok-title {\n        font-size: 13px;\n    }\n}\n\n@media (max-width: 340px) {\n    .calculator-tab-body-blok-title {\n        font-size: 12px;\n    }\n}\n\n@media (max-width: 320px) {\n    .calculator-tab-body-blok-title {\n        font-size: 11px;\n    }\n}\n\n\n/***********************\n****** PAGE CALCULATOR-FINISH ********\n***************************/\n/**********************/\n.one-ekran-calculator-finish {\n    margin-bottom: 0px;\n    height: 600px;\n    background-position: top center;\n}\n\n/******************/\n.section-calculator-finish {\n    width: 1920px;\n    margin: -240px auto 120px auto;\n    padding: 0px 0px 0px 0px;\n}\n\n.section-calculator-finish-contant {\n    position: relative;\n    z-index: 1;\n    width: 600px;\n    margin: 0px auto 0px auto;\n    padding: 30px 30px 30px 30px;\n    border-radius: 30px;\n    background: #fff;\n}\n\n.section-calculator-finish-text {\n    font-size: 16px;\n    font-weight: 400;\n    line-height: 20px;\n    letter-spacing: 0em;\n    text-align: left;\n}\n\n.section-calculator-finish-blok-info {\n    width: 100%;\n    margin: 30px 0px 30px 0px;\n    padding: 20px 20px 20px 20px;\n    border: 2px solid #000;\n    border-radius: 10px;\n}\n\n/*\n.section-calculator-finish-blok-info-2,.section-calculator-finish-blok-info-3{\n    display: none;\n}\n*/\n.tab-body-blok-info-403 {\n    display: none;\n}\n\n.finish-blok-info-image {\n    display: flex;\n    align-items: center;\n    margin: 0px 0px 10px 0px;\n}\n\n.finish-blok-info-image img {\n    margin: 0px 10px 0px 0px;\n}\n\n.finish-blok-info-polis {}\n\n.tab-body-blok-info-401-element {\n    display: flex;\n    align-items: flex-end;\n}\n\n.section-calculator-finish-blok-info-text {\n    font-size: 11px;\n    font-weight: 400;\n    line-height: 14px;\n    letter-spacing: 0em;\n    text-align: left;\n    color: #828282;\n}\n\n.section-calculator-finish-blok-info-text-3 {\n    margin: 0px 0px 0px 10px;\n    font-size: 14px;\n    font-weight: 700;\n    line-height: 14px;\n    letter-spacing: 0em;\n    text-align: left;\n}\n\n.section-calculator-finish-blok-info-text-4 {\n    margin: 0px 0px 0px 10px;\n    font-size: 14px;\n    font-weight: 700;\n    line-height: 14px;\n    letter-spacing: 0em;\n    text-align: left;\n}\n\n.button-step-500 {\n    width: 100%;\n    opacity: 0.7;\n}\n\n@media (max-width: 1920px) {\n    .section-calculator-finish {\n        width: 100%;\n    }\n}\n\n@media (max-width: 1366px) {\n    .one-ekran-calculator-finish {\n        height: 584px;\n    }\n\n    .section-calculator-finish {\n        margin: -290px auto 120px auto;\n    }\n}\n\n@media (max-width: 1280px) {\n    .one-ekran-calculator-finish {\n        height: 584px;\n        background-image: url(../img/fon-1-main-mob.jpg);\n    }\n\n    .section-calculator-finish {\n        margin: -300px auto 100px auto;\n    }\n\n    .section-calculator-finish-contant {\n        width: 502px;\n    }\n}\n\n@media (max-width: 1080px) {\n    .one-ekran-calculator-finish {\n        height: 550px;\n    }\n}\n\n@media (max-width: 1024px) {\n    .one-ekran-calculator-finish {\n        height: 510px;\n    }\n\n    .section-calculator-finish {\n        margin: -260px auto 100px auto;\n    }\n}\n\n@media (max-width: 900px) {\n    .one-ekran-calculator-finish {\n        height: 500px;\n    }\n\n    .section-calculator-finish {\n        margin: -270px auto 100px auto;\n    }\n}\n\n@media (max-width: 899px) {\n    .one-ekran-calculator-finish {\n        height: 480px;\n    }\n\n}\n\n@media (max-width: 899px) {\n    .section-calculator-finish-contant {\n        width: 100%;\n    }\n\n    .section-calculator-finish {\n        margin: -250px auto 100px auto;\n    }\n}\n\n/***********************\n****** PAGE PRAVOINFO ********\n***************************/\n\n/***** one-ekran-pravo ******/\n.one-ekran-pravo {\n    background-image: url(../img/fon-1-pravo.jpg);\n}\n\n/********** two-ekran-pravo **********/\n.two-ekran-pravo {\n    position: relative;\n    width: 1920px;\n    margin: -200px auto 100px auto;\n    padding: 0px 0px 0px 0px;\n}\n\n.two-ekran-pravo-contant {\n    width: 100%;\n}\n\n.pravo-tab {\n    width: 100%;\n}\n\n.pravo-tab-title {\n    width: 100%;\n    padding: 0px 20px 0px 20px;\n    margin: 0px 0px 40px 0px;\n    display: flex;\n    justify-content: space-between;\n}\n\n.pravo-tab-title-item {\n    flex: 0 0 33.333%;\n}\n\n.pravo-tab-title-item-2 {\n    text-align: center;\n}\n\n.pravo-tab-title-item-3 {\n    text-align: right;\n}\n\n.pravo-tab-title-link {\n    display: inline-block;\n    width: auto;\n    font-size: 18px;\n    font-weight: 400;\n    line-height: 20px;\n    letter-spacing: 0em;\n    color: #828282;\n    padding: 0px 0px 2px 0px;\n    border-bottom: 2px solid #828282;\n    transition-duration: 0.5s;\n    cursor: pointer;\n}\n\n.pravo-tab-title-link:hover {\n    color: #000;\n    border-color: #000;\n}\n\n.pravo-tab-title-link-1 {\n    color: #000;\n    border-color: #000;\n}\n\n.pravo-tab-body {\n    width: 100%;\n    margin: 0px 0px 0px 0px;\n    padding: 40px 30px 40px 30px;\n    background: #fff;\n    border-radius: 30px;\n}\n\n.pravo-tab-body-item {\n    width: 100%;\n    display: block;\n}\n\n.pravo-tab-body-item-2 {\n    display: none;\n}\n\n.pravo-tab-body-item-3 {\n    display: none;\n}\n\n.h2-ravo {\n    text-align: left;\n}\n\n.pravo-tab-blok-text {\n    width: 100%;\n    margin: 30px 0px 0px 0px;\n}\n\n.pravo-tab-blok-text-1 {\n    margin: 0px 0px 10px 0px;\n    font-size: 16px;\n    font-weight: 400;\n    line-height: 20px;\n    letter-spacing: 0em;\n    text-align: left;\n    color: #000;\n}\n\n.pravo-tab-blok-text-2 {\n    margin: 0px 0px 20px 0px;\n    font-size: 14px;\n    font-weight: 300;\n    line-height: 17px;\n    letter-spacing: 0em;\n    text-align: left;\n    color: #828282;\n}\n\n.pravo-tab-blok-link {\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n}\n\n.pravo-tab-link {\n    margin: 0px 0px 15px 0px;\n    text-decoration: underline;\n    transition-duration: 0.5s;\n}\n\n.pravo-tab-link:hover {\n    color: #828282;\n}\n\n@media (max-width: 1920px) {\n    .two-ekran-pravo {\n        width: 100%;\n    }\n}\n\n@media (max-width: 1366px) {\n    .two-ekran-pravo {\n        margin: -270px auto 100px auto;\n    }\n}\n\n@media (max-width: 1280px) {\n    .one-ekran-pravo {\n        height: 550px;\n    }\n\n    .two-ekran-pravo {\n        margin: -270px auto 100px auto;\n    }\n}\n\n@media (max-width: 1100px) {\n    .one-ekran-pravo {\n        height: 500px;\n    }\n\n    .two-ekran-pravo {\n        margin: -250px auto 70px auto;\n    }\n}\n\n@media (max-width: 1024px) {\n    .one-ekran-pravo {\n        height: 450px;\n    }\n\n    .two-ekran-pravo {\n        margin: -230px auto 60px auto;\n    }\n}\n\n@media (max-width: 900px) {\n    .one-ekran-pravo {\n        height: 400px;\n    }\n\n    .two-ekran-pravo {\n        margin: -200px auto 60px auto;\n    }\n\n    .pravo-tab-title {\n        padding: 0px 0px 0px 0px;\n        margin: 0px 0px 20px 0px;\n    }\n}\n\n@media (max-width: 768px) {\n    .one-ekran-pravo {\n        height: 380px;\n    }\n}\n\n@media (max-width: 700px) {\n    .pravo-tab-title-link {\n        font-size: 16px;\n    }\n}\n\n@media (max-width: 600px) {\n    .pravo-tab-title-item {\n        flex: 0 0 auto;\n    }\n\n    .pravo-tab-title-link {\n        font-size: 15px;\n    }\n}\n\n@media (max-width: 500px) {\n    .two-ekran-pravo {\n        margin: -160px auto 60px auto;\n    }\n\n    .one-ekran-pravo-contant {\n        padding: 150px 0px 0px 0px;\n    }\n\n    .pravo-tab-title {\n        padding: 0px 20px 0px 20px;\n        margin: 0px 0px 20px 0px;\n    }\n}\n\n@media (max-width: 428px) {\n    .pravo-tab-title {\n        flex-direction: column;\n        align-items: flex-start;\n    }\n\n    .pravo-tab-title-item {\n        margin: 0px 0px 10px 0px;\n    }\n\n    .pravo-tab-body {\n        padding: 30px 20px 30px 20px;\n    }\n}\n\n@media (max-width: 424px) {\n    .one-ekran-pravo {\n        height: 430px;\n    }\n\n    .two-ekran-pravo {\n        margin: -170px auto 60px auto;\n    }\n}\n\n/**********************\n******** PAGE LENDING **********\n**********************/\n/****** one-ekran-lending ********/\n.one-ekran-lending {\n    background-image: url(../img/fon-1-lending.jpg);\n}\n\n.one-ekran-contant-lending {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    text-align: center;\n}\n\n.h1-lending-2 {\n    display: none;\n}\n\n.button-lending {\n    width: 460px;\n    margin: 40px 0px 0px 0px;\n}\n\n.button-lending-1,\n.button-lending-2,\n.button-lending-3 {\n    width: 100%;\n    margin: 0px 0px 0px 0px;\n}\n\n.one-ekran-contant-lending-step {\n    margin: -440px auto 0px auto;\n    padding: 30px 30px 30px 30px;\n    width: 600px;\n    height: auto;\n    z-index: 1;\n    position: relative;\n    display: none;\n    border-radius: 30px;\n    background: #fff;\n}\n\n.one-ekran-contant-text-02 {\n    display: none;\n}\n\n.one-ekran-contant-lending-step-2 {\n    display: none;\n}\n\n.one-ekran-contant-lending-step-3 {\n    display: none;\n}\n\n.lending-step-text {\n    margin: 0px 0px 20px 0px;\n    font-size: 16px;\n    font-weight: 400;\n    line-height: 20px;\n    letter-spacing: 0em;\n    text-align: left;\n    color: #000;\n}\n\n.lending-step-text-2 {\n    margin: 0px 0px 5px 0px;\n    font-size: 11px;\n    font-weight: 400;\n    line-height: 14px;\n    letter-spacing: 0em;\n    text-align: left;\n    color: #000;\n}\n\n.one-ryad-popup-user-9 {\n    height: 79px;\n    margin: 0px 0px 3px 0px;\n    border-radius: 10px 10px 0px 0px;\n}\n\n.one-ryad-popup-user-10 {\n    height: 79px;\n    margin: 0px 0px 3px 0px;\n    border-radius: 0px 0px 0px 0px;\n}\n\n.one-ryad-popup-user-11 {\n    margin: 0px 0px 3px 0px;\n    border-radius: 0px 0px 0px 0px;\n}\n\n.one-ryad-popup-user-12 {\n    margin: 0px 0px 20px 0px;\n    border-radius: 0px 0px 10px 10px;\n}\n\n.one-ryad-popup-user-15 {\n    margin: 0px 0px 3px 0px;\n    border-radius: 10px 10px 0px 0px;\n}\n\n.one-ryad-popup-user-16 {\n    margin: 0px 0px 3px 0px;\n    border-radius: 0px 0px 0px 0px;\n}\n\n.one-ryad-popup-user-17 {\n    height: 89px;\n    margin: 0px 0px 20px 0px;\n    border-radius: 0px 0px 10px 10px;\n}\n\n.pole-popup-00::placeholder {\n    color: #000000;\n    opacity: 1;\n}\n\n.lending-step-text-row {\n    margin: 0px 0px 20px 0px;\n    width: 100%;\n    display: flex;\n    justify-content: space-between;\n}\n\n.lending-step-text-item {\n    height: 79px;\n    flex: 0 0 50%;\n    cursor: pointer;\n}\n\n.lending-step-text-item-1 {\n    padding: 0px 5px 0px 0px;\n}\n\n.lending-step-text-item-2 {\n    padding: 0px 0px 0px 5px;\n}\n\n.lending-step-text-item-vnutr {\n    width: 100%;\n    height: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: 10px;\n    background: #f5f5f5;\n    border: 2px solid #f5f5f5;\n    cursor: pointer;\n}\n\n.lending-step-text-item img {\n    margin: 0px 10px 0px 0px;\n}\n\n.lending-step-text-3 {\n    font-weight: 400 !important;\n    font-size: 16px !important;\n    line-height: 20px !important;\n    color: #000000 !important;\n    display: flex;\n    align-items: center;\n}\n\n.checked-1 {\n    border: 2px solid rgb(0, 0, 0);\n}\n\n.checkbox-1-1 {\n    opacity: 0;\n}\n\n.checkbox-1-2 {\n    opacity: 0;\n}\n\n.checkbox-1-3-box {\n    position: relative;\n    display: flex;\n    padding: 0px 0px 0px 0px;\n    margin: 0px 0px 30px 0px;\n}\n\n.checkbox-1-3-box label {\n    cursor: pointer;\n    margin: 0px 0px 0px 40px;\n}\n\n.checkbox-1-3 {\n    cursor: pointer;\n    margin: 0px 20px 0px 0px;\n}\n\n.one-ryad-popup-user-13 {\n    margin: 0px 0px 3px 0px;\n    border-radius: 10px 10px 0px 0px;\n}\n\n.one-ryad-popup-user-14 {\n    margin: 0px 0px 20px 0px;\n    border-radius: 0px 0px 10px 10px;\n}\n\n@media (max-width: 1600px) {\n    .one-ekran-contant-lending-step {\n        margin: -320px auto 0px auto;\n    }\n}\n\n@media (max-width: 1366px) {\n    .one-ekran-contant-lending-step {\n        margin: -280px auto 0px auto;\n    }\n}\n\n@media (max-width: 1280px) {\n\n    .one-ekran-lending-2 {\n        background-image: url(../img/fon-2-lending-1280.jpg);\n    }\n\n    .one-ekran-lending {\n        background-image: url(../img/fon-1-lending-1280.jpg);\n    }\n\n    .one-ekran-contant-lending-step {\n        margin: -240px auto 0px auto;\n    }\n}\n\n@media (max-width: 1024px) {\n    .one-ekran-contant-lending {\n        padding: 160px 0px 0px 0px\n    }\n\n    .one-ekran-contant-lending-step {\n        margin: -170px auto 0px auto;\n    }\n}\n\n@media (max-width: 899px) {\n    .one-ekran-contant-lending {\n        padding: 180px 0px 0px 0px\n    }\n\n    .one-ekran-lending {\n        height: 500px;\n    }\n\n    .one-ekran-contant-lending-step {\n        margin: -170px auto 0px auto;\n    }\n}\n\n@media (max-width: 700px) {\n    .one-ekran-contant-lending-step {\n        width: 100%;\n    }\n}\n\n@media (max-width: 600px) {\n    .one-ekran-contant-lending-step {\n        margin: -50px auto 0px auto;\n    }\n}\n\n@media (max-width: 500px) {\n    .one-ekran-lending {\n        height: 450px;\n        margin: 20px auto 0px auto;\n        border-radius: 50px 50px 50px 50px;\n    }\n\n    .button-lending {\n        width: 100%;\n    }\n\n    .lending-step-text-row {\n        flex-direction: column;\n    }\n\n    .lending-step-text-item {\n        padding: 0px 0px 0px 0px;\n    }\n\n    .lending-step-text-item-vnutr {\n        height: 79px;\n    }\n}\n\n@media (max-width: 428px) {\n    .one-ekran-contant-lending-step {\n        padding: 30px 20px 30px 20px;\n    }\n\n    .one-ryad-popup-user-9,\n    .one-ryad-popup-user-10 {\n        height: 69px;\n    }\n\n    .lending-step-text-item-vnutr {\n        height: 69px;\n    }\n}\n\n@media (max-width: 414px) {\n    .one-ekran-contant-lending {\n        padding: 140px 0px 0px 0px;\n    }\n}\n\n@media (max-width: 375px) {\n    .one-ekran-contant-lending {\n        padding: 110px 0px 0px 0px;\n    }\n}\n\n/**********************/\n.two-ekran-lending {\n    width: 1920px;\n    padding: 120px 0px 90px 0px;\n    margin: 0px auto 0px auto;\n}\n\n.two-ekran-lending-contant {\n    width: 100%;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    flex-wrap: wrap;\n}\n\n.two-ekran-lending-contant-item {\n    flex: 0 0 20%;\n    margin: 0px 0px 30px 0px;\n}\n\n.two-ekran-lending-contant-item-1 {\n    flex: 0 0 20%;\n}\n\n.two-ekran-lending-contant-item-2 {\n    flex: 0 0 20%;\n    text-align: center;\n}\n\n.two-ekran-lending-contant-item-3 {\n    flex: 0 0 20%;\n    text-align: center;\n}\n\n.two-ekran-lending-contant-item-4 {\n    flex: 0 0 20%;\n    text-align: center;\n}\n\n.two-ekran-lending-contant-item-5 {\n    flex: 0 0 20%;\n    text-align: right;\n}\n\n.two-ekran-lending-contant-item-6 {\n    flex: 0 0 16.666%;\n}\n\n.two-ekran-lending-contant-item-7 {\n    flex: 0 0 16.666%;\n    text-align: center;\n}\n\n.two-ekran-lending-contant-item-8 {\n    flex: 0 0 16.666%;\n    text-align: center;\n}\n\n.two-ekran-lending-contant-item-9 {\n    flex: 0 0 16.666%;\n    text-align: center;\n}\n\n.two-ekran-lending-contant-item-10 {\n    flex: 0 0 16.666%;\n    text-align: center;\n}\n\n.two-ekran-lending-contant-item-11 {\n    flex: 0 0 16.666%;\n    text-align: right;\n}\n\n\n@media (max-width: 1920px) {\n    .two-ekran-lending {\n        width: 100%;\n    }\n}\n\n@media (max-width: 1280px) {\n    .two-ekran-lending {\n        padding: 100px 0px 70px 0px;\n    }\n}\n\n@media (max-width: 1100px) {\n    .two-ekran-lending {\n        padding: 80px 0px 50px 0px;\n    }\n}\n\n@media (max-width: 900px) {\n    .two-ekran-lending-contant {\n        justify-content: center;\n    }\n\n    .two-ekran-lending-contant-item-6 {\n        flex: 0 0 25%;\n    }\n\n    .two-ekran-lending-contant-item-7 {\n        flex: 0 0 25%;\n        text-align: center;\n    }\n\n    .two-ekran-lending-contant-item-8 {\n        flex: 0 0 25%;\n        text-align: center;\n    }\n\n    .two-ekran-lending-contant-item-10 {\n        flex: 0 0 25%;\n        text-align: center;\n    }\n\n    .two-ekran-lending-contant-item-11 {\n        flex: 0 0 25%;\n        text-align: right;\n    }\n}\n\n@media (max-width: 768px) {\n    .two-ekran-lending-contant-item {\n        flex: 0 0 25%;\n    }\n\n    .two-ekran-lending-contant-item-1 {}\n\n    .two-ekran-lending-contant-item-2 {\n        text-align: center;\n    }\n\n    .two-ekran-lending-contant-item-3 {\n        text-align: center;\n    }\n\n    .two-ekran-lending-contant-item-4 {\n        text-align: right;\n    }\n\n    .two-ekran-lending-contant-item-5 {\n        text-align: left;\n    }\n\n    .two-ekran-lending-contant-item-6 {\n        text-align: center;\n    }\n\n    .two-ekran-lending-contant-item-7 {\n        text-align: center;\n    }\n\n    .two-ekran-lending-contant-item-8 {\n        text-align: right;\n    }\n\n    .two-ekran-lending-contant-item-9 {\n        text-align: left;\n    }\n\n    .two-ekran-lending-contant-item-10 {\n        text-align: center;\n    }\n\n    .two-ekran-lending-contant-item-11 {\n        text-align: right;\n    }\n}\n\n@media (max-width: 600px) {\n    .two-ekran-lending-contant-item {\n        flex: 0 0 33.333%;\n    }\n\n    .two-ekran-lending-contant-item-1 {\n        text-align: left;\n    }\n\n    .two-ekran-lending-contant-item-2 {\n        text-align: center;\n    }\n\n    .two-ekran-lending-contant-item-3 {\n        text-align: center;\n    }\n\n    .two-ekran-lending-contant-item-4 {\n        text-align: left;\n    }\n\n    .two-ekran-lending-contant-item-5 {\n        text-align: center;\n    }\n\n    .two-ekran-lending-contant-item-6 {\n        text-align: center;\n    }\n\n    .two-ekran-lending-contant-item-7 {\n        text-align: left;\n    }\n\n    .two-ekran-lending-contant-item-8 {\n        text-align: center;\n    }\n\n    .two-ekran-lending-contant-item-9 {\n        text-align: center;\n    }\n\n    .two-ekran-lending-contant-item-10 {\n        text-align: left;\n    }\n\n    .two-ekran-lending-contant-item-11 {\n        text-align: right;\n    }\n}\n\n@media (max-width: 500px) {\n    .two-ekran-lending-contant-item {\n        flex: 0 0 50%;\n        text-align: center;\n    }\n}\n\n@media (max-width: 359px) {\n    .two-ekran-lending-contant-item {\n        flex: 0 0 100%;\n    }\n}\n\n/************************\n******** PAGE  INDEX-2 ***********\n************************/\n.section-calculator-finish-2 {\n    margin: -370px auto 120px auto;\n}\n\n.section-calculator-finish-2-contant {\n    width: 100%;\n    display: flex;\n    flex-direction: row;\n    padding: 0px 0px 0px 0px;\n    border-radius: 30px;\n    background: none;\n    box-sizing: border-box;\n}\n\n.section-calculator-finish-2-contant-col {\n    flex: 0 0 50%;\n}\n\n.section-calculator-finish-2-contant-col-1 {\n    padding: 0px 10px 0px 0px;\n}\n\n.section-calculator-finish-2-contant-col-2 {\n    padding: 0px 0px 0px 10px;\n}\n\n.section-calculator-finish-2-contant-col-vnutr {\n    text-align: left;\n    padding: 20px 20px 20px 20px;\n    border-radius: 30px;\n    background: #fff;\n}\n\n.section-calculator-finish-2-contant-col-vnutr-111 {\n    height: 100%;\n}\n\n.form-111 {\n    flex-direction: column;\n    margin: 0px 0px 0px 0px;\n}\n\n.form-111 .form-1-col {\n    background: #f5f5f5;\n    margin: 0px 0px 5px 0px;\n}\n\n.form-111 .dropdown__button {\n    background: #f5f5f5;\n}\n\n.form-111 .pole {\n    background: #f5f5f5;\n}\n\n.form-111 .form-1-col-1 {\n    border-radius: 10px 10px 0px 0px;\n}\n\n.form-111 .form-1-col-2 {\n    border-radius: 0px 0px 0px 0px;\n}\n\n.form-111 .form-1-col-3 {\n    border-radius: 0px 0px 10px 10px;\n    margin: 0px 0px 20px 0px;\n}\n\n.checkbox-1-111{\n    opacity: 1;\n    background: linear-gradient(0deg, rgba(255, 255, 255, 0.5), rgba(255, 255, 255, 0.5)), #FFEB39!important;\n    /* background-color: #FFEB39 */\n}\n.checkbox-1-112{\n    opacity: 0.1;\n    background: linear-gradient(0deg, rgba(255, 255, 255, 0.5), rgba(255, 255, 255, 0.5)), #FFEB39!important;\n}\n.checked-111 {\n    opacity: 0.1;\n}\n\n\n.checked-112 {\n    opacity: 1;\n}\n\n.button-111 {\n    background: #fff;\n    border: 2px solid #828282;\n    color: #828282;\n}\n\n.button-111:visited {\n    background: none;\n    border: 2px solid #828282;\n    color: #000;\n}\n\n.tab-body-blok-info-row-2-111 {\n    display: flex;\n}\n\n.tab-body-blok-info-row-2-111 .tab-body-blok-info-element {\n    flex: 0 0 50% !important;\n}\n\n.tab-body-blok-info-row-2-111 .tab-body-blok-info-element-4 {\n    padding: 0px 3px 0px 0px;\n}\n\n.tab-body-blok-info-row-2-111 .tab-body-blok-info-element-5 {\n    padding: 0px 0px 0px 3px;\n}\n\n.tab-body-blok-info-row-2-111 .tab-body-blok-info-element-5 .tab-body-blok-info-element-vnutr {\n    border-radius: 0px 10px 10px 0px;\n    height: 100%;\n}\n\n.form-1-col-111 {\n    width: 100%;\n    flex: 0 0 50% !important;\n}\n\n.checked-1111 {\n    display: flex;\n}\n\n.checked-1112 {\n    opacity: 1;\n\n}\n\n#tab-body-blok-info-401-111 {\n    margin: 20px 0px 0px 0px;\n}\n\n.block-111 {\n    display: flex;\n}\n\n.banner-text {\n    position: absolute;\n    right: 20px;\n    top: -10px;\n    background: #FFEB39;\n    text-align: center;\n    width: 120px;\n    font-size: 11px;\n    padding: 3px 0px 3px 0px;\n}\n\n.banner-text-2 {\n    background: #8a8a8a;\n    color: #fff;\n}\n\n.tab-body-blok-info-401 {\n    position: relative;\n}\n\n#tab-body-blok-info-401-112,\n#tab-body-blok-info-401-113,\n#tab-body-blok-info-401-114 {\n    border: 2px solid #828282;\n}\n\n#tab-body-4-dopinfo-link-111 {\n    display: flex;\n    margin: 30px 0px 0px 0px;\n    width: 140px;\n}\n\n#tab-body-4-dopinfo-link-112 {\n    display: block;\n    margin: 30px 0px 0px 0px;\n    width: 140px;\n}\n\n.tab-body-4-dopinfo-link-112 img {\n    transform: rotate(180deg);\n}\n\n.blok-1111 {\n    display: block;\n    flex-direction: column;\n}\n\n.block-11111 {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n}\n\n.block-11112 {\n    display: flex;\n}\n\n.tab-body-4-dopinfo-blok-link-111 {\n    width: 100%;\n    display: block;\n    justify-content: center;\n}\n\n.icon-down-arrow-401-111 {\n    transform: rotate(0deg);\n    transition: .3s;\n}\n\n#tab-body-blok-info-401-112 {\n    margin: 10px 0px 20px 0px;\n}\n\n#tab-body-blok-info-401-113 {\n    margin: 0px 0px 20px 0px;\n}\n\n.tab-body-blok-info-401-element-2-000 {\n    display: block;\n    padding: 20px 20px 30px 20px;\n\n}\n\n.tab-body-blok-info-401-element-2-111 {\n    display: block;\n    cursor: pointer;\n    position: relative;\n    /*opacity: 0.6;*/\n}\n\n#tab-body-blok-info-401-element-2-112 {\n    position: relative;\n    display: none;\n    cursor: pointer;\n}\n\n.checked-111111 {\n    display: block;\n}\n\n.plus-2 {\n    position: absolute;\n    right: 0;\n}\n\n.plus-3 {\n    position: absolute;\n    right: 0;\n}\n\n.form-1-col-1111 {\n    flex: 0 0 100%;\n    padding: 5px 20px 5px 0px;\n    margin: 0px 0px 0px 0px;\n}\n\n.form-1-col-1111 .dropdown__button {\n    color: #000;\n}\n\n/*.tab-body-blok-info-401-element-1111{\n    align-items: flex-start;\n    box-sizing: border-box;\n}*/\n\n.dropdown-111 {\n    display: flex;\n    align-items: flex-start;\n}\n\n.bank-image-2 {\n    width: 18px !important;\n}\n\n.tab-body-blok-info-401-element-1111 img {\n    width: 22px;\n    margin: 0px 10px 0px 0px;\n}\n\n.dropdown__list-111 {\n    top: 50px;\n}\n\n.img-1 {}\n\n.img-2 {\n    display: none;\n}\n\n.img-3 {\n    display: none;\n}\n\n.img-4 {\n    display: none;\n}\n\n.dropdown__list-item-111 {\n    text-align: left;\n    justify-content: flex-start;\n    align-items: center;\n}\n\n.dropdown__list-item-111 span {\n    margin: 4px 0px 0px 10px;\n    color: #828282;\n}\n\n.dropdown__button-111 span {\n    color: #828282;\n    font-size: 11px;\n}\n\n.tab-body-blok-info-animation-text-111 {\n    margin: 100px 0px 0px 0px;\n    padding: 20px 20px 20px 35px;\n    border: 2px solid #ccc;\n    background-position: 5px center;\n    border-radius: 20px;\n}\n\n.tab-body-blok-info-animation-text-2-1111 {\n    margin: 10px 0px 0px 0px;\n}\n\n.tab-body-4-blok-price-111 {\n    width: auto;\n    font-size: 13px;\n    margin: 0px 0px -15px auto;\n}\n\n.tab-body-blok-info-animation-111 {\n    justify-content: space-between;\n    height: 100%;\n    padding: 120px 0px 0px 0px;\n}\n\n@media (max-width: 1366px) {\n    .section-calculator-finish-2 {\n        margin: -300px auto 120px auto;\n    }\n\n    .tab-body-blok-info-row-2-111 .tab-body-blok-info-element {\n        flex: 0 0 100% !important;\n    }\n\n    .tab-body-blok-info-row-2-111 .tab-body-blok-info-element-4 {\n        padding: 0px 0px 0px 0px;\n        margin: 0px 0px 5px 0px;\n    }\n\n    .tab-body-blok-info-element-4-111 .tab-body-blok-info-element-vnutr {\n        border-radius: 10px 10px 0px 0px;\n    }\n\n    .tab-body-blok-info-element-5-111 .form-1-col-111 .tab-body-blok-info-element-vnutr {\n        border-radius: 0px 0px 10px 10px;\n    }\n\n    .tab-body-blok-info-row-2-111 .tab-body-blok-info-element-5 {\n        padding: 0px 0px 0px 0px;\n    }\n}\n\n@media (max-width: 1280px) {\n    .section-calculator-finish-2 {\n        margin: -250px auto 80px auto;\n    }\n}\n\n@media (max-width: 1024px) {\n    .lending-step-text-row-111 {\n        flex-wrap: wrap;\n    }\n\n    .lending-step-text-row-111 .lending-step-text-item {\n        flex: 0 0 100%;\n        margin: 0px 0px 5px 0px;\n        padding: 0px 0px 0px 0px;\n    }\n}\n\n@media (max-width: 899px) {\n    .section-calculator-finish-2-111 {\n        margin: -300px auto 100px auto;\n    }\n\n    .lending-step-text-row-111 {\n        flex-wrap: wrap;\n        flex-direction: column;\n        margin-top: 170px;\n        box-sizing: border-box;\n    }\n\n    .lending-step-text-row-111 .lending-step-text-item {\n        height: 79px;\n        margin: 0px 0px 0px 0px;\n    }\n\n    .lending-step-text-row-111 .lending-step-text-item-1 {\n        height: 79px;\n        margin: 0px 0px 5px 0px;\n    }\n\n    .section-calculator-finish-2-contant-col-1 {\n        padding: 0px 2px 0px 0px;\n    }\n\n    .section-calculator-finish-2-contant-col-2 {\n        padding: 0px 0px 0px 2px;\n    }\n\n    .section-calculator-finish-2-contant-col {\n        flex: 0 0 50%;\n    }\n\n    .form-111 {\n        width: 100%;\n    }\n}\n\n@media (max-width: 830px) {\n    .section-calculator-finish-2-contant-111 {\n        flex-direction: column;\n    }\n\n    .section-calculator-finish-2-contant-col-1 {\n        padding: 0px 0px 0px 0px;\n    }\n\n    .section-calculator-finish-2-contant-col-2 {\n        padding: 0px 0px 0px 0px;\n        margin: 30px 0px 0px 0px;\n    }\n}\n\n@media (max-width: 500px) {\n    .section-calculator-finish-2-contant-col-1 .section-calculator-finish-2-contant-col-vnutr {\n        padding: 20px 20px 20px 20px;\n    }\n\n    .lending-step-text-row-111 {\n        margin-top: 0px;\n    }\n\n    .form-111 {\n        padding: 0px 0px 0px 0px;\n    }\n}\n\n\n/* srg */\n.addr_sugg {\n    width: 100%;\n}\n\n.btn_calc_active {\n    opacity: 0 !important;\n}\n\n.button-novostroiki-2 {\n    background: #fff59c;\n    width: 450px;\n}\n\n.policy_card:nth-child(n + 2) {\n    margin-top: 20px;\n}\n\n.cntr_iframe {\n    position: absolute;\n    z-index: 10;\n    top: 0;\n    left: 0;\n    background-color: #fff;\n}\n\n.container-pay {\n    padding-left: 20vw;\n    padding-top: 10vh;\n    width: 60vw;\n}\n\n.iframe_pay {\n    width: 100vw;\n    height: 100vh;\n}\n\n.redBorder {\n    border: 1px solid rgba(255, 0, 0, 0.4);\n    box-sizing: border-box;\n}\n\n.txt_a_l {\n    text-align: left;\n}\n\n.w_100 {\n    width: 100%;\n}\n\n.popup_question {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n\n    margin: 20px auto 20px auto;\n    width: 390px;\n    height: auto;\n    padding: 20px;\n    background: #fff;\n    border: 0px solid #92B96A;\n    border-radius: 30px;\n    box-shadow: 0px 0px 10px #000;\n    z-index: 1007;\n}\n\n.p-r {\n    position: relative;\n}\n\n.cur-p {\n    cursor: pointer;\n}\n\n.over_scroll_x {\n    overflow-y: scroll;\n}\n\n.mt-10 {\n    margin-top: 10px;\n}\n\n.txt_nowrap {\n    white-space: nowrap;\n}\n\n.z-i {\n    z-index: 1000;\n}\n\n@media (max-width: 768px) {\n    .cntr_btn_repeat_sms_desk {\n        display: none;\n    }\n\n    .txt_send_sms {\n        font-family: 'Geologica';\n        font-style: normal;\n        font-weight: 400;\n        font-size: 11px;\n        /*color: #828282;*/\n        color: #000;\n        position: relative;\n    }\n\n    .cntr_btn_repeat_sms_mobil {\n        margin-bottom: 10px;\n    }\n}\n\n@media (min-width: 768px) {\n    .txt_send_sms {\n        font-family: 'Geologica';\n        font-style: normal;\n        font-weight: 400;\n        font-size: 11px;\n        /*color: #828282;*/\n        color: #000;\n        position: absolute;\n        bottom: -20px;\n        left: 50%;\n        transform: translateX(-50%);\n    }\n\n    .cntr_btn_repeat_sms_mobil {\n        display: none;\n    }\n}\n\n.t_a_l {\n    text-align: left;\n}\n\n.p-10 {\n    padding: 10px !important;\n}\n\n\n.tab-body-blok-info-animation-text-25 {\n    background-image: url(../img/Info-2green.svg);\n}\n\n@-moz-document url-prefix() {\n    @media (max-width: 1680px) {\n        .tab-body-blok-info-row-2 .tab-body-blok-info-element {\n            flex: 0 0 33.333%;\n        }\n    }\n}\n\n.cntr_discount {\n    display: flex;\n\n}\n\n.btn_table_delete {\n    border: none;\n    border-radius: 4px;\n    padding: 3px;\n    background: #4f4f4f;\n    color: #fff;\n    font-size: 14px;\n}\n\n.btn_table_delete:hover {\n    box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.2);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
